import { useState, useEffect, useCallback } from 'react';

import {
    ChevronRight,
    Menu,
    X,
    Star,
    ArrowRight,
    Check,
    Layers,
    Box,
    Users,
    TrendingUp,
    Briefcase,
    Home,
    Settings,
    BookOpen,
    Search,
    Plus,
    Trash2
} from 'lucide-react';


import { initializeApp } from 'firebase/app';
import {
    getFirestore,
    getDocs,
    collection,
    setDoc,
    doc,
    deleteDoc
} from 'firebase/firestore';


/* ================= FIREBASE CONFIG ================= */

const firebaseConfig = {
  apiKey: "AIzaSy8XnMJKDAjZkHOZgu4YpsBGwrG6XrJwJw8",
  authDomain: "momentum-design-system.firebaseapp.com",
  projectId: "momentum-design-system",
  storageBucket: "momentum-design-system.firebasestorage.app",
  messagingSenderId: "300268074020",
  appId: "1:300268074020:web:f3a914cdbbf1e3aba154b1"
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

/* ================= MAIN COMPONENT ================= */


// Main App Component
export default function DesignSystemDocs() {
  const [activeSection, setActiveSection] = useState('introduction');
  const [activeTab, setActiveTab] = useState('overview');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [teamMembers, setTeamMembers] = useState([
    { id: 1, name: 'Lobna Elturkey', role: 'UI/UX Designer', image: 'data:image/jpeg;base64,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', linkedin: 'https://www.linkedin.com/in/lobna-elturkey-1122aa1a1/' },
    { id: 2, name: 'Wedad Awad', role: 'UI/UX Designer', image: 'data:image/jpeg;base64,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', linkedin: 'https://www.linkedin.com/in/wedad-awad/' },
    { id: 3, name: 'Ameera Hamada', role: 'UI/UX Designer', badge: 'Team Leader', image: 'data:image/jpeg;base64,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', linkedin: 'https://www.linkedin.com/in/ameerahamada/' },
    { id: 4, name: 'Nihal Omar', role: 'UI/UX Designer', image: 'data:image/webp;base64,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', linkedin: 'https://www.linkedin.com/in/nihal-omar-151538171/' },
      { id: 5, name: 'Magdy Saad', role: 'UI/UX Designer', image: 'data:image/jpeg;base64,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', linkedin: 'https://www.linkedin.com/in/magdy-saad-80025236b/' },
    { id: 6, name: 'Dimah Alshammari', role: 'UI/UX Designer', image: 'data:image/jpeg;base64,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', linkedin: 'https://www.linkedin.com/in/dimah-alshammari-158676262/' },
      { id: 7, name: 'Asia Elbastawesy', role: 'UI/UX Designer', image: 'data:image/jpeg;base64,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', linkedin: 'https://www.linkedin.com/in/asia-e-62390b2a6/' },
    { id: 8, name: 'Mona Almenshawi', role: 'UI/UX Designer', image: 'data:image/jpeg;base64,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', linkedin: 'https://www.linkedin.com/in/mona-almenshawi/' },
    { id: 9, name: 'Eman Gamal', role: 'UI/UX Designer', image: null, linkedin: '' },
    { id: 10, name: 'Mahmoud Damer', role: 'UI/UX Designer', image: 'data:image/jpeg;base64,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', linkedin: 'https://www.linkedin.com/in/mdamer/' },
  ]);

  // Search data
  const searchData = [
    { id: 'introduction', title: 'Introduction', category: 'Getting Started', tab: '', keywords: 'welcome start getting started overview guide momentum design system' },
    { id: 'colors', title: 'Colors', category: 'Foundations', tab: '', keywords: 'color palette tokens semantic primitive background text border' },
    { id: 'colors', title: 'Colors - Overview', category: 'Foundations', tab: 'overview', keywords: 'color system palette introduction' },
    { id: 'colors', title: 'Colors - Primitive Colors', category: 'Foundations', tab: 'examples', keywords: 'base colors white black gray tones' },
    { id: 'colors', title: 'Colors - Semantic Colors', category: 'Foundations', tab: 'anatomy', keywords: 'light dark mode background text border status' },
    { id: 'colors', title: 'Colors - Component Colors', category: 'Foundations', tab: 'props', keywords: 'component specific colors tokens' },
    { id: 'typography', title: 'Typography', category: 'Foundations', tab: '', keywords: 'fonts text styles inter outfit headings body labels' },
    { id: 'spacing', title: 'Spacing', category: 'Foundations', tab: '', keywords: 'spacing scale margin padding layout semantic primitive' },
    { id: 'team', title: 'Team Behind the Core', category: 'About', tab: '', keywords: 'team members designers contributors about' },
    { id: 'dev-handoff', title: 'Developer Handoff', category: 'Resources', tab: '', keywords: 'developer code tokens export implementation' },
    { id: 'list-item', title: 'List Item', category: 'Components', tab: 'overview', keywords: 'avatar profile user rating' },
    { id: 'list-item', title: 'List Item - Overview', category: 'Components', tab: 'overview', keywords: 'preview features' },
    { id: 'list-item', title: 'List Item - Examples', category: 'Components', tab: 'examples', keywords: 'variants demo samples' },
    { id: 'list-item', title: 'List Item - Anatomy', category: 'Components', tab: 'anatomy', keywords: 'structure layout spacing' },
    { id: 'list-item', title: 'List Item - Props', category: 'Components', tab: 'props', keywords: 'properties api tokens' },
    { id: 'list-item', title: 'List Item - Best Practices', category: 'Components', tab: 'best-practices', keywords: 'do dont guidelines' },
    { id: 'list-item', title: 'List Item - Accessibility', category: 'Components', tab: 'accessibility', keywords: 'a11y aria screen reader' },
    { id: 'stock-card', title: 'Stock Card', category: 'Components', tab: 'overview', keywords: 'price market trading finance' },
    { id: 'stock-card', title: 'Stock Card - Overview', category: 'Components', tab: 'overview', keywords: 'preview features' },
    { id: 'stock-card', title: 'Stock Card - Examples', category: 'Components', tab: 'examples', keywords: 'positive negative variants' },
    { id: 'stock-card', title: 'Stock Card - Anatomy', category: 'Components', tab: 'anatomy', keywords: 'structure logo badge' },
    { id: 'stock-card', title: 'Stock Card - Props', category: 'Components', tab: 'props', keywords: 'properties api tokens' },
    { id: 'stock-card', title: 'Stock Card - Best Practices', category: 'Components', tab: 'best-practices', keywords: 'do dont guidelines' },
    { id: 'stock-card', title: 'Stock Card - Accessibility', category: 'Components', tab: 'accessibility', keywords: 'a11y aria' },
    { id: 'navigation-bar', title: 'Navigation Bar', category: 'Components', tab: 'overview', keywords: 'nav menu tabs bottom' },
    { id: 'navigation-bar', title: 'Navigation Bar - Overview', category: 'Components', tab: 'overview', keywords: 'preview 3 4 5 tabs' },
    { id: 'navigation-bar', title: 'Navigation Bar - Examples', category: 'Components', tab: 'examples', keywords: 'variants icons labels' },
    { id: 'navigation-bar', title: 'Navigation Bar - Anatomy', category: 'Components', tab: 'anatomy', keywords: 'structure container spacing' },
    { id: 'navigation-bar', title: 'Navigation Bar - Props', category: 'Components', tab: 'props', keywords: 'properties api tokens' },
    { id: 'navigation-bar', title: 'Navigation Bar - Best Practices', category: 'Components', tab: 'best-practices', keywords: 'do dont guidelines' },
    { id: 'navigation-bar', title: 'Navigation Bar - Accessibility', category: 'Components', tab: 'accessibility', keywords: 'a11y aria keyboard' },
    { id: 'button', title: 'Button', category: 'Components', tab: 'overview', keywords: 'primary secondary tertiary link action' },
    { id: 'button', title: 'Button - Overview', category: 'Components', tab: 'overview', keywords: 'preview hierarchy variants' },
    { id: 'button', title: 'Button - Examples', category: 'Components', tab: 'examples', keywords: 'sizes icons disabled fullwidth' },
    { id: 'button', title: 'Button - Anatomy', category: 'Components', tab: 'anatomy', keywords: 'structure container label icon' },
    { id: 'button', title: 'Button - Props', category: 'Components', tab: 'props', keywords: 'properties api tokens colors' },
    { id: 'button', title: 'Button - Best Practices', category: 'Components', tab: 'best-practices', keywords: 'do dont guidelines hierarchy' },
    { id: 'button', title: 'Button - Accessibility', category: 'Components', tab: 'accessibility', keywords: 'a11y aria keyboard contrast' },
  ];

  const filteredResults = searchQuery.length > 0 
    ? searchData.filter(item => 
        item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (item.keywords && item.keywords.toLowerCase().includes(searchQuery.toLowerCase()))
      )
    : [];

  const handleSelectResult = (item) => {
    setActiveSection(item.id);
    if (item.tab) {
      setActiveTab(item.tab);
    }
    setSearchQuery('');
    setSearchOpen(false);
  };

  const getTabs = () => {
    if (activeSection === 'colors') {
      return [
        { id: 'overview', label: 'Overview' },
        { id: 'examples', label: 'Primitive Colors' },
        { id: 'anatomy', label: 'Semantic Colors' },
        { id: 'props', label: 'Component Colors' },
      ];
    }
    return [
      { id: 'overview', label: 'Overview' },
      { id: 'examples', label: 'Examples' },
      { id: 'anatomy', label: 'Anatomy' },
      { id: 'props', label: 'Props' },
      { id: 'best-practices', label: 'Best Practices' },
      { id: 'accessibility', label: 'Accessibility' },
    ];
  };

  const tabs = getTabs();

  const getPageTitle = () => {
    const titles = {
      'introduction': 'Introduction',
      'colors': 'Colors',
      'typography': 'Typography',
      'spacing': 'Spacing',
      'list-item': 'List Item',
      'stock-card': 'Stock Card',
      'navigation-bar': 'Navigation Bar',
      'button': 'Button',
      'team': 'Team Behind the Core',
      'dev-handoff': 'Developer Handoff',
    };
    return titles[activeSection] || activeSection;
  };

  const getPageDesc = () => {
    const descs = {
      'introduction': 'Welcome to the Momentum Design System. A comprehensive guide to building consistent, accessible, and beautiful user interfaces.',
      'colors': 'Color palette and guidelines for the Momentum Design System.',
      'typography': 'Typography system including fonts, sizes, and text styles.',
      'spacing': 'Spacing scale and layout guidelines for consistent spacing.',
      'list-item': 'List items display user profiles, portfolio managers, or content in a vertical list format with optional metadata like ratings, prices, and performance indicators.',
      'stock-card': 'Stock cards display essential stock information including company details, current price, percentage change, and market indicators in a compact, scannable format.',
      'navigation-bar': 'Bottom navigation bar for primary app navigation with icon and label support.',
      'button': 'Buttons trigger actions and guide users through their journey with clear visual hierarchy.',
    };
    return descs[activeSection] || '';
  };

  const getPageCategory = () => {
    if (activeSection === 'introduction') return 'Getting Started';
    if (activeSection === 'colors' || activeSection === 'typography' || activeSection === 'spacing' || activeSection === 'dev-handoff') return 'Foundations';
    if (activeSection === 'team') return 'About';
    return 'Components';
  };

  const showTabs = activeSection !== 'introduction' && activeSection !== 'typography' && activeSection !== 'spacing' && activeSection !== 'team' && activeSection !== 'dev-handoff';

  return (
    <div className="min-h-screen text-gray-100 flex relative overflow-hidden" style={{ background: 'linear-gradient(to bottom, #0a0e27 0%, #1a1f3a 50%, #0a0e27 100%)' }}>
      {/* Animated Stars Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Layer 1: Small stars */}
        <div 
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(2px 2px at 20% 30%, white, transparent),
              radial-gradient(2px 2px at 60% 70%, white, transparent),
              radial-gradient(1px 1px at 50% 50%, white, transparent),
              radial-gradient(1px 1px at 80% 10%, white, transparent),
              radial-gradient(2px 2px at 90% 60%, white, transparent),
              radial-gradient(1px 1px at 33% 80%, white, transparent),
              radial-gradient(1px 1px at 15% 90%, white, transparent),
              radial-gradient(2px 2px at 75% 25%, white, transparent),
              radial-gradient(1px 1px at 45% 15%, white, transparent),
              radial-gradient(1px 1px at 95% 85%, white, transparent)
            `,
            backgroundSize: '200px 200px, 300px 300px, 250px 250px, 280px 280px, 220px 220px, 240px 240px, 260px 260px, 290px 290px, 210px 210px, 270px 270px',
            animation: 'twinkle 3s ease-in-out infinite alternate'
          }}
        />
        
        {/* Layer 2: Medium stars */}
        <div 
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(1.5px 1.5px at 10% 20%, rgba(147, 197, 253, 0.8), transparent),
              radial-gradient(1.5px 1.5px at 70% 40%, rgba(167, 139, 250, 0.8), transparent),
              radial-gradient(1.5px 1.5px at 40% 60%, rgba(252, 211, 77, 0.8), transparent),
              radial-gradient(1.5px 1.5px at 85% 75%, rgba(147, 197, 253, 0.8), transparent),
              radial-gradient(1.5px 1.5px at 25% 85%, rgba(167, 139, 250, 0.8), transparent),
              radial-gradient(1.5px 1.5px at 55% 25%, rgba(252, 211, 77, 0.8), transparent)
            `,
            backgroundSize: '350px 350px, 400px 400px, 380px 380px, 420px 420px, 360px 360px, 390px 390px',
            animation: 'twinkle 4s ease-in-out infinite alternate-reverse'
          }}
        />
        
        {/* Layer 3: Bright stars with glow */}
        <div 
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(circle, rgba(255, 255, 255, 0.9) 0%, transparent 2px) 30% 20% / 600px 600px,
              radial-gradient(circle, rgba(147, 197, 253, 0.8) 0%, transparent 2px) 70% 60% / 700px 700px,
              radial-gradient(circle, rgba(252, 211, 77, 0.8) 0%, transparent 2px) 85% 35% / 650px 650px,
              radial-gradient(circle, rgba(167, 139, 250, 0.8) 0%, transparent 2px) 15% 75% / 680px 680px
            `,
            backgroundRepeat: 'no-repeat',
            animation: 'glow 5s ease-in-out infinite alternate'
          }}
        />
      </div>

      <style jsx>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.7; }
          50% { opacity: 1; }
        }
        @keyframes glow {
          0%, 100% { 
            opacity: 0.6;
            filter: blur(0px);
          }
          50% { 
            opacity: 1;
            filter: blur(0.5px);
          }
        }
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes scaleIn {
          0% {
            transform: scale(0.95);
          }
          50% {
            transform: scale(1.02);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes rotateIcon {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        @keyframes pulse {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.4);
          }
          50% {
            box-shadow: 0 0 0 6px rgba(20, 184, 166, 0);
          }
        }
        .glass-card {
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
        }
        .stagger-item {
          animation: fadeInUp 0.6s ease-out backwards;
        }
        .smooth-hover {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .smooth-hover:hover {
          transform: translateY(-4px);
        }
        .btn-scale {
          transition: transform 0.15s ease;
        }
        .btn-scale:active {
          transform: scale(0.95);
        }
        .icon-rotate:hover {
          animation: rotateIcon 0.6s ease;
        }
        .nav-item {
          animation: slideInLeft 0.4s ease-out backwards;
        }
        .nav-item:hover .nav-icon {
          transform: scale(1.1);
        }
        .nav-icon {
          transition: transform 0.2s ease;
        }
        .active-nav-pulse {
          animation: pulse 2s infinite;
        }
        .team-card {
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .team-card:hover {
          transform: translateY(-8px) scale(1.03);
        }
        .team-card:hover .team-card-border {
          box-shadow: 0 20px 40px rgba(20, 184, 166, 0.3), 0 0 20px rgba(20, 184, 166, 0.2);
        }
        .team-card-border {
          transition: box-shadow 0.4s ease;
        }
      `}</style>

      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-0'} transition-all duration-300 border-r flex-shrink-0 overflow-hidden relative z-10`} style={{ backgroundColor: 'rgba(10, 14, 39, 0.8)', backdropFilter: 'blur(10px)', borderColor: 'rgba(147, 197, 253, 0.1)' }}>
        <div className="p-4 border-b" style={{ borderColor: 'rgba(147, 197, 253, 0.1)' }}>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-purple-500 rounded-lg flex items-center justify-center" style={{ boxShadow: '0 0 20px rgba(20, 184, 166, 0.3), 0 0 15px rgba(168, 85, 247, 0.2)' }}>
              <Layers className="w-5 h-5 text-white" />
            </div>
            <span className="font-semibold text-lg">Momentum Design System</span>
          </div>
        </div>

        {/* Search Bar */}
        <div className="p-3">
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 icon-rotate" />
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setSearchOpen(true);
              }}
              onFocus={() => setSearchOpen(true)}
              className="w-full border rounded-lg pl-9 pr-3 py-2 text-sm focus:outline-none focus:border-teal-500 placeholder-gray-500"
              style={{ 
                backgroundColor: 'rgba(26, 31, 58, 0.6)', 
                borderColor: 'rgba(147, 197, 253, 0.2)',
                color: '#e5e7eb'
              }}
            />
            
            {searchOpen && searchQuery.length > 0 && (
              <div className="absolute left-0 right-0 top-full mt-1 rounded-lg shadow-xl z-50 max-h-64 overflow-y-auto" style={{ backgroundColor: 'rgba(26, 31, 58, 0.95)', backdropFilter: 'blur(10px)', border: '1px solid rgba(147, 197, 253, 0.2)' }}>
                {filteredResults.length > 0 ? (
                  filteredResults.map((item, index) => (
                    <button
                      key={`${item.id}-${item.tab}-${index}`}
                      onClick={() => handleSelectResult(item)}
                      className="w-full text-left px-3 py-2 text-sm last:border-0"
                      style={{ 
                        borderBottom: '1px solid rgba(147, 197, 253, 0.1)',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(147, 197, 253, 0.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }}
                    >
                      <div className="font-medium text-gray-200">{item.title}</div>
                      <div className="text-xs text-gray-500">{item.category}{item.tab ? ` → ${item.tab.replace('-', ' ')}` : ''}</div>
                    </button>
                  ))
                ) : (
                  <div className="px-3 py-2 text-sm text-gray-500">No results found</div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Navigation */}
        <nav className="p-2 space-y-3 overflow-y-auto h-[calc(100vh-140px)]">
          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-2">
              Getting Started
            </h3>
            <ul className="space-y-1">
              <li className="nav-item" style={{ animationDelay: '0.05s' }}>
                <button
                  onClick={() => { setActiveSection('introduction'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'introduction'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <BookOpen className="w-5 h-5 nav-icon" />
                  Introduction
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-2">
              Foundations
            </h3>
            <ul className="space-y-1">
              <li className="nav-item" style={{ animationDelay: '0.1s' }}>
                <button
                  onClick={() => { setActiveSection('colors'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'colors'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <svg className="w-5 h-5 nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 2a10 10 0 0 0 0 20"/>
                  </svg>
                  Colors
                </button>
              </li>
              <li className="nav-item" style={{ animationDelay: '0.15s' }}>
                <button
                  onClick={() => { setActiveSection('typography'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'typography'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <svg className="w-5 h-5 nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 7V4h16v3M9 20h6M12 4v16"/>
                  </svg>
                  Typography
                </button>
              </li>
              <li className="nav-item" style={{ animationDelay: '0.2s' }}>
                <button
                  onClick={() => { setActiveSection('spacing'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'spacing'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <svg className="w-5 h-5 nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <path d="M3 9h18M3 15h18M9 3v18M15 3v18"/>
                  </svg>
                  Spacing
                </button>
              </li>
              <li className="nav-item" style={{ animationDelay: '0.25s' }}>
                <button
                  onClick={() => { setActiveSection('dev-handoff'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'dev-handoff'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <svg className="w-5 h-5 nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="16 18 22 12 16 6"/>
                    <polyline points="8 6 2 12 8 18"/>
                  </svg>
                  Developer Handoff
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-2">
              Components
            </h3>
            <ul className="space-y-1">
              <li className="nav-item" style={{ animationDelay: '0.25s' }}>
                <button
                  onClick={() => { setActiveSection('list-item'); setActiveTab('overview'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'list-item'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <Layers className="w-5 h-5 nav-icon" />
                  List Item
                </button>
              </li>
              <li className="nav-item" style={{ animationDelay: '0.3s' }}>
                <button
                  onClick={() => { setActiveSection('navigation-bar'); setActiveTab('overview'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'navigation-bar'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <Menu className="w-5 h-5 nav-icon" />
                  Navigation Bar
                </button>
              </li>
              <li className="nav-item" style={{ animationDelay: '0.35s' }}>
                <button
                  onClick={() => { setActiveSection('stock-card'); setActiveTab('overview'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'stock-card'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <TrendingUp className="w-5 h-5 nav-icon" />
                  Stock Card
                </button>
              </li>
              <li className="nav-item" style={{ animationDelay: '0.4s' }}>
                <button
                  onClick={() => { setActiveSection('button'); setActiveTab('overview'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'button'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <Box className="w-5 h-5 nav-icon" />
                  Button
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-2">
              About
            </h3>
            <ul className="space-y-1">
              <li className="nav-item" style={{ animationDelay: '0.45s' }}>
                <button
                  onClick={() => { setActiveSection('team'); }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    activeSection === 'team'
                      ? 'bg-teal-500/20 text-teal-400 border-l-2 border-teal-500 active-nav-pulse'
                      : 'text-gray-400 hover:bg-blue-900/20 hover:text-gray-200'
                  }`}
                >
                  <Users className="w-5 h-5 nav-icon" />
                  Team Behind the Core
                </button>
              </li>
            </ul>
          </div>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <header className="sticky top-0 z-10 backdrop-blur border-b px-5 py-2.5" style={{ backgroundColor: 'rgba(10, 14, 39, 0.8)', borderColor: 'rgba(147, 197, 253, 0.1)' }}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="p-2 hover:bg-blue-900/20 rounded-lg btn-scale"
              >
                {sidebarOpen ? <X className="w-5 h-5 icon-rotate" /> : <Menu className="w-5 h-5 icon-rotate" />}
              </button>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <span>{getPageCategory()}</span>
                <ChevronRight className="w-4 h-4" />
                <span className="text-white">{getPageTitle()}</span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs bg-teal-500/20 text-teal-400 px-2 py-1 rounded">v1.0.0</span>
            </div>
          </div>
        </header>
        <div className="pl-6 pr-4 py-4">
          {activeSection !== 'list-item' && activeSection !== 'stock-card' && activeSection !== 'navigation-bar' && activeSection !== 'button' && activeSection !== 'colors' && activeSection !== 'typography' && activeSection !== 'spacing' && activeSection !== 'team' && activeSection !== 'dev-handoff' && (
            <div className={`mb-5 ${activeSection === 'introduction' ? 'max-w-5xl mx-auto' : ''}`}>
              <h1 className="text-4xl font-bold mb-1">{getPageTitle()}</h1>
              <p className="text-gray-400 text-lg">{getPageDesc()}</p>
            </div>
          )}

          {activeSection === 'list-item' && (
            <div className="mb-5 max-w-5xl mx-auto">
              <h1 className="text-4xl font-bold mb-4">List Item</h1>
              <p className="text-gray-400 text-lg mb-6">
                List items display user profiles, portfolio managers, or content in a vertical list format with optional metadata like ratings, prices, and performance indicators.
              </p>
            </div>
          )}

          {activeSection === 'stock-card' && (
            <div className="mb-5 max-w-5xl mx-auto">
              <h1 className="text-4xl font-bold mb-4">Stock Card</h1>
              <p className="text-gray-400 text-lg mb-6">
                Stock cards display essential stock information including company details, current price, percentage change, and market indicators in a compact, scannable format.
              </p>
            </div>
          )}

          {activeSection === 'navigation-bar' && (
            <div className="mb-5 max-w-5xl mx-auto">
              <h1 className="text-4xl font-bold mb-4">Navigation Bar</h1>
              <p className="text-gray-400 text-lg mb-6">
                Bottom navigation bar for primary app navigation with icon and label support.
              </p>
            </div>
          )}

          {activeSection === 'button' && (
            <div className="mb-5 max-w-5xl mx-auto">
              <h1 className="text-4xl font-bold mb-4">Button</h1>
              <p className="text-gray-400 text-lg mb-6">
                Buttons trigger actions and guide users through their journey with clear visual hierarchy.
              </p>
            </div>
          )}

          {activeSection === 'colors' && (
            <div className="mb-5 max-w-5xl mx-auto">
              <h1 className="text-4xl font-bold mb-4">Colors</h1>
              <p className="text-gray-400 text-lg mb-6">
                Color palette and guidelines for the Momentum Design System.
              </p>
            </div>
          )}

          {activeSection === 'typography' && (
            <div className="mb-5 max-w-5xl mx-auto">
              <h1 className="text-4xl font-bold mb-4">Typography</h1>
              <p className="text-gray-400 text-lg mb-6">
                Typography system including fonts, sizes, and text styles.
              </p>
            </div>
          )}

          {activeSection === 'spacing' && (
            <div className="mb-5 max-w-5xl mx-auto">
              <h1 className="text-4xl font-bold mb-4">Spacing</h1>
              <p className="text-gray-400 text-lg mb-6">
                Spacing scale and layout guidelines for consistent spacing.
              </p>
            </div>
          )}

          {showTabs && (
            <div className="border-b border-blue-900/30 mb-4 max-w-5xl mx-auto">
              <nav className="flex gap-1">
                {tabs.map((tab) => {
                  // Icons for all tabs
                  const getTabIcon = () => {
                    if (tab.id === 'overview') {
                      return (
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      );
                    }
                    if (tab.id === 'examples') {
                      return (
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                        </svg>
                      );
                    }
                    if (tab.id === 'anatomy') {
                      return (
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                        </svg>
                      );
                    }
                    if (tab.id === 'props') {
                      return (
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                        </svg>
                      );
                    }
                    if (tab.id === 'best-practices') {
                      return (
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      );
                    }
                    if (tab.id === 'accessibility') {
                      return (
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      );
                    }
                    return null;
                  };

                  // Component-specific colors
                  const getComponentColors = () => {
                    if (activeSection === 'colors') {
                      return {
                        overview: { text: 'text-blue-400', bg: 'bg-blue-500/10', border: 'bg-blue-500' },
                        examples: { text: 'text-teal-400', bg: 'bg-teal-500/10', border: 'bg-teal-500' },
                        anatomy: { text: 'text-purple-400', bg: 'bg-purple-500/10', border: 'bg-purple-500' },
                        props: { text: 'text-orange-400', bg: 'bg-orange-500/10', border: 'bg-orange-500' }
                      };
                    }
                    if (activeSection === 'list-item') {
                      return {
                        overview: { text: 'text-emerald-400', bg: 'bg-emerald-500/10', border: 'bg-emerald-500' },
                        examples: { text: 'text-green-400', bg: 'bg-green-500/10', border: 'bg-green-500' },
                        anatomy: { text: 'text-lime-400', bg: 'bg-lime-500/10', border: 'bg-lime-500' },
                        props: { text: 'text-teal-400', bg: 'bg-teal-500/10', border: 'bg-teal-500' },
                        'best-practices': { text: 'text-cyan-400', bg: 'bg-cyan-500/10', border: 'bg-cyan-500' },
                        accessibility: { text: 'text-sky-400', bg: 'bg-sky-500/10', border: 'bg-sky-500' }
                      };
                    }
                    if (activeSection === 'stock-card') {
                      return {
                        overview: { text: 'text-blue-400', bg: 'bg-blue-500/10', border: 'bg-blue-500' },
                        examples: { text: 'text-indigo-400', bg: 'bg-indigo-500/10', border: 'bg-indigo-500' },
                        anatomy: { text: 'text-violet-400', bg: 'bg-violet-500/10', border: 'bg-violet-500' },
                        props: { text: 'text-purple-400', bg: 'bg-purple-500/10', border: 'bg-purple-500' },
                        'best-practices': { text: 'text-fuchsia-400', bg: 'bg-fuchsia-500/10', border: 'bg-fuchsia-500' },
                        accessibility: { text: 'text-pink-400', bg: 'bg-pink-500/10', border: 'bg-pink-500' }
                      };
                    }
                    if (activeSection === 'navigation-bar') {
                      return {
                        overview: { text: 'text-purple-400', bg: 'bg-purple-500/10', border: 'bg-purple-500' },
                        examples: { text: 'text-violet-400', bg: 'bg-violet-500/10', border: 'bg-violet-500' },
                        anatomy: { text: 'text-fuchsia-400', bg: 'bg-fuchsia-500/10', border: 'bg-fuchsia-500' },
                        props: { text: 'text-pink-400', bg: 'bg-pink-500/10', border: 'bg-pink-500' },
                        'best-practices': { text: 'text-rose-400', bg: 'bg-rose-500/10', border: 'bg-rose-500' },
                        accessibility: { text: 'text-red-400', bg: 'bg-red-500/10', border: 'bg-red-500' }
                      };
                    }
                    if (activeSection === 'button') {
                      return {
                        overview: { text: 'text-orange-400', bg: 'bg-orange-500/10', border: 'bg-orange-500' },
                        examples: { text: 'text-amber-400', bg: 'bg-amber-500/10', border: 'bg-amber-500' },
                        anatomy: { text: 'text-yellow-400', bg: 'bg-yellow-500/10', border: 'bg-yellow-500' },
                        props: { text: 'text-lime-400', bg: 'bg-lime-500/10', border: 'bg-lime-500' },
                        'best-practices': { text: 'text-green-400', bg: 'bg-green-500/10', border: 'bg-green-500' },
                        accessibility: { text: 'text-emerald-400', bg: 'bg-emerald-500/10', border: 'bg-emerald-500' }
                      };
                    }
                    // Default teal for all others
                    return null;
                  };

                  const componentColors = getComponentColors();
                  const tabColors = componentColors?.[tab.id];

                  const getTabColor = () => {
                    if (tabColors && activeTab === tab.id) {
                      return `${tabColors.text} ${tabColors.bg}`;
                    }
                    return activeTab === tab.id ? 'text-teal-400' : 'text-gray-400 hover:text-gray-200';
                  };

                  const getBorderColor = () => {
                    if (tabColors && activeTab === tab.id) {
                      return tabColors.border;
                    }
                    return 'bg-teal-500';
                  };

                  return (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`px-5 py-2.5 text-sm font-medium transition-all relative flex items-center gap-2 rounded-t-lg smooth-hover btn-scale ${getTabColor()}`}
                    >
                      {getTabIcon()}
                      {tab.label}
                      {activeTab === tab.id && (
                        <div className={`absolute bottom-0 left-0 right-0 h-0.5 ${getBorderColor()}`} />
                      )}
                    </button>
                  );
                })}
              </nav>
            </div>
          )}

          {activeSection === 'introduction' && <IntroductionPage setActiveSection={setActiveSection} setActiveTab={setActiveTab} />}
          
          {activeSection === 'colors' && (
            <>
              {activeTab === 'overview' && <ColorsOverview />}
              {activeTab === 'examples' && <ColorsPrimitive />}
              {activeTab === 'anatomy' && <ColorsSemantic />}
              {activeTab === 'props' && <ColorsComponent />}
            </>
          )}
          
          {activeSection === 'typography' && <TypographyPage />}
          {activeSection === 'spacing' && <SpacingPage />}
          {activeSection === 'team' && <TeamPage editMode={editMode} setEditMode={setEditMode} teamMembers={teamMembers} setTeamMembers={setTeamMembers} />}
          {activeSection === 'dev-handoff' && <DevHandoffPage />}
          
          {activeSection === 'list-item' && (
            <>
              {activeTab === 'overview' && <OverviewTab />}
              {activeTab === 'examples' && <ExamplesTab />}
              {activeTab === 'anatomy' && <AnatomyTab />}
              {activeTab === 'props' && <PropsTab />}
              {activeTab === 'best-practices' && <BestPracticesTab />}
              {activeTab === 'accessibility' && <AccessibilityTab />}
            </>
          )}
          
          {activeSection === 'stock-card' && (
            <>
              {activeTab === 'overview' && <StockCardOverview />}
              {activeTab === 'examples' && <StockCardExamples />}
              {activeTab === 'anatomy' && <StockCardAnatomy />}
              {activeTab === 'props' && <StockCardProps />}
              {activeTab === 'best-practices' && <StockCardBestPractices />}
              {activeTab === 'accessibility' && <StockCardAccessibility />}
            </>
          )}
          
          {activeSection === 'navigation-bar' && (
            <>
              {activeTab === 'overview' && <NavBarOverview />}
              {activeTab === 'examples' && <NavBarExamples />}
              {activeTab === 'anatomy' && <NavBarAnatomy />}
              {activeTab === 'props' && <NavBarProps />}
              {activeTab === 'best-practices' && <NavBarBestPractices />}
              {activeTab === 'accessibility' && <NavBarAccessibility />}
            </>
          )}
          
          {activeSection === 'button' && (
            <>
              {activeTab === 'overview' && <ButtonOverview />}
              {activeTab === 'examples' && <ButtonExamples />}
              {activeTab === 'anatomy' && <ButtonAnatomy />}
              {activeTab === 'props' && <ButtonProps />}
              {activeTab === 'best-practices' && <ButtonBestPractices />}
              {activeTab === 'accessibility' && <ButtonAccessibility />}
            </>
          )}
        </div>
      </main>
    </div>
  );
}

// ==========================================
// LIST ITEM COMPONENTS - COMPLETE
// ==========================================

function Avatar({ variant = 1, size = 48 }) {
  if (variant === 1) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" className="rounded-full flex-shrink-0">
        <circle cx="50" cy="50" r="50" fill="#4A90D9"/>
        <circle cx="50" cy="45" r="25" fill="#FFDAB9"/>
        <circle cx="42" cy="42" r="3" fill="#333"/>
        <circle cx="58" cy="42" r="3" fill="#333"/>
        <path d="M 43 55 Q 50 60 57 55" stroke="#333" strokeWidth="2" fill="none"/>
        <path d="M 30 30 Q 35 15 50 12 Q 65 15 70 30 Q 65 22 50 20 Q 35 22 30 30" fill="#2C2C2C"/>
      </svg>
    );
  }
  if (variant === 2) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" className="rounded-full flex-shrink-0">
        <circle cx="50" cy="50" r="50" fill="#FFB6C1"/>
        <circle cx="50" cy="45" r="25" fill="#FFDAB9"/>
        <circle cx="42" cy="42" r="3" fill="#333"/>
        <circle cx="58" cy="42" r="3" fill="#333"/>
        <path d="M 43 55 Q 50 62 57 55" stroke="#333" strokeWidth="2" fill="none"/>
        <path d="M 25 35 Q 30 10 50 8 Q 70 10 75 35 Q 70 25 50 22 Q 30 25 25 35" fill="#8B4513"/>
        <path d="M 22 40 Q 15 35 20 60 Q 25 50 28 40" fill="#8B4513"/>
        <path d="M 78 40 Q 85 35 80 60 Q 75 50 72 40" fill="#8B4513"/>
      </svg>
    );
  }
  if (variant === 3) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" className="rounded-full flex-shrink-0">
        <circle cx="50" cy="50" r="50" fill="#50C878"/>
        <circle cx="50" cy="42" r="25" fill="#FFDAB9"/>
        <circle cx="42" cy="40" r="3" fill="#333"/>
        <circle cx="58" cy="40" r="3" fill="#333"/>
        <path d="M 43 50 Q 50 55 57 50" stroke="#333" strokeWidth="2" fill="none"/>
        <path d="M 32 28 Q 40 18 50 15 Q 60 18 68 28 Q 60 22 50 20 Q 40 22 32 28" fill="#4A4A4A"/>
        <path d="M 35 55 Q 50 70 65 55 Q 60 62 50 65 Q 40 62 35 55" fill="#4A4A4A"/>
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className="rounded-full flex-shrink-0">
      <circle cx="50" cy="50" r="50" fill="#4A90D9"/>
      <circle cx="50" cy="45" r="25" fill="#FFDAB9"/>
      <circle cx="42" cy="42" r="3" fill="#333"/>
      <circle cx="58" cy="42" r="3" fill="#333"/>
      <path d="M 43 55 Q 50 60 57 55" stroke="#333" strokeWidth="2" fill="none"/>
    </svg>
  );
}

function ListItemPreview({ 
  name = "Michael Chen",
  title = "Senior Portfolio Manager",
  rating = 4.9,
  price = "$125/hr",
  change = "+12.5%",
  showRating = true,
  showPrice = true,
  showArrow = true,
  selected = false,
  disabled = false,
  avatarVariant = 1
}) {
  const isPositive = change.startsWith('+');
  
  return (
    <div 
      className={`
        flex items-center gap-3 p-4 rounded-xl transition-all cursor-pointer
        ${selected 
          ? 'bg-teal-500/10 border-2 border-teal-500' 
          : 'glass-card bg-opacity-60 bg-blue-900/50 border border-blue-800/20 hover:bg-blue-900/20'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      `}
    >
      <Avatar variant={avatarVariant} size={48} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="font-semibold text-white truncate">{name}</h3>
          {showRating && (
            <div className="flex items-center gap-1 text-amber-400">
              <Star className="w-4 h-4 fill-current" />
              <span className="text-sm">{rating}</span>
            </div>
          )}
        </div>
        <p className="text-sm text-gray-400 truncate">{title}</p>
      </div>
      {showPrice && (
        <div className="text-right flex-shrink-0">
          <div className="font-semibold text-white">{price}</div>
          <div className={`text-sm ${isPositive ? 'text-green-400' : 'text-red-400'}`}>
            {change}
          </div>
        </div>
      )}
      {showArrow && (
        <ArrowRight className="w-5 h-5 text-gray-500 flex-shrink-0" />
      )}
    </div>
  );
}

function OverviewTab() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-4">Preview</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md space-y-3">
            <ListItemPreview avatarVariant={1} />
            <ListItemPreview 
              name="Sarah Johnson" 
              title="Investment Analyst" 
              rating={4.7}
              price="$95/hr"
              change="+8.2%"
              selected={true}
              avatarVariant={2}
            />
            <ListItemPreview 
              name="David Kim" 
              title="Financial Advisor" 
              rating={4.5}
              price="$150/hr"
              change="-3.1%"
              avatarVariant={3}
            />
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">When to use</h2>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
            <h3 className="font-semibold text-green-400 mb-2 flex items-center gap-2">
              <Check className="w-5 h-5" />
              Do use when
            </h3>
            <ul className="text-sm text-gray-300 space-y-2">
              <li>• Displaying portfolio managers or advisors</li>
              <li>• Showing user profiles with metadata</li>
              <li>• Creating selectable lists with ratings</li>
              <li>• Presenting performance data alongside identity</li>
            </ul>
          </div>
          <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
            <h3 className="font-semibold text-red-400 mb-2 flex items-center gap-2">
              <X className="w-5 h-5" />
              Don't use when
            </h3>
            <ul className="text-sm text-gray-300 space-y-2">
              <li>• Displaying simple navigation menus</li>
              <li>• Showing stock/asset cards (use Stock Card)</li>
              <li>• Creating action-heavy interfaces</li>
              <li>• Space is extremely limited</li>
            </ul>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Key Features</h2>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="glass-card bg-opacity-60 bg-blue-900/50 rounded-xl p-4 border border-blue-800/20 smooth-hover">
            <Users className="w-8 h-8 text-teal-400 mb-3" />
            <h3 className="font-semibold mb-1">Avatar Support</h3>
            <p className="text-sm text-gray-400">Display user avatars or initials</p>
          </div>
          <div className="glass-card bg-opacity-60 bg-blue-900/50 rounded-xl p-4 border border-blue-800/20 smooth-hover">
            <Star className="w-8 h-8 text-teal-400 mb-3" />
            <h3 className="font-semibold mb-1">Rating System</h3>
            <p className="text-sm text-gray-400">Show star ratings with numeric values</p>
          </div>
          <div className="glass-card bg-opacity-60 bg-blue-900/50 rounded-xl p-4 border border-blue-800/20 smooth-hover">
            <TrendingUp className="w-8 h-8 text-teal-400 mb-3" />
            <h3 className="font-semibold mb-1">Performance Data</h3>
            <p className="text-sm text-gray-400">Display price and percentage change</p>
          </div>
        </div>
      </section>
    </div>
  );
}

function ExamplesTab() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-2">Default</h2>
        <p className="text-gray-400 mb-4">Standard list item with all elements visible.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md">
            <ListItemPreview avatarVariant={1} />
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Selected</h2>
        <p className="text-gray-400 mb-4">Highlighted state when item is selected.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md">
            <ListItemPreview selected={true} avatarVariant={1} />
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Without Rating</h2>
        <p className="text-gray-400 mb-4">List item without rating display.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md">
            <ListItemPreview showRating={false} avatarVariant={1} />
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Minimal</h2>
        <p className="text-gray-400 mb-4">Minimal version without price and arrow.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md">
            <ListItemPreview showPrice={false} showArrow={false} avatarVariant={1} />
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Disabled</h2>
        <p className="text-gray-400 mb-4">Non-interactive disabled state.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md">
            <ListItemPreview disabled={true} avatarVariant={1} />
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Negative Performance</h2>
        <p className="text-gray-400 mb-4">Displaying negative percentage change.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md">
            <ListItemPreview change="-5.2%" avatarVariant={1} />
          </div>
        </div>
      </section>
    </div>
  );
}

function AnatomyTab() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <p className="text-gray-400 mb-4">
          The anatomy of a list item includes several essential components that work together to provide clear, accessible information display with interactive capabilities.
        </p>
        
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-8 border border-blue-900/30 mb-4">
          <div className="relative max-w-lg mx-auto">
            <div className="flex items-center gap-3 p-4 rounded-xl glass-card bg-opacity-60 bg-blue-900 border border-gray-600">
              <div className="relative">
                <Avatar variant={1} size={48} />
                <div className="absolute -top-2 -left-2 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold">1</div>
              </div>

              <div className="flex-1">
                <div className="flex items-center gap-2 relative">
                  <h3 className="font-semibold text-white">Michael Chen</h3>
                  <div className="absolute -top-4 left-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold">2</div>
                  <div className="flex items-center gap-1 text-amber-400 relative">
                    <Star className="w-4 h-4 fill-current" />
                    <span className="text-sm">4.9</span>
                    <div className="absolute -top-4 right-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold">4</div>
                  </div>
                </div>
                <p className="text-sm text-gray-400 relative">
                  Senior Portfolio Manager
                  <span className="absolute -bottom-4 left-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold">3</span>
                </p>
              </div>

              <div className="text-right relative">
                <div className="font-semibold text-white">$125/hr</div>
                <div className="absolute -top-2 right-8 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold">5</div>
                <div className="text-sm text-green-400 relative">
                  +12.5%
                  <span className="absolute -bottom-4 right-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold">6</span>
                </div>
              </div>

              <div className="relative">
                <ArrowRight className="w-5 h-5 text-gray-500" />
                <div className="absolute -top-2 -right-2 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold">7</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {[
            { num: 1, name: 'Avatar', desc: 'User profile image or initials (48×48px)' },
            { num: 2, name: 'Primary Text', desc: 'User name or main identifier' },
            { num: 3, name: 'Secondary Text', desc: 'Role, title, or description' },
            { num: 4, name: 'Rating', desc: 'Star icon with numeric rating value' },
            { num: 5, name: 'Price', desc: 'Hourly rate or cost indicator' },
            { num: 6, name: 'Change Indicator', desc: 'Performance percentage (positive/negative)' },
            { num: 7, name: 'Navigation Arrow', desc: 'Indicates clickable/navigable item' },
          ].map((part, index) => (
            <div key={part.num} className="flex gap-3 items-start">
              <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">
                {part.num}
              </div>
              <div>
                <h4 className="font-semibold">{part.name}</h4>
                <p className="text-sm text-gray-400">{part.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function PropsTab() {
  const props = [
    { name: 'name', type: 'string', default: '-', required: true, desc: 'Display name of the user' },
    { name: 'title', type: 'string', default: '-', required: true, desc: 'Role or title of the user' },
    { name: 'avatarUrl', type: 'string | null', default: 'null', required: false, desc: 'URL of avatar image' },
    { name: 'avatarIndex', type: 'number', default: '1', required: false, desc: 'Index for default avatar selection (1-6)' },
    { name: 'rating', type: 'number', default: '-', required: false, desc: 'Rating value (0-5)' },
    { name: 'showRating', type: 'boolean', default: 'true', required: false, desc: 'Show/hide rating display' },
    { name: 'price', type: 'string', default: '-', required: false, desc: 'Price or rate text' },
    { name: 'change', type: 'string', default: '-', required: false, desc: 'Percentage change value' },
    { name: 'showPrice', type: 'boolean', default: 'true', required: false, desc: 'Show/hide price section' },
    { name: 'showArrow', type: 'boolean', default: 'true', required: false, desc: 'Show/hide navigation arrow' },
    { name: 'selected', type: 'boolean', default: 'false', required: false, desc: 'Selected state styling' },
    { name: 'disabled', type: 'boolean', default: 'false', required: false, desc: 'Disable interaction' },
    { name: 'onPress', type: 'function', default: '-', required: false, desc: 'Callback on item press' },
  ];

  const tokens = [
    { category: 'Colors', tokens: [
      { name: 'surface-primary', light: '#FFFFFF', dark: '#1F2937', usage: 'Background' },
      { name: 'surface-secondary', light: '#F3F4F6', dark: '#374151', usage: 'Hover background' },
      { name: 'text-primary', light: '#1A1A1A', dark: '#F9FAFB', usage: 'Name text' },
      { name: 'text-secondary', light: '#6B7280', dark: '#9CA3AF', usage: 'Title text' },
      { name: 'border-default', light: '#E5E7EB', dark: '#4B5563', usage: 'Border color' },
      { name: 'brand-primary', light: '#159A92', dark: '#10B981', usage: 'Selected border' },
      { name: 'success', light: '#10B981', dark: '#34D399', usage: 'Positive change' },
      { name: 'error', light: '#EF4444', dark: '#F87171', usage: 'Negative change' },
      { name: 'warning', light: '#F59E0B', dark: '#FBBF24', usage: 'Rating star' },
    ]},
    { category: 'Spacing', tokens: [
      { name: 'spacing-xs', value: '4px', usage: 'Icon gaps' },
      { name: 'spacing-sm', value: '8px', usage: 'Internal gaps' },
      { name: 'spacing-md', value: '12px', usage: 'Element spacing' },
      { name: 'spacing-lg', value: '16px', usage: 'Padding' },
    ]},
    { category: 'Typography', tokens: [
      { name: 'font-size-sm', value: '14px', usage: 'Secondary text' },
      { name: 'font-size-md', value: '16px', usage: 'Primary text' },
      { name: 'font-weight-regular', value: '400', usage: 'Secondary text' },
      { name: 'font-weight-semibold', value: '600', usage: 'Primary text' },
    ]},
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-4">Properties</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl border border-blue-900/30 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="glass-card bg-opacity-60 bg-blue-900">
              <tr>
                <th className="text-left p-4 font-semibold">Property</th>
                <th className="text-left p-4 font-semibold">Type</th>
                <th className="text-left p-4 font-semibold">Default</th>
                <th className="text-left p-4 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              {props.map((prop, i) => (
                <tr key={prop.name} className={i % 2 === 0 ? 'glass-card bg-opacity-70 bg-blue-950' : 'glass-card bg-opacity-60 bg-blue-900/50'}>
                  <td className="p-4">
                    <code className="text-teal-400">{prop.name}</code>
                    {prop.required && <span className="text-red-400 ml-1">*</span>}
                  </td>
                  <td className="p-4 text-gray-400">{prop.type}</td>
                  <td className="p-4 text-gray-400">{prop.default}</td>
                  <td className="p-4 text-gray-400">{prop.desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Design Tokens</h2>
        {tokens.map((group) => (
          <div key={group.category} className="mb-4">
            <h3 className="text-lg font-medium mb-3 text-teal-400">{group.category}</h3>
            <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl border border-blue-900/30 overflow-hidden">
              <table className="w-full text-sm">
                <thead className="glass-card bg-opacity-60 bg-blue-900">
                  <tr>
                    <th className="text-left p-3 font-semibold">Token</th>
                    {group.category === 'Colors' ? (
                      <>
                        <th className="text-left p-3 font-semibold">Light</th>
                        <th className="text-left p-3 font-semibold">Dark</th>
                      </>
                    ) : (
                      <th className="text-left p-3 font-semibold">Value</th>
                    )}
                    <th className="text-left p-3 font-semibold">Usage</th>
                  </tr>
                </thead>
                <tbody>
                  {group.tokens.map((token, i) => (
                    <tr key={token.name} className={i % 2 === 0 ? 'glass-card bg-opacity-70 bg-blue-950' : 'glass-card bg-opacity-60 bg-blue-900/50'}>
                      <td className="p-3">
                        <code className="text-teal-400">{token.name}</code>
                      </td>
                      {group.category === 'Colors' ? (
                        <>
                          <td className="p-3">
                            <div className="flex items-center gap-2">
                              <div className="w-4 h-4 rounded" style={{ backgroundColor: token.light }} />
                              <span className="text-gray-400">{token.light}</span>
                            </div>
                          </td>
                          <td className="p-3">
                            <div className="flex items-center gap-2">
                              <div className="w-4 h-4 rounded" style={{ backgroundColor: token.dark }} />
                              <span className="text-gray-400">{token.dark}</span>
                            </div>
                          </td>
                        </>
                      ) : (
                        <td className="p-3 text-gray-400">{token.value}</td>
                      )}
                      <td className="p-3 text-gray-400">{token.usage}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Specifications</h2>
        <div className="grid md:grid-cols-2 gap-3">
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
            <h3 className="font-semibold mb-3">Dimensions</h3>
            <ul className="text-sm space-y-2 text-gray-400">
              <li className="flex justify-between"><span>Min Height:</span> <code>72px</code></li>
              <li className="flex justify-between"><span>Avatar Size:</span> <code>48×48px</code></li>
              <li className="flex justify-between"><span>Arrow Icon:</span> <code>20×20px</code></li>
              <li className="flex justify-between"><span>Star Icon:</span> <code>16×16px</code></li>
            </ul>
          </div>
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
            <h3 className="font-semibold mb-3">Spacing</h3>
            <ul className="text-sm space-y-2 text-gray-400">
              <li className="flex justify-between"><span>Padding:</span> <code>16px</code></li>
              <li className="flex justify-between"><span>Gap (elements):</span> <code>12px</code></li>
              <li className="flex justify-between"><span>Gap (rating):</span> <code>4px</code></li>
              <li className="flex justify-between"><span>Border Radius:</span> <code>12px</code></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

function BestPracticesTab() {
  const dos = [
    { title: 'Use consistent avatar sizes', desc: 'Keep all avatars 48×48px in lists for visual consistency' },
    { title: 'Show rating when available', desc: 'Ratings build trust and help users make decisions' },
    { title: 'Align financial data right', desc: 'Price and percentage on the right creates scannable columns' },
    { title: 'Use percentage colors meaningfully', desc: 'Green for positive, red for negative helps quick scanning' },
    { title: 'Keep list items equal height', desc: 'Makes lists more professional and easier to scan' },
  ];

  const donts = [
    { title: "Don't overload with information", desc: 'Maximum 2 lines of text, keep it scannable' },
    { title: "Don't use without proper spacing", desc: 'Always maintain 16px padding minimum' },
    { title: "Don't mix selected and default states", desc: 'Only one item selected at a time with clear distinction' },
    { title: "Don't hide important metadata", desc: 'If showing price, show percentage too for complete info' },
    { title: "Don't use inconsistent borders", desc: 'Default: subtle, Selected: clear teal border only' },
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-4 flex items-center gap-2 text-green-400">
          <Check className="w-6 h-6" />
          Do's
        </h2>
        <div className="space-y-5">
          {dos.map((item, i) => (
            <div key={i} className="bg-green-500/10 border border-green-500/30 rounded-xl p-4 flex gap-3">
              <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-semibold text-green-400">{item.title}</h3>
                <p className="text-sm text-gray-400">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4 flex items-center gap-2 text-red-400">
          <X className="w-6 h-6" />
          Don'ts
        </h2>
        <div className="space-y-5">
          {donts.map((item, i) => (
            <div key={i} className="bg-red-500/10 border border-red-500/30 rounded-xl p-4 flex gap-3">
              <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-semibold text-red-400">{item.title}</h3>
                <p className="text-sm text-gray-400">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Visual Examples</h2>
        <div className="grid md:grid-cols-2 gap-5">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Check className="w-5 h-5 text-green-400" />
              <span className="font-semibold text-green-400">Correct</span>
            </div>
            <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border-2 border-green-500/30">
              <ListItemPreview avatarVariant={1} />
            </div>
            <p className="text-sm text-gray-400 mt-2">All elements properly aligned with consistent spacing</p>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3">
              <X className="w-5 h-5 text-red-400" />
              <span className="font-semibold text-red-400">Incorrect</span>
            </div>
            <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-2 border-2 border-red-500/30">
              <div className="flex items-center gap-1 p-1">
                <Avatar variant={1} size={32} />
                <div className="flex-1">
                  <h3 className="font-semibold text-white text-xs">Michael Chen Senior Portfolio Manager With Very Long Title</h3>
                </div>
                <div className="text-xs text-white">$125</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 mt-2">Too cramped, text overflow, missing key information</p>
          </div>
        </div>
      </section>
    </div>
  );
}

function AccessibilityTab() {
  const checks = [
    { 
      category: 'Color Contrast',
      items: [
        'Text/Background: 4.5:1 minimum (WCAG AA)',
        'Selected border: High contrast',
        'Disabled state: 3:1 minimum'
      ]
    },
    { 
      category: 'Keyboard Navigation',
      items: [
        'Tab to focus next item',
        'Shift+Tab to focus previous',
        'Enter/Space to select',
        'Arrow keys for list navigation'
      ]
    },
    { 
      category: 'Focus States',
      items: [
        'Clear focus ring (2px solid)',
        'Never remove focus indicator',
        'Focus visible on keyboard navigation'
      ]
    },
    { 
      category: 'Screen Reader',
      items: [
        'Name announced first',
        'Title/role announced second',
        'Rating announced as "Rating X.X out of 5"',
        'Price announced with currency',
        'Selected state announced',
        'Arrow icon hidden (decorative)'
      ]
    },
    { 
      category: 'Touch Targets',
      items: [
        'Minimum 44×44px tap area',
        'Entire row is tappable',
        'No overlapping touch areas'
      ]
    },
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <p className="text-gray-400 mb-4">
          The List Item component is designed to meet WCAG 2.1 Level AA accessibility standards, ensuring all users can navigate and interact with list content effectively.
        </p>

        <div className="grid md:grid-cols-2 gap-4 mb-4">
          {checks.map((check) => (
            <div key={check.category} className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
              <h3 className="font-semibold mb-3 flex items-center gap-2">
                <Check className="w-5 h-5 text-green-400" />
                {check.category}
              </h3>
              <ul className="text-sm text-gray-400 space-y-1">
                {check.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-teal-400 mt-1">•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <h2 className="text-xl font-semibold mb-4">ARIA Attributes</h2>
        <div className="glass-card bg-opacity-70 bg-gradient-to-br from-blue-950 to-indigo-950 rounded-xl border border-blue-900/30 overflow-hidden">
          <div className="flex items-center gap-3 px-5 py-3 border-b border-blue-900/30 bg-blue-950/50">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-white">Code Example</h3>
              <p className="text-xs text-gray-400">ARIA implementation</p>
            </div>
          </div>
          <div className="p-5 bg-gradient-to-br from-slate-950 to-blue-950/50">
            <pre className="text-sm overflow-x-auto">
              <code>
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">div</span>
                {'\n  '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"listitem"</span>
                {'\n  '}
                <span className="text-purple-400">aria-selected</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true | false"</span>
                {'\n  '}
                <span className="text-purple-400">aria-label</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"Michael Chen, Senior Portfolio Manager, Rating 4.9"</span>
                {'\n  '}
                <span className="text-purple-400">tabindex</span>
                <span className="text-gray-500">=</span>
                <span className="text-orange-400">"0"</span>
                {'\n'}
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;!--</span>
                <span className="text-gray-400"> Content </span>
                <span className="text-gray-500">--&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">div</span>
                <span className="text-gray-500">&gt;</span>
              </code>
            </pre>
          </div>
        </div>
      </section>
    </div>
  );
}

// ==========================================
// STOCK CARD COMPONENTS - COMPLETE
// ==========================================

function StockCardPreview({
  logo = "TSLA",
  logoColor = "#FF0808",
  name = "Name",
  category = "Category",
  price = "Price",
  percent = "%",
  percentPositive = true,
  badgeText = "Badge Text",
  badgeColor = "#FFD452",
  marketCap = "Market Cap:0000",
  showLogo = true,
  showBadge = true,
  showPrice = true,
  showPercent = true,
  showMarketCap = true,
  showName = true,
  showCategory = true,
  state = "default"
}) {
  return (
    <div 
      className="flex flex-col gap-3 p-4 rounded-[10px] transition-all cursor-pointer shadow-lg"
      style={{ 
        width: '262px', 
        height: '120px',
        backgroundColor: state === 'hover' ? '#F5F5F5' : '#FFFFFF'
      }}
    >
      {/* Top Row: Logo + Company + Price */}
      <div className="flex items-center gap-2">
        {/* Logo + Company */}
        <div className="flex items-center gap-3 flex-1">
          {/* Logo */}
          {showLogo && (
            <div 
              className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: logoColor }}
            >
              <span style={{ color: '#FFFFFF', fontSize: '12px', fontWeight: 700 }}>{logo}</span>
            </div>
          )}
          
          {/* Company Info */}
          <div className="flex flex-col gap-1 flex-1">
            {showName && (
              <span style={{ fontSize: '14px', fontWeight: 700, color: '#050609', lineHeight: '20px' }}>{name}</span>
            )}
            {showCategory && (
              <span style={{ fontSize: '14px', fontWeight: 500, color: '#404A5F', lineHeight: '20px' }}>{category}</span>
            )}
          </div>
        </div>

        {/* Price Info */}
        {showPrice && (
          <div className="flex flex-col gap-1 items-end">
            <span style={{ fontSize: '14px', fontWeight: 700, color: '#050609', lineHeight: '20px' }}>{price}</span>
            {showPercent && (
              <span style={{ 
                fontSize: '14px', 
                fontWeight: 500, 
                color: percentPositive ? '#079455' : '#D92D20', 
                lineHeight: '20px' 
              }}>
                {percent}
              </span>
            )}
          </div>
        )}
      </div>

      {/* Bottom Row: Badge + Market Cap */}
      <div className="flex items-center gap-5">
        {/* Badge */}
        {showBadge && (
          <div 
            className="flex items-center px-2 py-1 rounded-full"
            style={{ backgroundColor: badgeColor }}
          >
            <span style={{ fontSize: '12px', fontWeight: 700, color: '#050609', lineHeight: '16px' }}>{badgeText}</span>
          </div>
        )}
        
        {/* Market Cap */}
        {showMarketCap && (
          <span style={{ fontSize: '12px', fontWeight: 400, color: '#404A5F', lineHeight: '16px', textAlign: 'right', flex: 1 }}>
            {marketCap}
          </span>
        )}
      </div>
    </div>
  );
}

function StockCardOverview() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* Preview */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Preview</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="flex flex-wrap gap-3">
            <StockCardPreview 
              name="Tesla Inc."
              category="Automotive"
              price="$248"
              percent="+3.8%"
              badgeText="Hot Stock"
              marketCap="Market Cap: $787B"
            />
            <StockCardPreview 
              name="Apple Inc."
              category="Technology"
              price="$178"
              percent="+1.2%"
              logo="AAPL"
              logoColor="#000000"
              badgeText="Strong Buy"
              badgeColor="#2196F3"
              marketCap="Market Cap: $2.8T"
            />
          </div>
        </div>
      </section>

      {/* When to Use */}
      <section>
        <h2 className="text-xl font-semibold mb-4">When to use</h2>
        <div className="grid md:grid-cols-2 gap-3">
          <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
            <h3 className="font-semibold text-green-400 mb-2 flex items-center gap-2">
              <Check className="w-5 h-5" />
              Do use when
            </h3>
            <ul className="text-sm text-gray-300 space-y-2">
              <li>• Displaying stock information in feeds</li>
              <li>• Showing trending stocks on home screen</li>
              <li>• Creating portfolio overview cards</li>
              <li>• Presenting watchlist items</li>
              <li>• Horizontal scrolling stock lists</li>
            </ul>
          </div>
          <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
            <h3 className="font-semibold text-red-400 mb-2 flex items-center gap-2">
              <X className="w-5 h-5" />
              Don't use when
            </h3>
            <ul className="text-sm text-gray-300 space-y-2">
              <li>• Displaying detailed stock analysis</li>
              <li>• Showing user profiles (use List Item)</li>
              <li>• Creating navigation elements</li>
              <li>• Displaying non-financial data</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Key Features</h2>
        <div className="grid md:grid-cols-3 gap-3">
          <div className="glass-card bg-opacity-60 bg-blue-900/50 rounded-xl p-4 border border-blue-800/20">
            <TrendingUp className="w-8 h-8 text-teal-400 mb-3" />
            <h3 className="font-semibold mb-1">Price Display</h3>
            <p className="text-sm text-gray-400">Current price with percentage change indicator</p>
          </div>
          <div className="glass-card bg-opacity-60 bg-blue-900/50 rounded-xl p-4 border border-blue-800/20">
            <Briefcase className="w-8 h-8 text-teal-400 mb-3" />
            <h3 className="font-semibold mb-1">Company Info</h3>
            <p className="text-sm text-gray-400">Logo, name, and category display</p>
          </div>
          <div className="glass-card bg-opacity-60 bg-blue-900/50 rounded-xl p-4 border border-blue-800/20">
            <Star className="w-8 h-8 text-teal-400 mb-3" />
            <h3 className="font-semibold mb-1">Status Badges</h3>
            <p className="text-sm text-gray-400">Hot Stock, Strong Buy, and more</p>
          </div>
        </div>
      </section>
    </div>
  );
}

function StockCardExamples() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* Default State */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Default State</h2>
        <p className="text-gray-400 mb-4">Standard card with all elements visible.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <StockCardPreview 
            name="Tesla Inc."
            category="Automotive"
            price="$248"
            percent="+3.8%"
            badgeText="Hot Stock"
            marketCap="Market Cap: $787B"
            state="default"
          />
        </div>
      </section>

      {/* Hover State */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Hover State</h2>
        <p className="text-gray-400 mb-4">Background changes to #F5F5F5 on hover.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <StockCardPreview 
            name="Tesla Inc."
            category="Automotive"
            price="$248"
            percent="+3.8%"
            badgeText="Hot Stock"
            marketCap="Market Cap: $787B"
            state="hover"
          />
        </div>
      </section>

      {/* Negative Change */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Negative Performance</h2>
        <p className="text-gray-400 mb-4">Red color for negative percentage change.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <StockCardPreview 
            name="Meta Inc."
            category="Technology"
            price="$312"
            percent="-2.4%"
            percentPositive={false}
            logo="META"
            logoColor="#0668E1"
            badgeText="Volatile"
            badgeColor="#FEE4E2"
            marketCap="Market Cap: $892B"
          />
        </div>
      </section>

      {/* Without Badge */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Without Badge</h2>
        <p className="text-gray-400 mb-4">Card without status badge.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <StockCardPreview 
            name="Google Inc."
            category="Technology"
            price="$142"
            percent="+0.8%"
            logo="GOOG"
            logoColor="#4285F4"
            showBadge={false}
            marketCap="Market Cap: $1.8T"
          />
        </div>
      </section>

      {/* Minimal */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Minimal</h2>
        <p className="text-gray-400 mb-4">Without badge and market cap.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <StockCardPreview 
            name="Amazon"
            category="E-Commerce"
            price="$178"
            percent="+1.5%"
            logo="AMZN"
            logoColor="#FF9900"
            showBadge={false}
            showMarketCap={false}
          />
        </div>
      </section>

      {/* Badge Variants */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Badge Variants</h2>
        <p className="text-gray-400 mb-4">Different badge types for various stock statuses.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="flex flex-wrap gap-3">
            <StockCardPreview 
              name="Tesla"
              category="Auto"
              price="$248"
              percent="+3.8%"
              badgeText="Hot Stock"
              badgeColor="#FFD452"
              marketCap="Market Cap: $787B"
            />
            <StockCardPreview 
              name="Apple"
              category="Tech"
              price="$178"
              percent="+1.2%"
              logo="AAPL"
              logoColor="#000000"
              badgeText="Strong Buy"
              badgeColor="#A3E0FF"
              marketCap="Market Cap: $2.8T"
            />
            <StockCardPreview 
              name="Microsoft"
              category="Tech"
              price="$378"
              percent="+0.5%"
              logo="MSFT"
              logoColor="#00A4EF"
              badgeText="Safe"
              badgeColor="#D1FADF"
              marketCap="Market Cap: $2.9T"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

function StockCardAnatomy() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <p className="text-gray-400 mb-4">
          The Stock Card component displays essential stock information in a compact format. Each element is carefully positioned to create a scannable, information-rich card.
        </p>
        
        {/* Anatomy Diagram */}
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-8 border border-blue-900/30 mb-4">
          <div className="relative max-w-sm mx-auto">
            {/* Component with numbered labels */}
            <div className="rounded-[10px] p-4 flex flex-col gap-3 shadow-lg" style={{ width: '262px', backgroundColor: '#FFFFFF' }}>
              {/* Top Row */}
              <div className="flex items-center gap-3">
                {/* 1 - Logo */}
                <div className="relative">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#FF0808' }}>
                    <span style={{ color: '#FFFFFF', fontSize: '12px', fontWeight: 700 }}>TSLA</span>
                  </div>
                  <div className="absolute -top-2 -left-2 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold text-white">1</div>
                </div>
                
                {/* 2,3 - Company Info */}
                <div className="flex-1 relative">
                  <div style={{ fontSize: '14px', fontWeight: 700, color: '#050609' }}>Tesla Inc.</div>
                  <div className="absolute -top-3 left-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold text-white">2</div>
                  <div className="relative" style={{ fontSize: '14px', fontWeight: 500, color: '#404A5F' }}>
                    Automotive
                    <span className="absolute -bottom-3 left-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold text-white">3</span>
                  </div>
                </div>
                
                {/* 4,5 - Price */}
                <div className="text-right relative">
                  <div style={{ fontSize: '14px', fontWeight: 700, color: '#050609' }}>$248</div>
                  <div className="absolute -top-3 right-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold text-white">4</div>
                  <div className="relative" style={{ fontSize: '14px', fontWeight: 500, color: '#079455' }}>
                    +3.8%
                    <span className="absolute -bottom-3 right-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold text-white">5</span>
                  </div>
                </div>
              </div>
              
              {/* Bottom Row */}
              <div className="flex items-center gap-5">
                {/* 6 - Badge */}
                <div className="relative">
                  <div className="px-2 py-1 rounded-full" style={{ backgroundColor: '#FFD452' }}>
                    <span style={{ fontSize: '12px', fontWeight: 700, color: '#050609' }}>Hot Stock</span>
                  </div>
                  <div className="absolute -top-2 -left-2 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold text-white">6</div>
                </div>
                
                {/* 7 - Market Cap */}
                <div className="relative flex-1 text-right">
                  <span style={{ fontSize: '12px', fontWeight: 400, color: '#404A5F' }}>Market Cap: $787B</span>
                  <div className="absolute -top-2 right-0 w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold text-white">7</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Parts List */}
        <div className="grid md:grid-cols-2 gap-3">
          {[
            { num: 1, name: 'Logo', desc: 'Company ticker symbol in colored circle (40×40px)' },
            { num: 2, name: 'Company Name', desc: 'Primary company identifier (14px, Bold)' },
            { num: 3, name: 'Category', desc: 'Industry/sector classification (14px, Medium)' },
            { num: 4, name: 'Price', desc: 'Current stock price (14px, Bold)' },
            { num: 5, name: 'Change Percentage', desc: 'Price change with color indicator' },
            { num: 6, name: 'Badge', desc: 'Status indicator (Hot Stock, Strong Buy, etc.)' },
            { num: 7, name: 'Market Cap', desc: 'Market capitalization value (12px, Regular)' },
          ].map((part) => (
            <div key={part.num} className="flex gap-3 items-start">
              <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">
                {part.num}
              </div>
              <div>
                <h4 className="font-semibold">{part.name}</h4>
                <p className="text-sm text-gray-400">{part.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function StockCardProps() {
  const props = [
    { name: 'logo', type: 'string', default: 'TSLA', required: false, desc: 'Ticker symbol displayed in logo' },
    { name: 'logoColor', type: 'string', default: '#FF0808', required: false, desc: 'Background color of logo circle' },
    { name: 'name', type: 'string', default: '-', required: true, desc: 'Company name' },
    { name: 'category', type: 'string', default: '-', required: true, desc: 'Industry/sector category' },
    { name: 'price', type: 'string', default: '-', required: true, desc: 'Current stock price' },
    { name: 'percent', type: 'string', default: '-', required: false, desc: 'Percentage change value' },
    { name: 'percentPositive', type: 'boolean', default: 'true', required: false, desc: 'Determines green/red color' },
    { name: 'badgeText', type: 'string', default: '-', required: false, desc: 'Badge label text' },
    { name: 'badgeColor', type: 'string', default: '#FFD452', required: false, desc: 'Badge background color' },
    { name: 'marketCap', type: 'string', default: '-', required: false, desc: 'Market cap text' },
    { name: 'showLogo', type: 'boolean', default: 'true', required: false, desc: 'Toggle logo visibility' },
    { name: 'showBadge', type: 'boolean', default: 'true', required: false, desc: 'Toggle badge visibility' },
    { name: 'showPrice', type: 'boolean', default: 'true', required: false, desc: 'Toggle price visibility' },
    { name: 'showPercent', type: 'boolean', default: 'true', required: false, desc: 'Toggle percent visibility' },
    { name: 'showMarketCap', type: 'boolean', default: 'true', required: false, desc: 'Toggle market cap visibility' },
    { name: 'showName', type: 'boolean', default: 'true', required: false, desc: 'Toggle name visibility' },
    { name: 'showCategory', type: 'boolean', default: 'true', required: false, desc: 'Toggle category visibility' },
    { name: 'state', type: "'default' | 'hover'", default: 'default', required: false, desc: 'Visual state of the card' },
  ];

  const tokens = [
    { category: 'Colors', tokens: [
      { name: 'surface-primary', light: '#FFFFFF', dark: '#1F2937', usage: 'Card background (default)' },
      { name: 'surface-hover', light: '#F5F5F5', dark: '#374151', usage: 'Card background (hover)' },
      { name: 'text-primary', light: '#050609', dark: '#F9FAFB', usage: 'Name, Price' },
      { name: 'text-secondary', light: '#404A5F', dark: '#9CA3AF', usage: 'Category, Market Cap' },
      { name: 'success', light: '#079455', dark: '#34D399', usage: 'Positive percentage' },
      { name: 'error', light: '#D92D20', dark: '#F87171', usage: 'Negative percentage' },
      { name: 'badge-hot', light: '#FFD452', dark: '#FFD452', usage: 'Hot Stock badge' },
      { name: 'badge-buy', light: '#A3E0FF', dark: '#A3E0FF', usage: 'Strong Buy badge' },
      { name: 'badge-safe', light: '#D1FADF', dark: '#D1FADF', usage: 'Safe badge' },
    ]},
    { category: 'Typography', tokens: [
      { name: 'Body/sm (B)', value: '14px / 700', usage: 'Name, Price' },
      { name: 'Body/sm', value: '14px / 500', usage: 'Category, Percent' },
      { name: 'Label/label (B)', value: '12px / 700', usage: 'Badge text, Logo text' },
      { name: 'Label/label', value: '12px / 400', usage: 'Market Cap' },
    ]},
    { category: 'Spacing', tokens: [
      { name: 'padding', value: '16px', usage: 'Card internal padding' },
      { name: 'gap-sections', value: '16px', usage: 'Between top and bottom rows' },
      { name: 'gap-elements', value: '8px', usage: 'Between logo and company' },
      { name: 'gap-badge', value: '20px', usage: 'Between badge and market cap' },
      { name: 'gap-text', value: '4px', usage: 'Between name and category' },
    ]},
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* Properties Table */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Properties</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl border border-blue-900/30 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="glass-card bg-opacity-60 bg-blue-900">
              <tr>
                <th className="text-left p-4 font-semibold">Property</th>
                <th className="text-left p-4 font-semibold">Type</th>
                <th className="text-left p-4 font-semibold">Default</th>
                <th className="text-left p-4 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              {props.map((prop, i) => (
                <tr key={prop.name} className={i % 2 === 0 ? 'glass-card bg-opacity-70 bg-blue-950' : 'glass-card bg-opacity-60 bg-blue-900/50'}>
                  <td className="p-4">
                    <code className="text-teal-400">{prop.name}</code>
                    {prop.required && <span className="text-red-400 ml-1">*</span>}
                  </td>
                  <td className="p-4 text-gray-400">{prop.type}</td>
                  <td className="p-4 text-gray-400">{prop.default}</td>
                  <td className="p-4 text-gray-400">{prop.desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Design Tokens */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Design Tokens</h2>
        {tokens.map((group) => (
          <div key={group.category} className="mb-4">
            <h3 className="text-lg font-medium mb-3 text-teal-400">{group.category}</h3>
            <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl border border-blue-900/30 overflow-hidden">
              <table className="w-full text-sm">
                <thead className="glass-card bg-opacity-60 bg-blue-900">
                  <tr>
                    <th className="text-left p-3 font-semibold">Token</th>
                    {group.category === 'Colors' ? (
                      <>
                        <th className="text-left p-3 font-semibold">Light</th>
                        <th className="text-left p-3 font-semibold">Dark</th>
                      </>
                    ) : (
                      <th className="text-left p-3 font-semibold">Value</th>
                    )}
                    <th className="text-left p-3 font-semibold">Usage</th>
                  </tr>
                </thead>
                <tbody>
                  {group.tokens.map((token, i) => (
                    <tr key={token.name} className={i % 2 === 0 ? 'glass-card bg-opacity-70 bg-blue-950' : 'glass-card bg-opacity-60 bg-blue-900/50'}>
                      <td className="p-3">
                        <code className="text-teal-400">{token.name}</code>
                      </td>
                      {group.category === 'Colors' ? (
                        <>
                          <td className="p-3">
                            <div className="flex items-center gap-2">
                              <div className="w-4 h-4 rounded border border-gray-600" style={{ backgroundColor: token.light }} />
                              <span className="text-gray-400">{token.light}</span>
                            </div>
                          </td>
                          <td className="p-3">
                            <div className="flex items-center gap-2">
                              <div className="w-4 h-4 rounded border border-gray-600" style={{ backgroundColor: token.dark }} />
                              <span className="text-gray-400">{token.dark}</span>
                            </div>
                          </td>
                        </>
                      ) : (
                        <td className="p-3 text-gray-400">{token.value}</td>
                      )}
                      <td className="p-3 text-gray-400">{token.usage}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </section>

      {/* Specifications */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Specifications</h2>
        <div className="grid md:grid-cols-2 gap-3">
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
            <h3 className="font-semibold mb-3">Dimensions</h3>
            <ul className="text-sm space-y-2 text-gray-400">
              <li className="flex justify-between"><span>Card Width:</span> <code>262px</code></li>
              <li className="flex justify-between"><span>Card Height:</span> <code>120px</code></li>
              <li className="flex justify-between"><span>Logo Size:</span> <code>40×40px</code></li>
              <li className="flex justify-between"><span>Border Radius:</span> <code>10px</code></li>
              <li className="flex justify-between"><span>Badge Radius:</span> <code>999px (pill)</code></li>
            </ul>
          </div>
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
            <h3 className="font-semibold mb-3">Layout</h3>
            <ul className="text-sm space-y-2 text-gray-400">
              <li className="flex justify-between"><span>Direction:</span> <code>Column</code></li>
              <li className="flex justify-between"><span>Padding:</span> <code>16px</code></li>
              <li className="flex justify-between"><span>Row Gap:</span> <code>16px</code></li>
              <li className="flex justify-between"><span>Element Gap:</span> <code>8px - 12px</code></li>
              <li className="flex justify-between"><span>Badge Padding:</span> <code>4px 8px</code></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

function StockCardBestPractices() {
  const dos = [
    { title: 'Use consistent logo sizes', desc: 'Keep all logos 40×40px for visual consistency' },
    { title: 'Show percentage with price', desc: 'Always pair price with change percentage for context' },
    { title: 'Use semantic badge colors', desc: 'Yellow for trending, blue for recommendations, green for safe' },
    { title: 'Align price data right', desc: 'Right-align numbers for easy scanning and comparison' },
    { title: 'Keep ticker symbols short', desc: 'Use standard 3-4 character ticker symbols in logo' },
  ];

  const donts = [
    { title: "Don't overcrowd with badges", desc: 'Use maximum one badge per card' },
    { title: "Don't truncate company names", desc: 'Ensure full name visibility or use abbreviations' },
    { title: "Don't mix percentage formats", desc: 'Always include + or - sign for clarity' },
    { title: "Don't use similar badge colors", desc: 'Maintain distinct colors for different statuses' },
    { title: "Don't hide essential info", desc: 'Price and percentage should always be visible' },
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-4 flex items-center gap-2 text-green-400">
          <Check className="w-6 h-6" />
          Do's
        </h2>
        <div className="space-y-4">
          {dos.map((item, i) => (
            <div key={i} className="bg-green-500/10 border border-green-500/30 rounded-xl p-4 flex gap-3">
              <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-semibold text-green-400">{item.title}</h3>
                <p className="text-sm text-gray-400">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4 flex items-center gap-2 text-red-400">
          <X className="w-6 h-6" />
          Don'ts
        </h2>
        <div className="space-y-4">
          {donts.map((item, i) => (
            <div key={i} className="bg-red-500/10 border border-red-500/30 rounded-xl p-4 flex gap-3">
              <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-semibold text-red-400">{item.title}</h3>
                <p className="text-sm text-gray-400">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Visual Examples</h2>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Check className="w-5 h-5 text-green-400" />
              <span className="font-semibold text-green-400">Correct</span>
            </div>
            <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border-2 border-green-500/30">
              <StockCardPreview 
                name="Tesla Inc."
                category="Automotive"
                price="$248"
                percent="+3.8%"
                badgeText="Hot Stock"
                marketCap="Market Cap: $787B"
              />
            </div>
            <p className="text-sm text-gray-400 mt-2">All elements properly aligned with consistent spacing</p>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3">
              <X className="w-5 h-5 text-red-400" />
              <span className="font-semibold text-red-400">Incorrect</span>
            </div>
            <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border-2 border-red-500/30">
              <div className="rounded p-2 flex items-center gap-1 shadow" style={{ width: '200px', backgroundColor: '#FFFFFF' }}>
                <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: '#FF0808' }}>
                  <span style={{ color: '#FFFFFF', fontSize: '8px', fontWeight: 700 }}>T</span>
                </div>
                <div className="flex-1 overflow-hidden">
                  <div className="truncate" style={{ fontSize: '10px', fontWeight: 700, color: '#050609' }}>Tesla Inc. Electric Vehicles Company</div>
                  <div style={{ fontSize: '8px', color: '#404A5F' }}>Auto</div>
                </div>
                <div style={{ fontSize: '10px', color: '#050609' }}>248</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 mt-2">Too cramped, missing currency symbol, truncated text</p>
          </div>
        </div>
      </section>
    </div>
  );
}

function StockCardAccessibility() {
  const checks = [
    { 
      category: 'Color Contrast',
      items: [
        'Text on white: #050609 provides 19:1 ratio',
        'Secondary text: #404A5F provides 7:1 ratio',
        'Badge text readable on all badge colors',
        'Green/red percentages meet 4.5:1 minimum'
      ]
    },
    { 
      category: 'Screen Reader',
      items: [
        'Company name announced first',
        'Price announced with currency',
        'Percentage includes direction (up/down)',
        'Badge status announced',
        'Market cap announced with context'
      ]
    },
    { 
      category: 'Visual Indicators',
      items: [
        'Color not sole indicator (+ and - signs)',
        'Badge shapes consistent',
        'Hover state provides visual feedback',
        'Interactive area clearly defined'
      ]
    },
    { 
      category: 'Touch & Click',
      items: [
        'Entire card is clickable',
        'Minimum 44px touch target',
        'No overlapping interactive areas',
        'Clear hover/focus states'
      ]
    },
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <p className="text-gray-400 mb-4">
          The Stock Card component is designed to be accessible to all users, including those using screen readers and keyboard navigation. Color is never the sole indicator of information.
        </p>

        <div className="grid md:grid-cols-2 gap-3 mb-4">
          {checks.map((check) => (
            <div key={check.category} className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
              <h3 className="font-semibold mb-3 flex items-center gap-2">
                <Check className="w-5 h-5 text-green-400" />
                {check.category}
              </h3>
              <ul className="text-sm text-gray-400 space-y-1">
                {check.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-teal-400 mt-1">•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <h2 className="text-xl font-semibold mb-4">ARIA Implementation</h2>
        <div className="glass-card bg-opacity-70 bg-gradient-to-br from-blue-950 to-indigo-950 rounded-xl border border-blue-900/30 overflow-hidden">
          <div className="flex items-center gap-3 px-5 py-3 border-b border-blue-900/30 bg-blue-950/50">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-white">Code Example</h3>
              <p className="text-xs text-gray-400">ARIA implementation</p>
            </div>
          </div>
          <div className="p-5 bg-gradient-to-br from-slate-950 to-blue-950/50">
            <pre className="text-sm overflow-x-auto">
              <code>
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">article</span>
                {'\n  '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"article"</span>
                {'\n  '}
                <span className="text-purple-400">aria-label</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"Tesla Inc. stock card"</span>
                {'\n  '}
                <span className="text-purple-400">tabindex</span>
                <span className="text-gray-500">=</span>
                <span className="text-orange-400">"0"</span>
                {'\n'}
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">img</span>
                {' '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"img"</span>
                {' '}
                <span className="text-purple-400">aria-label</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"Tesla logo"</span>
                {' '}
                <span className="text-gray-500">/&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">h3</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">Tesla Inc.</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">h3</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">p</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">Automotive</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">p</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">data</span>
                {' '}
                <span className="text-purple-400">value</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"248"</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">$248</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">data</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">span</span>
                {' '}
                <span className="text-purple-400">aria-label</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"Up 3.8 percent"</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">+3.8%</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">span</span>
                {' '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"status"</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">Hot Stock</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">Market Cap: $787B</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">article</span>
                <span className="text-gray-500">&gt;</span>
              </code>
            </pre>
          </div>
        </div>
      </section>
    </div>
  );
}

// ==========================================
// NAVIGATION BAR COMPONENTS - COMPLETE
// ==========================================

function NavBarPreview({ 
  tabs = 3,
  activeTab = 1,
  showIcons = true,
  showLabels = true,
  onTabChange = () => {}
}) {
  const tabData = [
    { icon: Home, label: 'Home' },
    { icon: TrendingUp, label: 'Market' },
    { icon: Users, label: 'Account' },
    { icon: Briefcase, label: 'Portfolio' },
    { icon: Settings, label: 'Settings' },
  ].slice(0, tabs);

  return (
    <div 
      className="flex items-start bg-white rounded-lg shadow-lg"
      style={{ padding: '8px 16px 20px' }}
    >
      {tabData.map((tab, index) => {
        const isActive = index + 1 === activeTab;
        const Icon = tab.icon;
        return (
          <button
            key={index}
            onClick={() => onTabChange(index + 1)}
            className="flex flex-col items-center flex-1"
            style={{ padding: '12px 8px', gap: '4px' }}
          >
            {showIcons && (
              <Icon 
                className="w-6 h-6" 
                style={{ 
                  color: isActive ? '#159A92' : '#050609',
                  strokeWidth: 2
                }} 
              />
            )}
            {showLabels && (
              <span 
                className="text-center w-full"
                style={{ 
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '12px',
                  lineHeight: '16px',
                  fontWeight: 400,
                  color: isActive ? '#159A92' : '#050609'
                }}
              >
                {tab.label}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

function NavBarOverview() {
  const [activeTab, setActiveTab] = useState(2);

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* Preview */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Preview</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md mx-auto space-y-4">
            <p className="text-sm text-gray-400 text-center mb-2">3 Tabs</p>
            <NavBarPreview tabs={3} activeTab={activeTab} onTabChange={setActiveTab} />
            <p className="text-sm text-gray-400 text-center mb-2 mt-6">4 Tabs</p>
            <NavBarPreview tabs={4} activeTab={1} />
            <p className="text-sm text-gray-400 text-center mb-2 mt-6">5 Tabs</p>
            <NavBarPreview tabs={5} activeTab={5} />
          </div>
        </div>
      </section>

      {/* When to Use */}
      <section>
        <h2 className="text-xl font-semibold mb-4">When to use</h2>
        <div className="grid md:grid-cols-2 gap-3">
          <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
            <h3 className="font-semibold text-green-400 mb-2 flex items-center gap-2">
              <Check className="w-5 h-5" />
              Do use when
            </h3>
            <ul className="text-sm text-gray-300 space-y-2">
              <li>• App has 3-5 main navigation destinations</li>
              <li>• Users need quick access to top-level views</li>
              <li>• Navigation should persist across screens</li>
              <li>• Building mobile-first experiences</li>
            </ul>
          </div>
          <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
            <h3 className="font-semibold text-red-400 mb-2 flex items-center gap-2">
              <X className="w-5 h-5" />
              Don't use when
            </h3>
            <ul className="text-sm text-gray-300 space-y-2">
              <li>• More than 5 navigation items needed</li>
              <li>• Content is the primary focus (use tabs instead)</li>
              <li>• Single-page or wizard flows</li>
              <li>• Desktop-only applications</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Key features</h2>
        <div className="grid md:grid-cols-3 gap-3">
          {[
            { title: 'Flexible Tabs', desc: 'Supports 3, 4, or 5 navigation items' },
            { title: 'Active States', desc: 'Clear visual indication of current section' },
            { title: 'Icon + Label', desc: 'Both can be shown or hidden independently' },
          ].map((feature) => (
            <div key={feature.title} className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
              <h3 className="font-semibold mb-1">{feature.title}</h3>
              <p className="text-sm text-gray-400">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function NavBarExamples() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* 3 Tabs */}
      <section>
        <h2 className="text-xl font-semibold mb-2">3 Tabs</h2>
        <p className="text-gray-400 mb-4">Minimal navigation for simple apps.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md mx-auto">
            <NavBarPreview tabs={3} activeTab={2} />
          </div>
        </div>
      </section>

      {/* 4 Tabs */}
      <section>
        <h2 className="text-xl font-semibold mb-2">4 Tabs</h2>
        <p className="text-gray-400 mb-4">Standard navigation for most apps.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md mx-auto">
            <NavBarPreview tabs={4} activeTab={1} />
          </div>
        </div>
      </section>

      {/* 5 Tabs */}
      <section>
        <h2 className="text-xl font-semibold mb-2">5 Tabs</h2>
        <p className="text-gray-400 mb-4">Maximum tabs for complex apps.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md mx-auto">
            <NavBarPreview tabs={5} activeTab={5} />
          </div>
        </div>
      </section>

      {/* Icons Only */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Icons Only</h2>
        <p className="text-gray-400 mb-4">Compact version without labels.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md mx-auto">
            <NavBarPreview tabs={4} activeTab={2} showLabels={false} />
          </div>
        </div>
      </section>

      {/* Different Active States */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Active States</h2>
        <p className="text-gray-400 mb-4">Each tab can be active independently.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md mx-auto space-y-4">
            <NavBarPreview tabs={4} activeTab={1} />
            <NavBarPreview tabs={4} activeTab={3} />
            <NavBarPreview tabs={4} activeTab={4} />
          </div>
        </div>
      </section>
    </div>
  );
}

function NavBarAnatomy() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-4">Component Structure</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-lg mx-auto">
            {/* Anatomy Diagram */}
            <div className="relative bg-white rounded-lg p-4" style={{ padding: '8px 16px 20px' }}>
              {/* Container Label */}
              <div className="absolute -top-3 left-4 bg-teal-500 text-white text-xs px-2 py-1 rounded">
                1. Container
              </div>
              
              <div className="flex items-start">
                {/* Tab 1 - Default */}
                <div className="flex flex-col items-center flex-1 relative" style={{ padding: '12px 8px', gap: '4px' }}>
                  <div className="absolute -top-1 -left-1 w-5 h-5 bg-purple-500 rounded-full flex items-center justify-center text-xs font-bold text-white">2</div>
                  <Home className="w-6 h-6" style={{ color: '#050609' }} />
                  <span style={{ fontSize: '12px', color: '#050609' }}>Home</span>
                </div>
                
                {/* Tab 2 - Active */}
                <div className="flex flex-col items-center flex-1 relative" style={{ padding: '12px 8px', gap: '4px' }}>
                  <div className="absolute -top-1 -right-1 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center text-xs font-bold text-white">3</div>
                  <TrendingUp className="w-6 h-6" style={{ color: '#159A92' }} />
                  <span style={{ fontSize: '12px', color: '#159A92' }}>Market</span>
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white text-xs px-2 py-0.5 rounded">Active</div>
                </div>
                
                {/* Tab 3 - Default */}
                <div className="flex flex-col items-center flex-1 relative" style={{ padding: '12px 8px', gap: '4px' }}>
                  <div className="absolute top-3 -right-1 w-5 h-5 bg-pink-500 rounded-full flex items-center justify-center text-xs font-bold text-white">4</div>
                  <Users className="w-6 h-6" style={{ color: '#050609' }} />
                  <span style={{ fontSize: '12px', color: '#050609' }}>Account</span>
                </div>
              </div>
            </div>
          </div>

          {/* Legend */}
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { num: 1, label: 'Container', color: 'bg-teal-500' },
              { num: 2, label: 'Tab Item', color: 'bg-purple-500' },
              { num: 3, label: 'Active State', color: 'bg-orange-500' },
              { num: 4, label: 'Icon + Label', color: 'bg-pink-500' },
            ].map((item) => (
              <div key={item.num} className="flex items-center gap-2">
                <div className={`w-6 h-6 ${item.color} rounded-full flex items-center justify-center text-xs font-bold`}>
                  {item.num}
                </div>
                <span className="text-sm text-gray-300">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Spacing */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Spacing</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
            <div><span className="text-gray-400">Container Padding:</span> <span className="text-teal-400">8px 16px 20px</span></div>
            <div><span className="text-gray-400">Tab Padding:</span> <span className="text-teal-400">12px 8px</span></div>
            <div><span className="text-gray-400">Icon-Label Gap:</span> <span className="text-teal-400">4px</span></div>
            <div><span className="text-gray-400">Icon Size:</span> <span className="text-teal-400">24px</span></div>
          </div>
        </div>
      </section>
    </div>
  );
}

function NavBarProps() {
  const props = [
    { name: 'tabs', type: 'number', default: '3', description: 'Number of tabs (3, 4, or 5)' },
    { name: 'activeTab', type: 'number', default: '1', description: 'Currently active tab index (1-based)' },
    { name: 'showIcons', type: 'boolean', default: 'true', description: 'Show/hide tab icons' },
    { name: 'showLabels', type: 'boolean', default: 'true', description: 'Show/hide tab labels' },
    { name: 'onTabChange', type: 'function', default: '() => {}', description: 'Callback when tab is clicked' },
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* Props Table */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Properties</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl border border-blue-900/30 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="glass-card bg-opacity-60 bg-blue-900">
              <tr>
                <th className="text-left p-4 font-semibold">Property</th>
                <th className="text-left p-4 font-semibold">Type</th>
                <th className="text-left p-4 font-semibold">Default</th>
                <th className="text-left p-4 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {props.map((prop) => (
                <tr key={prop.name}>
                  <td className="p-4 font-mono text-teal-400">{prop.name}</td>
                  <td className="p-4 font-mono text-purple-400">{prop.type}</td>
                  <td className="p-4 font-mono text-gray-400">{prop.default}</td>
                  <td className="p-4 text-gray-300">{prop.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Design Tokens */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Design Tokens</h2>
        <div className="grid md:grid-cols-2 gap-3">
          {/* Colors */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
            <h3 className="font-semibold mb-3">Colors</h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-center justify-between">
                <span className="text-gray-400">Background</span>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 rounded" style={{ backgroundColor: '#FFFFFF' }}></div>
                  <code className="text-gray-300">#FFFFFF</code>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-400">Default Text/Icon</span>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 rounded" style={{ backgroundColor: '#050609' }}></div>
                  <code className="text-gray-300">#050609</code>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-400">Active Text/Icon</span>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 rounded" style={{ backgroundColor: '#159A92' }}></div>
                  <code className="text-gray-300">#159A92</code>
                </div>
              </div>
            </div>
          </div>

          {/* Typography */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
            <h3 className="font-semibold mb-3">Typography</h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-center justify-between">
                <span className="text-gray-400">Font Family</span>
                <code className="text-gray-300">Inter</code>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-400">Font Size</span>
                <code className="text-gray-300">12px</code>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-400">Line Height</span>
                <code className="text-gray-300">16px</code>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-400">Font Weight</span>
                <code className="text-gray-300">400</code>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function NavBarBestPractices() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-4">Do's and Don'ts</h2>
        <div className="grid md:grid-cols-2 gap-4">
          {/* Do */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Check className="w-5 h-5 text-green-400" />
              <h3 className="font-semibold text-green-400">Do</h3>
            </div>
            <div className="space-y-4">
              <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
                <NavBarPreview tabs={4} activeTab={2} />
                <p className="text-sm text-gray-300 mt-3">Use 3-5 tabs for main navigation</p>
              </div>
              <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
                <NavBarPreview tabs={3} activeTab={1} />
                <p className="text-sm text-gray-300 mt-3">Use clear, recognizable icons</p>
              </div>
              <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
                <p className="text-sm text-gray-300">Keep labels short (1-2 words max)</p>
              </div>
            </div>
          </div>

          {/* Don't */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <X className="w-5 h-5 text-red-400" />
              <h3 className="font-semibold text-red-400">Don't</h3>
            </div>
            <div className="space-y-4">
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
                <NavBarPreview tabs={5} activeTab={1} showLabels={false} />
                <p className="text-sm text-gray-300 mt-3">Don't use icons only without tooltips</p>
              </div>
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
                <p className="text-sm text-gray-300">Don't use more than 5 tabs</p>
              </div>
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
                <p className="text-sm text-gray-300">Don't use very long labels that wrap</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function NavBarAccessibility() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <p className="text-gray-400 mb-4">
          The Navigation Bar component follows WCAG 2.1 guidelines and is designed to be accessible for all users including keyboard and screen reader users.
        </p>

        <div className="grid md:grid-cols-2 gap-3 mb-4">
          {[
            {
              category: 'Keyboard Navigation',
              items: ['Tab key moves between navigation items', 'Enter/Space activates the focused tab', 'Arrow keys can navigate between tabs']
            },
            {
              category: 'Screen Readers',
              items: ['Uses role="navigation" on container', 'Active tab announced with aria-current', 'Labels are readable and descriptive']
            },
            {
              category: 'Visual',
              items: ['Active state has sufficient color contrast', 'Focus indicators are clearly visible', 'Touch targets meet 44px minimum']
            },
            {
              category: 'Color Contrast',
              items: ['Default text: 19.6:1 (#050609 on #FFFFFF)', 'Active text: 4.8:1 (#159A92 on #FFFFFF)', 'Passes WCAG AA requirements']
            },
          ].map((check) => (
            <div key={check.category} className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
              <h3 className="font-semibold mb-3 flex items-center gap-2">
                <Check className="w-5 h-5 text-green-400" />
                {check.category}
              </h3>
              <ul className="text-sm text-gray-400 space-y-1">
                {check.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-teal-400 mt-1">•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ARIA Example */}
        <h2 className="text-xl font-semibold mb-4">ARIA Implementation</h2>
        <div className="glass-card bg-opacity-70 bg-gradient-to-br from-blue-950 to-indigo-950 rounded-xl border border-blue-900/30 overflow-hidden">
          <div className="flex items-center gap-3 px-5 py-3 border-b border-blue-900/30 bg-blue-950/50">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-white">Code Example</h3>
              <p className="text-xs text-gray-400">ARIA implementation</p>
            </div>
          </div>
          <div className="p-5 bg-gradient-to-br from-slate-950 to-blue-950/50">
            <pre className="text-sm overflow-x-auto">
              <code>
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">nav</span>
                {' '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"navigation"</span>
                {' '}
                <span className="text-purple-400">aria-label</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"Main navigation"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">ul</span>
                {' '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"tablist"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n    '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">li</span>
                {' '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"presentation"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n      '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">a</span>
                {' '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"tab"</span>
                {' '}
                <span className="text-purple-400">aria-selected</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"false"</span>
                {' '}
                <span className="text-purple-400">href</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"/home"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n        '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">svg</span>
                {' '}
                <span className="text-purple-400">aria-hidden</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true"</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">...</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">svg</span>
                <span className="text-gray-500">&gt;</span>
                {'\n        '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">Home</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                {'\n      '}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">a</span>
                <span className="text-gray-500">&gt;</span>
                {'\n    '}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">li</span>
                <span className="text-gray-500">&gt;</span>
                {'\n    '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">li</span>
                {' '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"presentation"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n      '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">a</span>
                {' '}
                <span className="text-purple-400">role</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"tab"</span>
                {' '}
                <span className="text-purple-400">aria-selected</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true"</span>
                {' '}
                <span className="text-purple-400">aria-current</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"page"</span>
                {' '}
                <span className="text-purple-400">href</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"/market"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n        '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">svg</span>
                {' '}
                <span className="text-purple-400">aria-hidden</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true"</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">...</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">svg</span>
                <span className="text-gray-500">&gt;</span>
                {'\n        '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">Market</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                {'\n      '}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">a</span>
                <span className="text-gray-500">&gt;</span>
                {'\n    '}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">li</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">ul</span>
                <span className="text-gray-500">&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">nav</span>
                <span className="text-gray-500">&gt;</span>
              </code>
            </pre>
          </div>
        </div>
      </section>
    </div>
  );
}


// ==========================================
// BUTTON COMPONENT
// ==========================================

// Button Preview Component
function ButtonPreview({ 
  children = "Button",
  variant = "primary",
  size = "medium",
  state = "default",
  iconLeft = false,
  iconRight = false,
  iconOnly = false,
  onClick = () => {}
}) {
  // Size configurations
  const sizes = {
    small: { padding: '6px', gap: '6px', iconSize: 20, fontSize: '12px' },
    medium: { padding: '8px', gap: '8px', iconSize: 24, fontSize: '12px' },
    large: { padding: '12px', gap: '12px', iconSize: 32, fontSize: '12px' },
  };

  // Variant color configurations
  const variants = {
    primary: {
      default: { bg: '#18B2A8', text: '#FFFFFF', border: 'none' },
      hover: { bg: '#159A92', text: '#FFFFFF', border: 'none' },
      disabled: { bg: '#E9EAEB', text: '#A4A7AE', border: 'none' },
    },
    'secondary-gray': {
      default: { bg: '#FFFFFF', text: '#293142', border: '1px solid #A4A7AE' },
      hover: { bg: '#E9EAEB', text: '#050609', border: '1px solid #A4A7AE' },
      disabled: { bg: '#E9EAEB', text: '#A4A7AE', border: '1px solid #D5D7DA' },
    },
    'secondary-colored': {
      default: { bg: '#FFFFFF', text: '#18B2A8', border: '1px solid #18B2A8' },
      hover: { bg: '#AEE8E4', text: '#117F78', border: '1px solid #117F78' },
      disabled: { bg: '#E9EAEB', text: '#A4A7AE', border: '1px solid #D5D7DA' },
    },
    'tertiary-gray': {
      default: { bg: 'transparent', text: '#293142', border: 'none' },
      hover: { bg: 'transparent', text: '#050609', border: 'none' },
      disabled: { bg: 'transparent', text: '#A4A7AE', border: 'none' },
    },
    'tertiary-colored': {
      default: { bg: 'transparent', text: '#18B2A8', border: 'none' },
      hover: { bg: '#AEE8E4', text: '#117F78', border: 'none' },
      disabled: { bg: 'transparent', text: '#A4A7AE', border: 'none' },
    },
    'link-gray': {
      default: { bg: 'transparent', text: '#293142', border: 'none', noPadding: true },
      hover: { bg: 'transparent', text: '#050609', border: 'none', noPadding: true },
      disabled: { bg: 'transparent', text: '#A4A7AE', border: 'none', noPadding: true },
    },
    'link-colored': {
      default: { bg: 'transparent', text: '#18B2A8', border: 'none', noPadding: true },
      hover: { bg: 'transparent', text: '#117F78', border: 'none', noPadding: true },
      disabled: { bg: 'transparent', text: '#A4A7AE', border: 'none', noPadding: true },
    },
  };

  const sizeConfig = sizes[size];
  const variantConfig = variants[variant][state];
  const isLink = variant.startsWith('link');

  const IconCircle = ({ size: iconSize }) => (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={variantConfig.text} strokeWidth="2"/>
    </svg>
  );

  return (
    <button
      onClick={onClick}
      disabled={state === 'disabled'}
      className="inline-flex items-center justify-center rounded-lg font-semibold transition-all"
      style={{
        padding: isLink ? '0' : sizeConfig.padding,
        gap: sizeConfig.gap,
        background: variantConfig.bg,
        color: variantConfig.text,
        border: variantConfig.border,
        fontSize: sizeConfig.fontSize,
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        lineHeight: '18px',
        cursor: state === 'disabled' ? 'not-allowed' : 'pointer',
        opacity: state === 'disabled' ? 1 : 1,
      }}
    >
      {(iconLeft || iconOnly) && <IconCircle size={sizeConfig.iconSize} />}
      {!iconOnly && <span>{children}</span>}
      {iconRight && !iconOnly && <IconCircle size={sizeConfig.iconSize} />}
    </button>
  );
}

// Button Overview
function ButtonOverview() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* Preview */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Preview</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="flex flex-wrap gap-3 items-center justify-center">
            <ButtonPreview variant="primary">Primary</ButtonPreview>
            <ButtonPreview variant="secondary-gray">Secondary Gray</ButtonPreview>
            <ButtonPreview variant="secondary-colored">Secondary Colored</ButtonPreview>
            <ButtonPreview variant="tertiary-gray">Tertiary Gray</ButtonPreview>
            <ButtonPreview variant="tertiary-colored">Tertiary Colored</ButtonPreview>
            <ButtonPreview variant="link-gray">Link Gray</ButtonPreview>
            <ButtonPreview variant="link-colored">Link Colored</ButtonPreview>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Overview</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <ul className="text-sm text-gray-300 space-y-2">
            <li>• Can contain an optional leading or trailing icon</li>
            <li>• Seven types: Primary, Secondary Gray, Secondary Colored, Tertiary Gray, Tertiary Colored, Link Gray, Link Colored</li>
            <li>• Keep labels concise</li>
            <li>• Containers have medium-rounded corners (8px border radius)</li>
            <li>• Three sizes: Small, Medium, Large</li>
          </ul>
        </div>
      </section>

      {/* When to Use */}
      <section>
        <h2 className="text-xl font-semibold mb-4">When to use</h2>
        <div className="grid md:grid-cols-2 gap-3">
          <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
            <h3 className="font-semibold text-green-400 mb-2 flex items-center gap-2">
              <Check className="w-5 h-5" />
              Do use when
            </h3>
            <ul className="text-sm text-gray-300 space-y-2">
              <li>• Triggering an action (submit, save, confirm)</li>
              <li>• Navigating to another page or view</li>
              <li>• Opening a modal or dialog</li>
              <li>• Initiating a process or workflow</li>
            </ul>
          </div>
          <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
            <h3 className="font-semibold text-red-400 mb-2 flex items-center gap-2">
              <X className="w-5 h-5" />
              Don't use when
            </h3>
            <ul className="text-sm text-gray-300 space-y-2">
              <li>• Navigating within text (use text links)</li>
              <li>• Displaying status or information</li>
              <li>• As a replacement for tabs or toggles</li>
              <li>• For decorative purposes only</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Variants Overview */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Variants</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {[
            { name: 'Primary', variant: 'primary', desc: 'Main action, high emphasis' },
            { name: 'Secondary Gray', variant: 'secondary-gray', desc: 'Supporting action, medium emphasis' },
            { name: 'Secondary Colored', variant: 'secondary-colored', desc: 'Brand-colored outline' },
            { name: 'Tertiary Gray', variant: 'tertiary-gray', desc: 'Low emphasis, no background' },
            { name: 'Tertiary Colored', variant: 'tertiary-colored', desc: 'Low emphasis with brand color' },
            { name: 'Link Gray', variant: 'link-gray', desc: 'Minimal, text-like appearance' },
            { name: 'Link Colored', variant: 'link-colored', desc: 'Minimal with brand color' },
          ].map((item) => (
            <div key={item.variant} className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
              <div className="mb-3">
                <ButtonPreview variant={item.variant}>{item.name.split(' ')[0]}</ButtonPreview>
              </div>
              <h3 className="font-semibold text-sm">{item.name}</h3>
              <p className="text-xs text-gray-400">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

// Button Examples
function ButtonExamples() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* Sizes */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Sizes</h2>
        <p className="text-gray-400 mb-4">Three size options for different contexts.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="flex flex-wrap items-center gap-4">
            <div className="text-center">
              <ButtonPreview size="small">Small</ButtonPreview>
              <p className="text-xs text-gray-400 mt-2">Small</p>
            </div>
            <div className="text-center">
              <ButtonPreview size="medium">Medium</ButtonPreview>
              <p className="text-xs text-gray-400 mt-2">Medium</p>
            </div>
            <div className="text-center">
              <ButtonPreview size="large">Large</ButtonPreview>
              <p className="text-xs text-gray-400 mt-2">Large</p>
            </div>
          </div>
        </div>
      </section>

      {/* States */}
      <section>
        <h2 className="text-xl font-semibold mb-2">States</h2>
        <p className="text-gray-400 mb-4">Different visual states for interaction feedback.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="space-y-4">
            {['primary', 'secondary-gray', 'secondary-colored'].map((variant) => (
              <div key={variant} className="flex flex-wrap items-center gap-3">
                <span className="text-sm text-gray-400 w-32 capitalize">{variant.replace('-', ' ')}</span>
                <ButtonPreview variant={variant} state="default">Default</ButtonPreview>
                <ButtonPreview variant={variant} state="hover">Hover</ButtonPreview>
                <ButtonPreview variant={variant} state="disabled">Disabled</ButtonPreview>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* With Icons */}
      <section>
        <h2 className="text-xl font-semibold mb-2">With Icons</h2>
        <p className="text-gray-400 mb-4">Buttons can include leading, trailing, or both icons.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="flex flex-wrap items-center gap-3">
            <ButtonPreview iconLeft>Left Icon</ButtonPreview>
            <ButtonPreview iconRight>Right Icon</ButtonPreview>
            <ButtonPreview iconLeft iconRight>Both Icons</ButtonPreview>
            <ButtonPreview iconOnly />
          </div>
        </div>
      </section>

      {/* All Variants with States */}
      <section>
        <h2 className="text-xl font-semibold mb-2">All Variants</h2>
        <p className="text-gray-400 mb-4">Complete overview of all button variants.</p>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-blue-800/20">
                <th className="text-left p-3">Variant</th>
                <th className="text-center p-3">Default</th>
                <th className="text-center p-3">Hover</th>
                <th className="text-center p-3">Disabled</th>
              </tr>
            </thead>
            <tbody>
              {['primary', 'secondary-gray', 'secondary-colored', 'tertiary-gray', 'tertiary-colored', 'link-gray', 'link-colored'].map((variant) => (
                <tr key={variant} className="border-b border-blue-900/30">
                  <td className="p-3 capitalize text-gray-300">{variant.replace(/-/g, ' ')}</td>
                  <td className="p-3 text-center"><ButtonPreview variant={variant} state="default">Button</ButtonPreview></td>
                  <td className="p-3 text-center"><ButtonPreview variant={variant} state="hover">Button</ButtonPreview></td>
                  <td className="p-3 text-center"><ButtonPreview variant={variant} state="disabled">Button</ButtonPreview></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

// Button Anatomy
function ButtonAnatomy() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-4">Component Structure</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="max-w-md mx-auto">
            {/* Anatomy Diagram */}
            <div className="relative bg-white rounded-lg p-4 inline-flex items-center gap-2" style={{ padding: '12px' }}>
              {/* Container Label */}
              <div className="absolute -top-3 left-2 bg-teal-500 text-white text-xs px-2 py-1 rounded">
                1. Container
              </div>
              
              {/* Left Icon */}
              <div className="relative">
                <div className="absolute -top-1 -left-1 w-5 h-5 bg-purple-500 rounded-full flex items-center justify-center text-xs font-bold text-white">2</div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#18B2A8" strokeWidth="2"/>
                </svg>
              </div>
              
              {/* Text */}
              <div className="relative">
                <div className="absolute -top-1 -right-1 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center text-xs font-bold text-white">3</div>
                <span style={{ color: '#18B2A8', fontWeight: 600, fontSize: '12px' }}>Button CTA</span>
              </div>
              
              {/* Right Icon */}
              <div className="relative">
                <div className="absolute -top-1 -right-1 w-5 h-5 bg-pink-500 rounded-full flex items-center justify-center text-xs font-bold text-white">4</div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#18B2A8" strokeWidth="2"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Legend */}
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { num: 1, label: 'Container', color: 'bg-teal-500' },
              { num: 2, label: 'Left Icon', color: 'bg-purple-500' },
              { num: 3, label: 'Label Text', color: 'bg-orange-500' },
              { num: 4, label: 'Right Icon', color: 'bg-pink-500' },
            ].map((item) => (
              <div key={item.num} className="flex items-center gap-2">
                <div className={`w-6 h-6 ${item.color} rounded-full flex items-center justify-center text-xs font-bold`}>
                  {item.num}
                </div>
                <span className="text-sm text-gray-300">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Spacing by Size */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Spacing by Size</h2>
        <div className="grid md:grid-cols-3 gap-3">
          {[
            { size: 'Small', padding: '6px', gap: '6px', icon: '20px', height: '32px' },
            { size: 'Medium', padding: '8px', gap: '8px', icon: '24px', height: '40px' },
            { size: 'Large', padding: '12px', gap: '12px', icon: '32px', height: '56px' },
          ].map((s) => (
            <div key={s.size} className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
              <h3 className="font-semibold mb-3">{s.size}</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-400">Padding</span>
                  <span className="text-teal-400">{s.padding}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Gap</span>
                  <span className="text-teal-400">{s.gap}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Icon Size</span>
                  <span className="text-teal-400">{s.icon}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Height</span>
                  <span className="text-teal-400">{s.height}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

// Button Props
function ButtonProps() {
  const props = [
    { name: 'variant', type: 'string', default: '"primary"', description: 'Button style: primary, secondary-gray, secondary-colored, tertiary-gray, tertiary-colored, link-gray, link-colored' },
    { name: 'size', type: 'string', default: '"medium"', description: 'Button size: small, medium, large' },
    { name: 'state', type: 'string', default: '"default"', description: 'Visual state: default, hover, disabled' },
    { name: 'iconLeft', type: 'boolean', default: 'false', description: 'Show icon on the left side' },
    { name: 'iconRight', type: 'boolean', default: 'false', description: 'Show icon on the right side' },
    { name: 'iconOnly', type: 'boolean', default: 'false', description: 'Show only icon without text' },
    { name: 'children', type: 'string', default: '"Button"', description: 'Button label text' },
    { name: 'onClick', type: 'function', default: '() => {}', description: 'Click handler function' },
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      {/* Props Table */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Properties</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl border border-blue-900/30 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="glass-card bg-opacity-60 bg-blue-900">
              <tr>
                <th className="text-left p-4 font-semibold">Property</th>
                <th className="text-left p-4 font-semibold">Type</th>
                <th className="text-left p-4 font-semibold">Default</th>
                <th className="text-left p-4 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {props.map((prop) => (
                <tr key={prop.name}>
                  <td className="p-4 font-mono text-teal-400">{prop.name}</td>
                  <td className="p-4 font-mono text-purple-400">{prop.type}</td>
                  <td className="p-4 font-mono text-gray-400">{prop.default}</td>
                  <td className="p-4 text-gray-300">{prop.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Design Tokens */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Design Tokens - Primary Button</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="space-y-3 text-sm">
            <div className="grid grid-cols-3 gap-3 pb-2 border-b border-blue-800/20 font-semibold">
              <span>Token</span>
              <span>Value</span>
              <span>Description</span>
            </div>
            {[
              { token: 'background-default', value: '#18B2A8', desc: 'Default background color' },
              { token: 'background-hover', value: '#159A92', desc: 'Hover background color' },
              { token: 'background-disabled', value: '#E9EAEB', desc: 'Disabled background color' },
              { token: 'text-default', value: '#FFFFFF', desc: 'Default text color' },
              { token: 'text-disabled', value: '#A4A7AE', desc: 'Disabled text color' },
              { token: 'border-radius', value: '8px', desc: 'Corner radius' },
            ].map((t) => (
              <div key={t.token} className="grid grid-cols-3 gap-3 items-center">
                <span className="text-gray-400">{t.token}</span>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 rounded" style={{ backgroundColor: t.value }}></div>
                  <code className="text-gray-300">{t.value}</code>
                </div>
                <span className="text-gray-400">{t.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Typography */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Typography</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
            <div>
              <span className="text-gray-400">Font Family</span>
              <p className="text-white font-medium">Inter</p>
            </div>
            <div>
              <span className="text-gray-400">Font Weight</span>
              <p className="text-white font-medium">600 (Semi Bold)</p>
            </div>
            <div>
              <span className="text-gray-400">Font Size</span>
              <p className="text-white font-medium">12px</p>
            </div>
            <div>
              <span className="text-gray-400">Line Height</span>
              <p className="text-white font-medium">18px</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

// Button Best Practices
function ButtonBestPractices() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <h2 className="text-xl font-semibold mb-4">Do's and Don'ts</h2>
        <div className="grid md:grid-cols-2 gap-4">
          {/* Do */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Check className="w-5 h-5 text-green-400" />
              <h3 className="font-semibold text-green-400">Do</h3>
            </div>
            <div className="space-y-4">
              <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
                <div className="mb-3 flex gap-2">
                  <ButtonPreview variant="primary">Submit</ButtonPreview>
                  <ButtonPreview variant="secondary-gray">Cancel</ButtonPreview>
                </div>
                <p className="text-sm text-gray-300">Use Primary for main action, Secondary for supporting</p>
              </div>
              <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
                <div className="mb-3">
                  <ButtonPreview iconRight>Next Step</ButtonPreview>
                </div>
                <p className="text-sm text-gray-300">Use icons to indicate direction or action</p>
              </div>
              <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4">
                <div className="mb-3">
                  <ButtonPreview state="disabled">Processing...</ButtonPreview>
                </div>
                <p className="text-sm text-gray-300">Use disabled state for unavailable actions</p>
              </div>
            </div>
          </div>

          {/* Don't */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <X className="w-5 h-5 text-red-400" />
              <h3 className="font-semibold text-red-400">Don't</h3>
            </div>
            <div className="space-y-4">
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
                <div className="mb-3">
                  <button className="px-4 py-2 bg-teal-500 text-white rounded-lg text-xs">
                    Click here to complete the registration process now
                  </button>
                </div>
                <p className="text-sm text-gray-300">Don't use long text labels</p>
              </div>
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
                <div className="mb-3">
                  <button className="px-2 py-2 bg-teal-500 text-white rounded-lg text-xs flex flex-col items-center">
                    <span>Review &</span>
                    <span>Confirm</span>
                  </button>
                </div>
                <p className="text-sm text-gray-300">Don't wrap text to multiple lines</p>
              </div>
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
                <div className="mb-3 flex gap-2">
                  <ButtonPreview variant="primary">Buy</ButtonPreview>
                  <button className="px-4 py-2 bg-pink-500 text-white rounded-lg text-xs font-semibold">Sell</button>
                </div>
                <p className="text-sm text-gray-300">Don't use contradictory colors that break brand identity</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Button Hierarchy */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Button Hierarchy</h2>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <div className="flex items-center gap-2">
              <span className="text-teal-400 font-bold">1.</span>
              <ButtonPreview variant="primary">Primary</ButtonPreview>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-teal-400 font-bold">2.</span>
              <ButtonPreview variant="secondary-gray">Secondary</ButtonPreview>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-teal-400 font-bold">3.</span>
              <ButtonPreview variant="tertiary-gray">Tertiary</ButtonPreview>
            </div>
          </div>
          <p className="text-sm text-gray-400">Use button hierarchy to guide users to the most important action</p>
        </div>
      </section>
    </div>
  );
}

// Button Accessibility
function ButtonAccessibility() {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section>
        <p className="text-gray-400 mb-4">
          The Button component follows WCAG 2.1 guidelines and ensures all users can interact with buttons effectively.
        </p>

        <div className="grid md:grid-cols-2 gap-3 mb-4">
          {[
            {
              category: 'Color Contrast',
              items: [
                'Primary: White on #18B2A8 = 3.5:1 (AA Large)',
                'Disabled states clearly distinguishable',
                'Focus states have visible indicators'
              ]
            },
            {
              category: 'Touch Targets',
              items: [
                'Small: 32px height (minimum)',
                'Medium: 40px height',
                'Large: 56px height (recommended)',
                'Minimum 44x44px clickable area'
              ]
            },
            {
              category: 'Keyboard Navigation',
              items: [
                'Tab key to focus',
                'Enter/Space to activate',
                'Visible focus indicator',
                'Disabled buttons not focusable'
              ]
            },
            {
              category: 'Screen Readers',
              items: [
                'Descriptive button text',
                'Icons have aria-hidden="true"',
                'Loading states announced',
                'Disabled state communicated'
              ]
            },
          ].map((check) => (
            <div key={check.category} className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-4 border border-blue-900/30">
              <h3 className="font-semibold mb-3 flex items-center gap-2">
                <Check className="w-5 h-5 text-green-400" />
                {check.category}
              </h3>
              <ul className="text-sm text-gray-400 space-y-1">
                {check.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-teal-400 mt-1">•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ARIA Example */}
        <h2 className="text-xl font-semibold mb-4">ARIA Implementation</h2>
        <div className="glass-card bg-opacity-70 bg-gradient-to-br from-blue-950 to-indigo-950 rounded-xl border border-blue-900/30 overflow-hidden">
          <div className="flex items-center gap-3 px-5 py-3 border-b border-blue-900/30 bg-blue-950/50">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-white">Code Examples</h3>
              <p className="text-xs text-gray-400">ARIA implementation patterns</p>
            </div>
          </div>
          <div className="p-5 bg-gradient-to-br from-slate-950 to-blue-950/50">
            <pre className="text-sm overflow-x-auto">
              <code>
                <span className="text-gray-500">&lt;!--</span>
                <span className="text-gray-400"> Standard Button </span>
                <span className="text-gray-500">--&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">button</span>
                {' '}
                <span className="text-purple-400">type</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"button"</span>
                {' '}
                <span className="text-purple-400">class</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"btn-primary"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-white">Submit Form</span>
                {'\n'}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">button</span>
                <span className="text-gray-500">&gt;</span>
                {'\n\n'}
                <span className="text-gray-500">&lt;!--</span>
                <span className="text-gray-400"> Button with Icon </span>
                <span className="text-gray-500">--&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">button</span>
                {' '}
                <span className="text-purple-400">type</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"button"</span>
                {' '}
                <span className="text-purple-400">class</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"btn-primary"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">svg</span>
                {' '}
                <span className="text-purple-400">aria-hidden</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true"</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">...</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">svg</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">Continue</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">button</span>
                <span className="text-gray-500">&gt;</span>
                {'\n\n'}
                <span className="text-gray-500">&lt;!--</span>
                <span className="text-gray-400"> Icon Only Button </span>
                <span className="text-gray-500">--&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">button</span>
                {' '}
                <span className="text-purple-400">type</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"button"</span>
                {' '}
                <span className="text-purple-400">class</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"btn-icon"</span>
                {' '}
                <span className="text-purple-400">aria-label</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"Settings"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">svg</span>
                {' '}
                <span className="text-purple-400">aria-hidden</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true"</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">...</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">svg</span>
                <span className="text-gray-500">&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">button</span>
                <span className="text-gray-500">&gt;</span>
                {'\n\n'}
                <span className="text-gray-500">&lt;!--</span>
                <span className="text-gray-400"> Disabled Button </span>
                <span className="text-gray-500">--&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">button</span>
                {' '}
                <span className="text-purple-400">type</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"button"</span>
                {' '}
                <span className="text-purple-400">class</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"btn-primary"</span>
                {' '}
                <span className="text-purple-400">disabled</span>
                {' '}
                <span className="text-purple-400">aria-disabled</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-white">Unavailable</span>
                {'\n'}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">button</span>
                <span className="text-gray-500">&gt;</span>
                {'\n\n'}
                <span className="text-gray-500">&lt;!--</span>
                <span className="text-gray-400"> Loading Button </span>
                <span className="text-gray-500">--&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">button</span>
                {' '}
                <span className="text-purple-400">type</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"button"</span>
                {' '}
                <span className="text-purple-400">class</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"btn-primary"</span>
                {' '}
                <span className="text-purple-400">aria-busy</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true"</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">span</span>
                {' '}
                <span className="text-purple-400">class</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"spinner"</span>
                {' '}
                <span className="text-purple-400">aria-hidden</span>
                <span className="text-gray-500">=</span>
                <span className="text-green-400">"true"</span>
                <span className="text-gray-500">&gt;&lt;/</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                {'\n  '}
                <span className="text-gray-500">&lt;</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                <span className="text-white">Processing...</span>
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">span</span>
                <span className="text-gray-500">&gt;</span>
                {'\n'}
                <span className="text-gray-500">&lt;/</span>
                <span className="text-blue-400">button</span>
                <span className="text-gray-500">&gt;</span>
              </code>
            </pre>
          </div>
        </div>
      </section>
    </div>
  );
}

function IntroductionPage({ setActiveSection, setActiveTab }) {
  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <section className="glass-card bg-gradient-to-br from-teal-500/20 to-purple-500/20 rounded-xl p-5 border border-blue-900/30">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-purple-500 rounded-2xl flex items-center justify-center">
            <Layers className="w-10 h-10 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold">Momentum Design System</h2>
            <p className="text-gray-400">Version 1.0.0 · Updated January 2026</p>
          </div>
        </div>
        <p className="text-gray-300 text-lg leading-relaxed">
          A comprehensive design system featuring foundations, components, and team collaboration. 
          Built to create consistent, accessible, and beautiful user experiences with a focus on design excellence and creative innovation.
        </p>
      </section>

      <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30 text-center">
          <div className="w-12 h-12 mx-auto mb-3 bg-teal-500/20 rounded-lg flex items-center justify-center">
            <Box className="w-7 h-7 text-teal-400" />
          </div>
          <div className="text-3xl font-bold text-white mb-1">4</div>
          <div className="text-sm text-gray-400">Components</div>
        </div>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30 text-center">
          <div className="w-12 h-12 mx-auto mb-3 bg-purple-500/20 rounded-lg flex items-center justify-center">
            <Star className="w-7 h-7 text-purple-400" />
          </div>
          <div className="text-3xl font-bold text-white mb-1">4</div>
          <div className="text-sm text-gray-400">Foundations</div>
        </div>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30 text-center">
          <div className="w-12 h-12 mx-auto mb-3 bg-blue-500/20 rounded-lg flex items-center justify-center">
            <Users className="w-7 h-7 text-blue-400" />
          </div>
          <div className="text-3xl font-bold text-white mb-1">10</div>
          <div className="text-sm text-gray-400">Team Members</div>
        </div>
        <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30 text-center">
          <div className="w-12 h-12 mx-auto mb-3 bg-green-500/20 rounded-lg flex items-center justify-center">
            <Check className="w-7 h-7 text-green-400" />
          </div>
          <div className="text-3xl font-bold text-white mb-1">WCAG 2.1</div>
          <div className="text-sm text-gray-400">Accessibility</div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">What's Included</h2>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-teal-500/20 rounded-lg flex items-center justify-center">
                <Star className="w-6 h-6 text-teal-400" />
              </div>
              <h3 className="font-semibold">Foundations</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Comprehensive color system with light/dark modes, typography with Inter & Outfit fonts, and spacing tokens for consistent layouts.
            </p>
          </div>
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center">
                <Box className="w-6 h-6 text-purple-400" />
              </div>
              <h3 className="font-semibold">Components</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Ready-to-use UI components including List Items, Stock Cards, Navigation Bars, and Buttons with multiple variants and states.
            </p>
          </div>
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-orange-500/20 rounded-lg flex items-center justify-center">
                <BookOpen className="w-6 h-6 text-orange-400" />
              </div>
              <h3 className="font-semibold">Documentation</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Comprehensive guides with 6 tabs per component covering overview, examples, anatomy, props, best practices, and accessibility.
            </p>
          </div>
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center">
                <Users className="w-6 h-6 text-blue-400" />
              </div>
              <h3 className="font-semibold">Team</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Meet the talented 10-member design team behind this system, featuring creative layouts and collaborative excellence.
            </p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Design Principles</h2>
        <div className="space-y-5">
          <div className="flex gap-3 items-start">
            <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">1</div>
            <div>
              <h3 className="font-semibold mb-1">Consistency</h3>
              <p className="text-gray-400 text-sm">Every component follows the same design language, creating a unified experience across all touchpoints.</p>
            </div>
          </div>
          <div className="flex gap-3 items-start">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">2</div>
            <div>
              <h3 className="font-semibold mb-1">Accessibility</h3>
              <p className="text-gray-400 text-sm">Designed for everyone. We ensure proper contrast ratios, touch targets, and screen reader support.</p>
            </div>
          </div>
          <div className="flex gap-3 items-start">
            <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-fuchsia-500 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">3</div>
            <div>
              <h3 className="font-semibold mb-1">Performance</h3>
              <p className="text-gray-400 text-sm">Lightweight components that load fast and respond instantly to user interactions.</p>
            </div>
          </div>
          <div className="flex gap-3 items-start">
            <div className="w-8 h-8 bg-gradient-to-br from-pink-500 to-rose-500 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">4</div>
            <div>
              <h3 className="font-semibold mb-1">Flexibility</h3>
              <p className="text-gray-400 text-sm">Components are customizable through props and variants to fit various use cases.</p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Available Components</h2>
        <div className="grid md:grid-cols-1 gap-4">
          <button 
            onClick={() => { setActiveSection('list-item'); setActiveTab('overview'); }}
            className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30 hover:border-teal-500/50 transition-all cursor-pointer text-left group w-full"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-teal-500/20 flex items-center justify-center group-hover:bg-teal-500/30 transition-colors">
                  <Layers className="w-6 h-6 text-teal-400" />
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">List Item</h3>
                  <p className="text-sm text-gray-400">User profiles, portfolio managers with ratings</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-teal-400 transition-colors" />
            </div>
          </button>
          
          <button 
            onClick={() => { setActiveSection('stock-card'); setActiveTab('overview'); }}
            className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30 hover:border-teal-500/50 transition-all cursor-pointer text-left group w-full"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-teal-500/20 flex items-center justify-center group-hover:bg-teal-500/30 transition-colors">
                  <TrendingUp className="w-6 h-6 text-teal-400" />
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Stock Card</h3>
                  <p className="text-sm text-gray-400">Stock info with price and performance</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-teal-400 transition-colors" />
            </div>
          </button>
          
          <button 
            onClick={() => { setActiveSection('navigation-bar'); setActiveTab('overview'); }}
            className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30 hover:border-teal-500/50 transition-all cursor-pointer text-left group w-full"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-teal-500/20 flex items-center justify-center group-hover:bg-teal-500/30 transition-colors">
                  <Menu className="w-6 h-6 text-teal-400" />
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Navigation Bar</h3>
                  <p className="text-sm text-gray-400">Bottom navigation with 3-5 tabs</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-teal-400 transition-colors" />
            </div>
          </button>
          
          <button 
            onClick={() => { setActiveSection('button'); setActiveTab('overview'); }}
            className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-5 border border-blue-900/30 hover:border-teal-500/50 transition-all cursor-pointer text-left group w-full"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-teal-500/20 flex items-center justify-center group-hover:bg-teal-500/30 transition-colors">
                  <Box className="w-6 h-6 text-teal-400" />
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Button</h3>
                  <p className="text-sm text-gray-400">7 variants, 3 sizes, multiple states</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-teal-400 transition-colors" />
            </div>
          </button>
        </div>
      </section>
    </div>
  );
}

// ==========================================
// FOUNDATIONS PAGES
// ==========================================

// ==========================================
// COLORS PAGES
// ==========================================

function ColorsOverview() {
  return (
    <div className="space-y-8 max-w-5xl mx-auto">
      <section>
        <h2 className="text-2xl font-semibold mb-4">Color System Overview</h2>
        <p className="text-gray-400 mb-6">
          The Momentum Design System uses a comprehensive color palette organized into three main categories.
        </p>

        <div className="space-y-6">
          {/* Primitive Colors */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-teal-500 to-blue-500 flex-shrink-0"></div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Primitive Colors</h3>
                <p className="text-gray-300 mb-3">
                  Foundation color palette that forms the basis of our design system. These are raw color values organized by color families.
                </p>
                <ul className="text-sm text-gray-400 space-y-1">
                  <li>• Brand colors (100-900)</li>
                  <li>• Gray scale (100-900)</li>
                  <li>• Blue, Green, Red, Orange, Purple palettes</li>
                  <li>• Base colors (Black & White)</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Semantic Colors */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex-shrink-0"></div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Semantic Colors</h3>
                <p className="text-gray-300 mb-3">
                  Contextual colors mapped to specific use cases and meaning. These colors communicate state, feedback, and hierarchy.
                </p>
                <ul className="text-sm text-gray-400 space-y-1">
                  <li>• Background colors (primary, secondary, brand)</li>
                  <li>• Text colors (primary, secondary, brand, status)</li>
                  <li>• Border colors (primary, brand, status)</li>
                  <li>• Icon colors (primary, secondary, status)</li>
                  <li>• Status colors (success, error, warning, info)</li>
                  <li>• Support for light and dark modes</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Component Colors */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-orange-500 to-red-500 flex-shrink-0"></div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Component Colors</h3>
                <p className="text-gray-300 mb-3">
                  Specific color applications for UI components. These ensure consistency across all interface elements.
                </p>
                <ul className="text-sm text-gray-400 space-y-1">
                  <li>• Button colors (primary, secondary, tertiary)</li>
                  <li>• Interactive states (default, hover, disabled)</li>
                  <li>• Component-specific variations</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Usage Guidelines */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-xl font-semibold mb-6">Usage Guidelines</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-teal-500/10 border border-teal-500/30 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-teal-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-5 h-5 text-teal-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-2">Start with Semantic Colors</h4>
                    <p className="text-sm text-gray-300">
                      When building UI, always use semantic color tokens (e.g., background-primary) rather than primitive colors directly.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-blue-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-5 h-5 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-2">Use Primitive Colors For</h4>
                    <p className="text-sm text-gray-300">
                      Brand identities, illustrations, and custom one-off designs where semantic meaning doesn't apply.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-purple-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-5 h-5 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-2">Component Colors</h4>
                    <p className="text-sm text-gray-300">
                      Pre-defined color combinations for specific components to ensure visual consistency across all elements.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-5 h-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-2">Accessibility First</h4>
                    <p className="text-sm text-gray-300">
                      All color combinations meet WCAG 2.1 AA standards for contrast ratios, ensuring readability for all users.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function ColorsPrimitive() {
  const brandColors = [
    { name: 'Brand 100', color: '#d7f4f2' },
    { name: 'Brand 200', color: '#aee8e4' },
    { name: 'Brand 300', color: '#85dbd5' },
    { name: 'Brand 400', color: '#5ccfc7' },
    { name: 'Brand 500 (Base)', color: '#159a92' },
    { name: 'Brand 600', color: '#117f78' },
    { name: 'Brand 700', color: '#0c6460' },
    { name: 'Brand 800', color: '#084b47' },
    { name: 'Brand 900', color: '#052e2c' },
  ];

  const grayColors = [
    { name: 'Gray 100', color: '#f5f5f5' },
    { name: 'Gray 200', color: '#e9eaeb' },
    { name: 'Gray 300', color: '#d5d7da' },
    { name: 'Gray 400', color: '#a4a7ae' },
    { name: 'Gray 450', color: '#717680' },
    { name: 'Gray 500 (Base)', color: '#666e7f' },
    { name: 'Gray 550', color: '#666666' },
    { name: 'Gray 600', color: '#4f5663' },
    { name: 'Gray 700', color: '#404a5f' },
    { name: 'Gray 800', color: '#252b37' },
    { name: 'Gray 900', color: '#181d27' },
  ];

  const blueColors = [
    { name: 'Blue 50', color: '#eaf2fb' },
    { name: 'Blue 100', color: '#d1e9ff' },
    { name: 'Blue 200', color: '#b2ddff' },
    { name: 'Blue 300', color: '#84caff' },
    { name: 'Blue 400', color: '#53b0fd' },
    { name: 'Blue 500 (Base)', color: '#156fee' },
    { name: 'Blue 600', color: '#175cd3' },
    { name: 'Blue 700', color: '#1849a9' },
    { name: 'Blue 800', color: '#194084' },
    { name: 'Blue 900', color: '#112c5a' },
    { name: 'Blue 950', color: '#101828' },
  ];

  const redColors = [
    { name: 'Red 100', color: '#fee4e2' },
    { name: 'Red 200', color: '#fecdca' },
    { name: 'Red 300', color: '#fca19b' },
    { name: 'Red 400', color: '#f97066' },
    { name: 'Red 500 (Base)', color: '#f04437' },
    { name: 'Red 550', color: '#ff0808' },
    { name: 'Red 600', color: '#d92c20' },
    { name: 'Red 700', color: '#b42318' },
    { name: 'Red 800', color: '#912018' },
    { name: 'Red 900', color: '#501911' },
  ];

  const orangeColors = [
    { name: 'Orange 50', color: '#fff5ea' },
    { name: 'Orange 100', color: '#fef0c7' },
    { name: 'Orange 200', color: '#fedf89' },
    { name: 'Orange 300', color: '#ffd452' },
    { name: 'Orange 350', color: '#facd15' },
    { name: 'Orange 400', color: '#fdb022' },
    { name: 'Orange 500 (Base)', color: '#f79009' },
    { name: 'Orange 600', color: '#dc6803' },
    { name: 'Orange 700', color: '#b54707' },
    { name: 'Orange 800', color: '#93370c' },
    { name: 'Orange 900', color: '#4e1d09' },
  ];

  const greenColors = [
    { name: 'Green 50', color: '#ebf6f1' },
    { name: 'Green 100', color: '#dcfae6' },
    { name: 'Green 200', color: '#a9efc5' },
    { name: 'Green 300', color: '#75dfa6' },
    { name: 'Green 400', color: '#47cd89' },
    { name: 'Green 500 (Base)', color: '#069454' },
    { name: 'Green 600', color: '#067647' },
    { name: 'Green 700', color: '#085d3a' },
    { name: 'Green 800', color: '#074c30' },
    { name: 'Green 900', color: '#053321' },
  ];

  const purpleColors = [
    { name: 'Purple 100', color: '#f3e8ff' },
    { name: 'Purple 200', color: '#dc88ff' },
    { name: 'Purple 300', color: '#cb77ff' },
    { name: 'Purple 400', color: '#bd69ff' },
    { name: 'Purple 500 (Base)', color: '#a753f7' },
  ];

  const ColorGrid = ({ title, colors }) => (
    <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {colors.map((item) => (
          <div key={item.name} className="flex flex-col gap-2">
            <div 
              className="w-full h-16 rounded-lg border border-gray-700/30" 
              style={{ backgroundColor: item.color }}
            ></div>
            <div>
              <p className="text-sm font-semibold text-white">{item.name}</p>
              <p className="text-xs text-gray-400 uppercase">{item.color}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <ColorGrid title="Brand Colors" colors={brandColors} />
      <ColorGrid title="Gray Colors" colors={grayColors} />
      <ColorGrid title="Blue Colors" colors={blueColors} />
      <ColorGrid title="Green Colors" colors={greenColors} />
      <ColorGrid title="Red Colors" colors={redColors} />
      <ColorGrid title="Orange Colors" colors={orangeColors} />
      <ColorGrid title="Purple Colors" colors={purpleColors} />

      <section className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Base Colors</h3>
        <div className="grid grid-cols-2 gap-4">
          <div className="flex items-center gap-3">
            <div className="w-16 h-16 rounded-lg border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
            <div>
              <p className="font-semibold">White</p>
              <p className="text-sm text-gray-400">#FFFFFF</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-16 h-16 rounded-lg border border-gray-700" style={{ backgroundColor: '#000000' }}></div>
            <div>
              <p className="font-semibold">Black</p>
              <p className="text-sm text-gray-400">#000000</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function ColorsSemantic() {
  const [mode, setMode] = useState('light');

  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <section>
        <p className="text-gray-400 mb-6">
          Semantic colors provide meaning and context across the design system. These colors support both light and dark modes.
        </p>
      </section>

      {/* Mode Toggle */}
      <div className="flex justify-center mb-6">
        <div className="inline-flex rounded-lg bg-blue-950/50 border border-blue-900/30 p-1">
          <button
            onClick={() => setMode('light')}
            className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${
              mode === 'light'
                ? 'bg-blue-500/20 text-blue-400 border border-blue-500/30'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            ☀️ Light Mode
          </button>
          <button
            onClick={() => setMode('dark')}
            className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${
              mode === 'dark'
                ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            🌙 Dark Mode
          </button>
        </div>
      </div>

      {mode === 'light' && (
        <>
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-lg font-semibold mb-4">Background Colors - Light Mode</h3>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-300">Primary</h4>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
              <div>
                <p className="text-xs font-semibold">Default</p>
                <p className="text-xs text-gray-400">#ffffff</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#f5f5f5' }}></div>
              <div>
                <p className="text-xs font-semibold">Hover</p>
                <p className="text-xs text-gray-400">#f5f5f5</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-300">Secondary</h4>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#f5f5f5' }}></div>
              <div>
                <p className="text-xs font-semibold">Default</p>
                <p className="text-xs text-gray-400">#f5f5f5</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#e9eaeb' }}></div>
              <div>
                <p className="text-xs font-semibold">Hover</p>
                <p className="text-xs text-gray-400">#e9eaeb</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-300">Brand</h4>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
              <div>
                <p className="text-xs font-semibold">Solid</p>
                <p className="text-xs text-gray-400">#159a92</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#d7f4f2' }}></div>
              <div>
                <p className="text-xs font-semibold">Default</p>
                <p className="text-xs text-gray-400">#d7f4f2</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Text Colors - Light Mode</h3>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#050609' }}></div>
              <div>
                <p className="text-xs font-semibold">Primary</p>
                <p className="text-xs text-gray-400">#050609</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#404a5f' }}></div>
              <div>
                <p className="text-xs font-semibold">Secondary</p>
                <p className="text-xs text-gray-400">#404a5f</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#4f5663' }}></div>
              <div>
                <p className="text-xs font-semibold">Tertiary</p>
                <p className="text-xs text-gray-400">#4f5663</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
              <div>
                <p className="text-xs font-semibold">Brand</p>
                <p className="text-xs text-gray-400">#159a92</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#a4a7ae' }}></div>
              <div>
                <p className="text-xs font-semibold">Disabled</p>
                <p className="text-xs text-gray-400">#a4a7ae</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Border Colors - Light Mode</h3>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#e9eaeb' }}></div>
              <div>
                <p className="text-xs font-semibold">Primary</p>
                <p className="text-xs text-gray-400">#e9eaeb</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#d5d7da' }}></div>
              <div>
                <p className="text-xs font-semibold">Secondary</p>
                <p className="text-xs text-gray-400">#d5d7da</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
              <div>
                <p className="text-xs font-semibold">Brand</p>
                <p className="text-xs text-gray-400">#159a92</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#050609' }}></div>
              <div>
                <p className="text-xs font-semibold">Focused</p>
                <p className="text-xs text-gray-400">#050609</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#d5d7da' }}></div>
              <div>
                <p className="text-xs font-semibold">Disabled</p>
                <p className="text-xs text-gray-400">#d5d7da</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Status Colors - Light Mode</h3>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="space-y-3">
            <h4 className="text-sm font-semibold text-green-400 mb-2">Success</h4>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#069454' }}></div>
              <div>
                <p className="text-sm">Default</p>
                <p className="text-xs text-gray-400">#069454</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#ebf6f1' }}></div>
              <div>
                <p className="text-sm">Background</p>
                <p className="text-xs text-gray-400">#ebf6f1</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#75dfa6' }}></div>
              <div>
                <p className="text-sm">Border Subtle</p>
                <p className="text-xs text-gray-400">#75dfa6</p>
              </div>
            </div>
          </div>
          <div className="space-y-3">
            <h4 className="text-sm font-semibold text-red-400 mb-2">Error</h4>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#f04437' }}></div>
              <div>
                <p className="text-sm">Default</p>
                <p className="text-xs text-gray-400">#f04437</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#fee4e2' }}></div>
              <div>
                <p className="text-sm">Background</p>
                <p className="text-xs text-gray-400">#fee4e2</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#fca19b' }}></div>
              <div>
                <p className="text-sm">Border Subtle</p>
                <p className="text-xs text-gray-400">#fca19b</p>
              </div>
            </div>
          </div>
          <div className="space-y-3">
            <h4 className="text-sm font-semibold text-orange-400 mb-2">Warning</h4>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#f79009' }}></div>
              <div>
                <p className="text-sm">Default</p>
                <p className="text-xs text-gray-400">#f79009</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#fff5ea' }}></div>
              <div>
                <p className="text-sm">Background</p>
                <p className="text-xs text-gray-400">#fff5ea</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#fec84b' }}></div>
              <div>
                <p className="text-sm">Border Subtle</p>
                <p className="text-xs text-gray-400">#fec84b</p>
              </div>
            </div>
          </div>
          <div className="space-y-3">
            <h4 className="text-sm font-semibold text-blue-400 mb-2">Info</h4>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#156fee' }}></div>
              <div>
                <p className="text-sm">Default</p>
                <p className="text-xs text-gray-400">#156fee</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#eaf2fb' }}></div>
              <div>
                <p className="text-sm">Background</p>
                <p className="text-xs text-gray-400">#eaf2fb</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded" style={{ backgroundColor: '#84caff' }}></div>
              <div>
                <p className="text-sm">Border Subtle</p>
                <p className="text-xs text-gray-400">#84caff</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Icon Colors - Light Mode</h3>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#050609' }}></div>
              <div>
                <p className="text-xs font-semibold">Primary</p>
                <p className="text-xs text-gray-400">#050609</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#666e7f' }}></div>
              <div>
                <p className="text-xs font-semibold">Secondary</p>
                <p className="text-xs text-gray-400">#666e7f</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#404a5f' }}></div>
              <div>
                <p className="text-xs font-semibold">Tertiary</p>
                <p className="text-xs text-gray-400">#404a5f</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
              <div>
                <p className="text-xs font-semibold">Brand</p>
                <p className="text-xs text-gray-400">#159a92</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#d5d7da' }}></div>
              <div>
                <p className="text-xs font-semibold">Disabled</p>
                <p className="text-xs text-gray-400">#d5d7da</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Additional Background States - Light Mode</h3>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-300 mb-2">Primary</h4>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#050609' }}></div>
              <div>
                <p className="text-xs font-semibold">Solid</p>
                <p className="text-xs text-gray-400">#050609</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#d5d7da' }}></div>
              <div>
                <p className="text-xs font-semibold">Disabled</p>
                <p className="text-xs text-gray-400">#d5d7da</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#050609' }}></div>
              <div>
                <p className="text-xs font-semibold">Focus</p>
                <p className="text-xs text-gray-400">#050609</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-300 mb-2">Secondary</h4>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#293142' }}></div>
              <div>
                <p className="text-xs font-semibold">Solid</p>
                <p className="text-xs text-gray-400">#293142</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#e9eaeb' }}></div>
              <div>
                <p className="text-xs font-semibold">Hover</p>
                <p className="text-xs text-gray-400">#e9eaeb</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-300 mb-2">Brand</h4>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#117f78' }}></div>
              <div>
                <p className="text-xs font-semibold">Solid Hover</p>
                <p className="text-xs text-gray-400">#117f78</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#aee8e4' }}></div>
              <div>
                <p className="text-xs font-semibold">Default Hover</p>
                <p className="text-xs text-gray-400">#aee8e4</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Additional Text States - Light Mode</h3>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#293142' }}></div>
              <div>
                <p className="text-xs font-semibold">Primary Hover</p>
                <p className="text-xs text-gray-400">#293142</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#293142' }}></div>
              <div>
                <p className="text-xs font-semibold">Secondary Hover</p>
                <p className="text-xs text-gray-400">#293142</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#d5d7da' }}></div>
              <div>
                <p className="text-xs font-semibold">Secondary Disabled</p>
                <p className="text-xs text-gray-400">#d5d7da</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#0c6460' }}></div>
              <div>
                <p className="text-xs font-semibold">Brand Hover</p>
                <p className="text-xs text-gray-400">#0c6460</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
              <div>
                <p className="text-xs font-semibold">Primary Inverse</p>
                <p className="text-xs text-gray-400">#ffffff</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#717680' }}></div>
              <div>
                <p className="text-xs font-semibold">Primary Focus</p>
                <p className="text-xs text-gray-400">#717680</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Heading Colors - Light Mode</h3>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#101828' }}></div>
              <div>
                <p className="text-xs font-semibold">Heading Primary</p>
                <p className="text-xs text-gray-400">#101828</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#717680' }}></div>
              <div>
                <p className="text-xs font-semibold">Heading Secondary</p>
                <p className="text-xs text-gray-400">#717680</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Asset Colors (Purple) - Light Mode</h3>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#f3e8ff' }}></div>
              <div>
                <p className="text-xs font-semibold">Default</p>
                <p className="text-xs text-gray-400">#f3e8ff</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#a753f7' }}></div>
              <div>
                <p className="text-xs font-semibold">Solid</p>
                <p className="text-xs text-gray-400">#a753f7</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#dc88ff' }}></div>
              <div>
                <p className="text-xs font-semibold">Hover</p>
                <p className="text-xs text-gray-400">#dc88ff</p>
              </div>
            </div>
          </div>
        </div>
      </div>
        </>
      )}

      {mode === 'dark' && (
        <>
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-lg font-semibold mb-4">Background Colors - Dark Mode</h3>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="space-y-2">
                <h4 className="text-sm font-semibold text-gray-300">Primary</h4>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#181d27' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Default</p>
                    <p className="text-xs text-gray-400">#181d27</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#293142' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Hover</p>
                    <p className="text-xs text-gray-400">#293142</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <h4 className="text-sm font-semibold text-gray-300">Secondary</h4>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#404a5f' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Default</p>
                    <p className="text-xs text-gray-400">#404a5f</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#4f5663' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Hover</p>
                    <p className="text-xs text-gray-400">#4f5663</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <h4 className="text-sm font-semibold text-gray-300">Brand</h4>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Solid</p>
                    <p className="text-xs text-gray-400">#159a92</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#293142' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Default</p>
                    <p className="text-xs text-gray-400">#293142</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-lg font-semibold mb-4">Text Colors - Dark Mode</h3>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Primary</p>
                    <p className="text-xs text-gray-400">#ffffff</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#f5f5f5' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Secondary</p>
                    <p className="text-xs text-gray-400">#f5f5f5</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#a4a7ae' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Tertiary</p>
                    <p className="text-xs text-gray-400">#a4a7ae</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Brand</p>
                    <p className="text-xs text-gray-400">#159a92</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#a4a7ae' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Disabled</p>
                    <p className="text-xs text-gray-400">#a4a7ae</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-lg font-semibold mb-4">Status Colors - Dark Mode</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="space-y-3">
                <h4 className="text-sm font-semibold text-green-400 mb-2">Success</h4>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded" style={{ backgroundColor: '#069454' }}></div>
                  <div>
                    <p className="text-sm">Default</p>
                    <p className="text-xs text-gray-400">#069454</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded" style={{ backgroundColor: '#053321' }}></div>
                  <div>
                    <p className="text-sm">Background</p>
                    <p className="text-xs text-gray-400">#053321</p>
                  </div>
                </div>
              </div>
              <div className="space-y-3">
                <h4 className="text-sm font-semibold text-red-400 mb-2">Error</h4>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded" style={{ backgroundColor: '#f04437' }}></div>
                  <div>
                    <p className="text-sm">Default</p>
                    <p className="text-xs text-gray-400">#f04437</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded" style={{ backgroundColor: '#fee4e2' }}></div>
                  <div>
                    <p className="text-sm">Background</p>
                    <p className="text-xs text-gray-400">#fee4e2</p>
                  </div>
                </div>
              </div>
              <div className="space-y-3">
                <h4 className="text-sm font-semibold text-orange-400 mb-2">Warning</h4>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded" style={{ backgroundColor: '#f79009' }}></div>
                  <div>
                    <p className="text-sm">Default</p>
                    <p className="text-xs text-gray-400">#f79009</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded" style={{ backgroundColor: '#93370c' }}></div>
                  <div>
                    <p className="text-sm">Background</p>
                    <p className="text-xs text-gray-400">#93370c</p>
                  </div>
                </div>
              </div>
              <div className="space-y-3">
                <h4 className="text-sm font-semibold text-blue-400 mb-2">Info</h4>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded" style={{ backgroundColor: '#1849a9' }}></div>
                  <div>
                    <p className="text-sm">Solid</p>
                    <p className="text-xs text-gray-400">#1849a9</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded" style={{ backgroundColor: '#112c5a' }}></div>
                  <div>
                    <p className="text-sm">Background</p>
                    <p className="text-xs text-gray-400">#112c5a</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-lg font-semibold mb-4">Border Colors - Dark Mode</h3>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#666e7f' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Primary</p>
                    <p className="text-xs text-gray-400">#666e7f</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Secondary</p>
                    <p className="text-xs text-gray-400">#ffffff</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Brand</p>
                    <p className="text-xs text-gray-400">#159a92</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-lg font-semibold mb-4">Heading Colors - Dark Mode</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Heading Primary</p>
                    <p className="text-xs text-gray-400">#ffffff</p>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
                  <div>
                    <p className="text-xs font-semibold">Heading Secondary</p>
                    <p className="text-xs text-gray-400">#ffffff</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

function ColorsComponent() {
  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <section>
        <p className="text-gray-400 mb-6">
          Pre-defined color combinations for UI components to ensure visual consistency and adherence to design standards.
        </p>
      </section>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Button Colors</h3>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-300 mb-2">Primary Button</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: '#159a92' }}></div>
                <div>
                  <p className="text-sm font-semibold">Background Default</p>
                  <p className="text-xs text-gray-400">#159a92</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: '#117f78' }}></div>
                <div>
                  <p className="text-sm font-semibold">Background Hover</p>
                  <p className="text-xs text-gray-400">#117f78</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: '#d5d7da' }}></div>
                <div>
                  <p className="text-sm font-semibold">Background Disabled</p>
                  <p className="text-xs text-gray-400">#d5d7da</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
                <div>
                  <p className="text-sm font-semibold">Text On Brand</p>
                  <p className="text-xs text-gray-400">#ffffff</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: '#159a92' }}></div>
                <div>
                  <p className="text-sm font-semibold">Icon Default</p>
                  <p className="text-xs text-gray-400">#159a92</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
                <div>
                  <p className="text-sm font-semibold">Icon Inverse</p>
                  <p className="text-xs text-gray-400">#ffffff</p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-300 mb-2">Secondary Button</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded border border-gray-700" style={{ backgroundColor: '#ffffff' }}></div>
                <div>
                  <p className="text-sm font-semibold">Background Default</p>
                  <p className="text-xs text-gray-400">#ffffff</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: '#e9eaeb' }}></div>
                <div>
                  <p className="text-sm font-semibold">Border Default</p>
                  <p className="text-xs text-gray-400">#e9eaeb</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: '#404a5f' }}></div>
                <div>
                  <p className="text-sm font-semibold">Text Default</p>
                  <p className="text-xs text-gray-400">#404a5f</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: '#d5d7da' }}></div>
                <div>
                  <p className="text-sm font-semibold">Icon Default</p>
                  <p className="text-xs text-gray-400">#d5d7da</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-blue-900/30">
          <h4 className="text-sm font-semibold text-gray-300 mb-3">Text Colors</h4>
          <div className="grid md:grid-cols-3 gap-3">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
              <div>
                <p className="text-xs font-semibold">Primary Default</p>
                <p className="text-xs text-gray-400">#159a92</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded" style={{ backgroundColor: '#159a92' }}></div>
              <div>
                <p className="text-xs font-semibold">Primary Link</p>
                <p className="text-xs text-gray-400">#159a92</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-4">Usage Examples</h3>
        <div className="space-y-4">
          <div>
            <p className="text-sm font-semibold mb-2 text-gray-300">Primary Button Example</p>
            <div className="flex gap-3">
              <button className="px-4 py-2 rounded-lg font-medium" style={{ backgroundColor: '#159a92', color: '#ffffff' }}>
                Primary Default
              </button>
              <button className="px-4 py-2 rounded-lg font-medium" style={{ backgroundColor: '#117f78', color: '#ffffff' }}>
                Primary Hover
              </button>
              <button className="px-4 py-2 rounded-lg font-medium opacity-50 cursor-not-allowed" style={{ backgroundColor: '#d5d7da', color: '#ffffff' }}>
                Primary Disabled
              </button>
            </div>
          </div>
          <div>
            <p className="text-sm font-semibold mb-2 text-gray-300">Secondary Button Example</p>
            <div className="flex gap-3">
              <button className="px-4 py-2 rounded-lg font-medium border" style={{ backgroundColor: '#ffffff', color: '#404a5f', borderColor: '#e9eaeb' }}>
                Secondary Default
              </button>
              <button className="px-4 py-2 rounded-lg font-medium border" style={{ backgroundColor: '#f5f5f5', color: '#404a5f', borderColor: '#e9eaeb' }}>
                Secondary Hover
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function TypographyPage() {
  const [activeFont, setActiveFont] = useState('inter');

  return (
    <div className="space-y-8 max-w-5xl mx-auto">
      {/* Font Family Toggle */}
      <div className="flex justify-center mb-8">
        <div className="inline-flex rounded-lg bg-blue-950/50 border border-blue-900/30 p-1">
          <button
            onClick={() => setActiveFont('inter')}
            className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${
              activeFont === 'inter'
                ? 'bg-teal-500/20 text-teal-400 border border-teal-500/30'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            Inter Font Family
          </button>
          <button
            onClick={() => setActiveFont('outfit')}
            className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${
              activeFont === 'outfit'
                ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            Outfit Font Family
          </button>
        </div>
      </div>

      {activeFont === 'inter' && (
        <>
          {/* Inter - Headings */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-teal-500 to-blue-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">H</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Headings - Inter Bold</h3>
                <p className="text-sm text-gray-400">Display and heading styles</p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="border-l-4 border-teal-500 pl-4">
                <p className="text-[72px] font-bold leading-none mb-2" style={{ fontFamily: 'Inter' }}>The Future</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-teal-400 font-semibold">Heading/3xl</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">72px / Bold</span>
                </div>
              </div>

              <div className="border-l-4 border-teal-500 pl-4">
                <p className="text-[60px] font-bold leading-none mb-2" style={{ fontFamily: 'Inter' }}>Innovation</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-teal-400 font-semibold">Heading/2xl</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">60px / Bold</span>
                </div>
              </div>

              <div className="border-l-4 border-blue-500 pl-4">
                <p className="text-[48px] font-bold leading-tight mb-2" style={{ fontFamily: 'Inter' }}>Excellence</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-blue-400 font-semibold">Heading/xl</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">48px / Bold</span>
                </div>
              </div>

              <div className="border-l-4 border-blue-500 pl-4">
                <p className="text-[40px] font-bold leading-tight mb-2" style={{ fontFamily: 'Inter' }}>Design System</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-blue-400 font-semibold">Heading/md</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">40px / Bold</span>
                </div>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <p className="text-[36px] font-bold leading-tight mb-2" style={{ fontFamily: 'Inter' }}>Typography</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-indigo-400 font-semibold">Heading/lg</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">36px / Bold</span>
                </div>
              </div>

              <div className="border-l-4 border-purple-500 pl-4">
                <p className="text-[30px] font-bold leading-tight mb-2" style={{ fontFamily: 'Inter' }}>Components</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-purple-400 font-semibold">Heading/sm</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">30px / Bold</span>
                </div>
              </div>

              <div className="border-l-4 border-pink-500 pl-4">
                <p className="text-[24px] font-bold leading-tight mb-2" style={{ fontFamily: 'Inter' }}>Interface</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-pink-400 font-semibold">Heading/xs</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">24px / Bold</span>
                </div>
              </div>
            </div>
          </div>

          {/* Inter - Body Text */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-green-500 to-teal-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Body Text - Inter Medium</h3>
                <p className="text-sm text-gray-400">Paragraph and content styles</p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="bg-green-500/5 border border-green-500/20 rounded-lg p-4">
                <p className="text-[24px] font-medium mb-2" style={{ fontFamily: 'Inter' }}>
                  Large body text for important content sections and introductions.
                </p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-green-400 font-semibold">Body/24</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">24px / Medium</span>
                </div>
              </div>

              <div className="bg-emerald-500/5 border border-emerald-500/20 rounded-lg p-4">
                <p className="text-[20px] font-medium mb-2" style={{ fontFamily: 'Inter' }}>
                  Extra large text perfect for featured content and highlighted information that needs emphasis.
                </p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-emerald-400 font-semibold">Body/xl</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">20px / Medium</span>
                </div>
              </div>

              <div className="bg-teal-500/5 border border-teal-500/20 rounded-lg p-4">
                <p className="text-[18px] font-medium mb-2" style={{ fontFamily: 'Inter' }}>
                  Large body text ideal for main content areas, ensuring comfortable reading experience across different screen sizes.
                </p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-teal-400 font-semibold">Body/lg</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">18px / Medium</span>
                </div>
              </div>

              <div className="bg-cyan-500/5 border border-cyan-500/20 rounded-lg p-4">
                <p className="text-[16px] font-medium mb-2" style={{ fontFamily: 'Inter' }}>
                  Standard body text size used for most interface content, descriptions, and general text elements throughout the application.
                </p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-cyan-400 font-semibold">Body/md</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">16px / Medium</span>
                </div>
              </div>

              <div className="bg-blue-500/5 border border-blue-500/20 rounded-lg p-4">
                <p className="text-[14px] font-medium mb-2" style={{ fontFamily: 'Inter' }}>
                  Small body text for secondary information, captions, and supporting details that complement the main content.
                </p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-blue-400 font-semibold">Body/sm</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">14px / Medium</span>
                </div>
              </div>
            </div>
          </div>

          {/* Inter - Body Bold Variants */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Body Bold Variants - Inter</h3>
                <p className="text-sm text-gray-400">Emphasized text styles</p>
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-orange-500/5 border border-orange-500/20 rounded-lg p-4">
                <p className="text-[20px] font-bold mb-2" style={{ fontFamily: 'Inter' }}>
                  Bold Extra Large
                </p>
                <p className="text-sm text-gray-400 mb-2">Body/xl (B) • 20px / Bold</p>
                <p className="text-xs text-gray-500">For strong emphasis on larger text</p>
              </div>

              <div className="bg-amber-500/5 border border-amber-500/20 rounded-lg p-4">
                <p className="text-[18px] font-normal mb-2" style={{ fontFamily: 'Inter' }}>
                  Regular Large
                </p>
                <p className="text-sm text-gray-400 mb-2">Body/lg (B) • 18px / Regular</p>
                <p className="text-xs text-gray-500">For normal weight large text</p>
              </div>

              <div className="bg-yellow-500/5 border border-yellow-500/20 rounded-lg p-4">
                <p className="text-[16px] font-bold mb-2" style={{ fontFamily: 'Inter' }}>
                  Bold Medium
                </p>
                <p className="text-sm text-gray-400 mb-2">Body/md (B) • 16px / Bold</p>
                <p className="text-xs text-gray-500">For emphasized standard text</p>
              </div>

              <div className="bg-lime-500/5 border border-lime-500/20 rounded-lg p-4">
                <p className="text-[14px] font-bold mb-2" style={{ fontFamily: 'Inter' }}>
                  Bold Small
                </p>
                <p className="text-sm text-gray-400 mb-2">Body/sm (B) • 14px / Bold</p>
                <p className="text-xs text-gray-500">For emphasized smaller text</p>
              </div>
            </div>
          </div>

          {/* Inter - Labels */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-pink-500 to-rose-500 flex items-center justify-center">
                <span className="text-white font-bold text-sm">L</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Labels - Inter</h3>
                <p className="text-sm text-gray-400">Form and UI labels</p>
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="bg-pink-500/5 border border-pink-500/20 rounded-lg p-4">
                  <div className="space-y-2">
                    <p className="text-[12px] font-normal text-gray-400" style={{ fontFamily: 'Inter' }}>USERNAME</p>
                    <input 
                      type="text" 
                      placeholder="Enter username" 
                      className="w-full bg-blue-950/50 border border-blue-900/30 rounded px-3 py-2 text-white"
                    />
                  </div>
                  <p className="text-xs text-gray-400 mt-3">Label/label • 12px / Regular</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-rose-500/5 border border-rose-500/20 rounded-lg p-4">
                  <div className="space-y-2">
                    <p className="text-[12px] font-bold text-gray-200" style={{ fontFamily: 'Inter' }}>PASSWORD</p>
                    <input 
                      type="password" 
                      placeholder="Enter password" 
                      className="w-full bg-blue-950/50 border border-blue-900/30 rounded px-3 py-2 text-white"
                    />
                  </div>
                  <p className="text-xs text-gray-400 mt-3">Label/label (B) • 12px / Bold</p>
                </div>
              </div>
            </div>
          </div>

          {/* Special Body Style */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-violet-500 to-purple-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">S</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Special Style</h3>
                <p className="text-sm text-gray-400">Unique text treatment</p>
              </div>
            </div>
            
            <div className="bg-violet-500/5 border border-violet-500/20 rounded-lg p-6">
              <p className="text-[30px] font-semibold mb-2" style={{ fontFamily: 'Inter' }}>
                Premium Content Heading
              </p>
              <div className="flex items-center gap-4 text-sm">
                <span className="text-violet-400 font-semibold">Body1/30</span>
                <span className="text-gray-400">•</span>
                <span className="text-gray-400">30px / Semi Bold</span>
              </div>
            </div>
          </div>
        </>
      )}

      {activeFont === 'outfit' && (
        <>
          {/* Outfit - Headings */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">O</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Outfit Font Family</h3>
                <p className="text-sm text-gray-400">Display headings and special text</p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="border-l-4 border-purple-500 pl-4">
                <p className="text-[60px] font-semibold leading-none mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Welcome</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-purple-400 font-semibold">Heading1/60</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">60px / SemiBold</span>
                </div>
              </div>

              <div className="border-l-4 border-fuchsia-500 pl-4">
                <p className="text-[56px] font-semibold leading-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Transform</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-fuchsia-400 font-semibold">Heading1/56</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">56px / SemiBold</span>
                </div>
              </div>

              <div className="border-l-4 border-pink-500 pl-4">
                <p className="text-[32px] font-medium leading-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Create Something Amazing</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-pink-400 font-semibold">Heading1/32</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">32px / Medium</span>
                </div>
              </div>

              <div className="border-l-4 border-rose-500 pl-4">
                <p className="text-[24px] font-semibold leading-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Beautiful Interfaces</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-rose-400 font-semibold">Heading1/24</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">24px / SemiBold</span>
                </div>
              </div>

              <div className="border-l-4 border-red-500 pl-4">
                <p className="text-[20px] font-semibold leading-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Elegant Design</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-red-400 font-semibold">Heading1/20</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">20px / SemiBold</span>
                </div>
              </div>
            </div>
          </div>

          {/* Outfit - Body Text */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Body Text - Outfit Regular</h3>
                <p className="text-sm text-gray-400">Content and paragraph styles</p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="bg-indigo-500/5 border border-indigo-500/20 rounded-lg p-4">
                <p className="text-[32px] font-normal mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  Large display text for hero sections
                </p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-indigo-400 font-semibold">Body1/32</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">32px / Regular</span>
                </div>
              </div>

              <div className="bg-purple-500/5 border border-purple-500/20 rounded-lg p-4">
                <p className="text-[20px] font-normal mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  Comfortable reading size for featured content and important messages that deserve attention.
                </p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-purple-400 font-semibold">Body1/20</span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-400">20px / Regular</span>
                </div>
              </div>
            </div>
          </div>

          {/* Usage Example */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-lg font-semibold mb-6">Outfit in Action</h3>
            
            <div className="bg-gradient-to-br from-purple-500/10 to-pink-500/10 border border-purple-500/20 rounded-xl p-8">
              <p className="text-[56px] font-semibold leading-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Stock Market
              </p>
              <p className="text-[20px] font-normal text-gray-300 mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Track your investments with confidence and make informed decisions with real-time data.
              </p>
              <button className="px-6 py-3 bg-purple-500 hover:bg-purple-600 rounded-lg text-white font-semibold transition-colors">
                Get Started
              </button>
            </div>
          </div>
        </>
      )}

      {/* Typography Best Practices */}
      <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-lg font-semibold mb-6">Best Practices</h3>
        
        <div className="grid md:grid-cols-2 gap-4">
          <div className="bg-green-500/5 border border-green-500/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-1">
                <Check className="w-4 h-4 text-green-400" />
              </div>
              <div>
                <p className="font-semibold text-green-400 mb-1">Use Inter for UI</p>
                <p className="text-sm text-gray-400">Inter is optimized for interface text and ensures excellent readability at all sizes.</p>
              </div>
            </div>
          </div>

          <div className="bg-green-500/5 border border-green-500/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-1">
                <Check className="w-4 h-4 text-green-400" />
              </div>
              <div>
                <p className="font-semibold text-green-400 mb-1">Use Outfit for Impact</p>
                <p className="text-sm text-gray-400">Outfit works beautifully for hero sections and marketing content.</p>
              </div>
            </div>
          </div>

          <div className="bg-green-500/5 border border-green-500/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-1">
                <Check className="w-4 h-4 text-green-400" />
              </div>
              <div>
                <p className="font-semibold text-green-400 mb-1">Maintain Hierarchy</p>
                <p className="text-sm text-gray-400">Use consistent heading scales to create clear visual hierarchy.</p>
              </div>
            </div>
          </div>

          <div className="bg-green-500/5 border border-green-500/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-1">
                <Check className="w-4 h-4 text-green-400" />
              </div>
              <div>
                <p className="font-semibold text-green-400 mb-1">Line Length</p>
                <p className="text-sm text-gray-400">Keep body text between 45-75 characters per line for optimal readability.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SpacingPage() {
  const [activeCategory, setActiveCategory] = useState('primitive');

  return (
    <div className="space-y-8 max-w-5xl mx-auto">
      {/* Category Toggle */}
      <div className="flex justify-center mb-8">
        <div className="inline-flex rounded-lg bg-blue-950/50 border border-blue-900/30 p-1">
          <button
            onClick={() => setActiveCategory('primitive')}
            className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${
              activeCategory === 'primitive'
                ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            Primitive Scale
          </button>
          <button
            onClick={() => setActiveCategory('semantic')}
            className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${
              activeCategory === 'semantic'
                ? 'bg-teal-500/20 text-teal-400 border border-teal-500/30'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            Semantic Spacing
          </button>
        </div>
      </div>

      {activeCategory === 'primitive' && (
        <>
          {/* Primitive Scale */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">P</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Primitive Scale</h3>
                <p className="text-sm text-gray-400">Base spacing values</p>
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 gap-3">
              {[
                { name: '0', px: '0px' },
                { name: '1', px: '1px' },
                { name: '2', px: '2px' },
                { name: '4', px: '4px' },
                { name: '6', px: '6px' },
                { name: '8', px: '8px' },
                { name: '10', px: '10px' },
                { name: '12', px: '12px' },
                { name: '14', px: '14px' },
                { name: '16', px: '16px' },
                { name: '20', px: '20px' },
                { name: '24', px: '24px' },
                { name: '32', px: '32px' },
                { name: '40', px: '40px' },
                { name: '120', px: '120px' },
                { name: '343', px: '343px' },
                { name: '758', px: '758px' },
                { name: '999', px: '999px' },
                { name: '1024', px: '1024px' },
                { name: '1440', px: '1440px' },
              ].map((scale) => (
                <div key={scale.name} className="bg-purple-500/5 border border-purple-500/20 rounded-lg p-3 flex items-center justify-between">
                  <div>
                    <p className="text-sm font-semibold text-purple-400">scale/{scale.name}</p>
                    <p className="text-xs text-gray-500">Primitive value</p>
                  </div>
                  <p className="text-sm font-mono text-white">{scale.px}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Usage Info */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <h3 className="text-lg font-semibold mb-4">Usage Guidelines</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-green-400" />
                </div>
                <div>
                  <p className="font-semibold text-green-400 mb-1">Use Semantic Tokens</p>
                  <p className="text-sm text-gray-400">Always prefer semantic spacing tokens (xs, sm, md, etc.) over primitive values in your designs.</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-green-400" />
                </div>
                <div>
                  <p className="font-semibold text-green-400 mb-1">Consistent Spacing</p>
                  <p className="text-sm text-gray-400">Use the same spacing value for similar elements to create visual consistency.</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-green-400" />
                </div>
                <div>
                  <p className="font-semibold text-green-400 mb-1">Visual Hierarchy</p>
                  <p className="text-sm text-gray-400">Increase spacing between sections to establish clear visual separation and hierarchy.</p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {activeCategory === 'semantic' && (
        <>
          {/* Semantic Spacing */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-teal-500 to-blue-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">S</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Spacing Scale</h3>
                <p className="text-sm text-gray-400">Semantic spacing tokens</p>
              </div>
            </div>
            
            <div className="space-y-4">
              {[
                { name: 'none', value: 'scale/0', px: '0px', color: 'from-gray-500 to-gray-600' },
                { name: 'xxs', value: 'scale/2', px: '2px', color: 'from-teal-500 to-teal-600' },
                { name: 'xs', value: 'scale/4', px: '4px', color: 'from-teal-500 to-cyan-500' },
                { name: 'sm', value: 'scale/6', px: '6px', color: 'from-cyan-500 to-blue-500' },
                { name: 'md', value: 'scale/8', px: '8px', color: 'from-blue-500 to-indigo-500' },
                { name: 'lg', value: 'scale/12', px: '12px', color: 'from-indigo-500 to-purple-500' },
                { name: 'xl', value: 'scale/16', px: '16px', color: 'from-purple-500 to-fuchsia-500' },
                { name: '2xl', value: 'scale/20', px: '20px', color: 'from-fuchsia-500 to-pink-500' },
                { name: '3xl', value: 'scale/24', px: '24px', color: 'from-pink-500 to-rose-500' },
                { name: '4xl', value: 'scale/32', px: '32px', color: 'from-rose-500 to-red-500' },
                { name: '5xl', value: 'scale/40', px: '40px', color: 'from-red-500 to-orange-500' },
              ].map((space) => (
                <div key={space.name} className="flex items-center gap-4 group hover:bg-blue-900/20 p-3 rounded-lg transition-colors">
                  <div className="w-16">
                    <span className="text-sm font-semibold text-teal-400">{space.name}</span>
                  </div>
                  <div className="flex-1 flex items-center gap-3">
                    <div 
                      className={`h-8 bg-gradient-to-r ${space.color} rounded`} 
                      style={{ width: space.px }}
                    ></div>
                    <span className="text-sm text-gray-400">{space.px}</span>
                  </div>
                  <div className="text-xs text-gray-500">{space.value}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Border Radius */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-green-500 to-emerald-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">R</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Border Radius</h3>
                <p className="text-sm text-gray-400">Corner rounding values</p>
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              {[
                { name: 'none', value: 'scale/0', px: '0px' },
                { name: '3xs', value: 'scale/2', px: '2px' },
                { name: '2xs', value: 'scale/4', px: '4px' },
                { name: 'xs', value: 'scale/6', px: '6px' },
                { name: 'sm', value: 'scale/12', px: '12px' },
                { name: 'md', value: 'scale/16', px: '16px' },
                { name: 'lg', value: 'scale/10', px: '10px' },
                { name: 'xl', value: 'scale/12', px: '12px' },
                { name: '3xl', value: 'scale/16', px: '16px' },
                { name: 'full', value: 'scale/999', px: '999px' },
              ].map((radius) => (
                <div key={radius.name} className="bg-green-500/5 border border-green-500/20 rounded-lg p-4">
                  <div className="flex items-center gap-4 mb-3">
                    <div 
                      className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500" 
                      style={{ borderRadius: radius.px }}
                    ></div>
                    <div>
                      <p className="text-sm font-semibold text-green-400">{radius.name}</p>
                      <p className="text-xs text-gray-400">{radius.px}</p>
                    </div>
                  </div>
                  <p className="text-xs text-gray-500">{radius.value}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Border Width */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Border Width</h3>
                <p className="text-sm text-gray-400">Border thickness values</p>
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              {[
                { name: 'none', value: 'scale/0', px: '0px' },
                { name: '3xs', value: 'scale/1', px: '1px' },
                { name: '2xs', value: 'scale/2', px: '2px' },
                { name: 'xs', value: 'scale/4', px: '4px' },
              ].map((border) => (
                <div key={border.name} className="bg-orange-500/5 border border-orange-500/20 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <p className="text-sm font-semibold text-orange-400">{border.name}</p>
                      <p className="text-xs text-gray-400">{border.px}</p>
                    </div>
                    <div 
                      className="w-20 h-12 rounded bg-blue-950/50" 
                      style={{ border: `${border.px} solid rgb(251, 146, 60)` }}
                    ></div>
                  </div>
                  <p className="text-xs text-gray-500">{border.value}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Icon Size */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">I</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Icon Size</h3>
                <p className="text-sm text-gray-400">Standard icon dimensions</p>
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              {[
                { name: 'xs', value: 'scale/16', px: '16px' },
                { name: 'sm', value: 'scale/20', px: '20px' },
                { name: 'md', value: 'scale/24', px: '24px' },
                { name: 'lg', value: 'scale/32', px: '32px' },
              ].map((icon) => (
                <div key={icon.name} className="bg-purple-500/5 border border-purple-500/20 rounded-lg p-4 flex items-center gap-4">
                  <div 
                    className="rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center flex-shrink-0" 
                    style={{ width: icon.px, height: icon.px }}
                  >
                    <Star className="text-white" style={{ width: `calc(${icon.px} * 0.6)`, height: `calc(${icon.px} * 0.6)` }} />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-purple-400">{icon.name}</p>
                    <p className="text-xs text-gray-400">{icon.px}</p>
                    <p className="text-xs text-gray-500">{icon.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Responsive Sizes */}
          <div className="glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center">
                <span className="text-white font-bold text-lg">📱</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Responsive</h3>
                <p className="text-sm text-gray-400">Breakpoint dimensions</p>
              </div>
            </div>
            
            <div className="space-y-3">
              {[
                { name: 'xs', value: 'scale/343', px: '343px', desc: 'Mobile small' },
                { name: 'sm', value: 'scale/768', px: '768px', desc: 'Tablet' },
                { name: 'md', value: 'scale/1024', px: '1024px', desc: 'Desktop small' },
                { name: 'xlg', value: 'scale/1440', px: '1440px', desc: 'Desktop large' },
              ].map((breakpoint) => (
                <div key={breakpoint.name} className="bg-blue-500/5 border border-blue-500/20 rounded-lg p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-semibold text-blue-400">{breakpoint.name}</p>
                      <p className="text-xs text-gray-500">{breakpoint.desc}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-sm font-mono text-white">{breakpoint.px}</p>
                      <p className="text-xs text-gray-500">{breakpoint.value}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}





// Developer Handoff Page
function DevHandoffPage() {
  const [copiedItem, setCopiedItem] = useState(null);
  const [expandedSections, setExpandedSections] = useState({
    lightColors: false,
    darkColors: false,
    spacing: true,
    typography: true
  });
  
  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  
  const copyToClipboard = async (text, item) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedItem(item);
      setTimeout(() => setCopiedItem(null), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopiedItem(item);
        setTimeout(() => setCopiedItem(null), 2000);
      } catch (e) {
        console.error('Fallback copy failed:', e);
      }
      document.body.removeChild(textArea);
    }
  };

  const tokens = {
    colors: `{
  "light": {
    "border-info-subtle": "#84caff",
    "border-info-default": "#156fee",
    "border-success-subtle": "#75dfa6",
    "border-warning-default": "#f79009",
    "background-info-solid": "#156fee",
    "background-info-default-hover": "#b2ddff",
    "text-info-hover": "#194084",
    "text-info-default": "#112c5a",
    "border-error-default": "#f04437",
    "border-primary-default": "#e9eaeb",
    "border-brand-default": "#159a92",
    "icon-error-default": "#f04437",
    "icon-warning-default": "#f79009",
    "icon-brand-hover": "#0c6460",
    "background-info-default": "#eaf2fb",
    "icon-brand-default": "#159a92",
    "icon-secondary-default": "#666e7f",
    "background-brand-default": "#d7f4f2",
    "text-error-default-hover": "#b42318",
    "text-error-default": "#f04437",
    "text-info-on-solid": "#156fee",
    "icon-primary-inverse": "#ffffff",
    "background-error-default-hover": "#fecdca",
    "text-warning-default-hover": "#b54707",
    "icon-primary-default": "#050609",
    "text-warning-default": "#f79009",
    "text-brand-default": "#159a92",
    "text-tertiary-default": "#4f5663",
    "background-info-solid-hover": "#175cd3",
    "text-secondary-inverse": "#dcfae6",
    "border-warning-subtle": "#fec84b",
    "text-secondary-disabled": "#d5d7da",
    "icon-info-default": "#156fee",
    "text-secondary-default": "#404a5f",
    "text-primary-hover": "#293142",
    "text-secondary-hover": "#293142",
    "text-primary-default": "#050609",
    "border-brand-subtle": "#85dbd5",
    "border-error-subtle": "#fca19b",
    "text-success-default-hover": "#085d3a",
    "border-primary-focused": "#050609",
    "background-warning-default-hover": "#fedf89",
    "background-error-default": "#fef5f5",
    "background-brand-solid-hover": "#117f78",
    "background-warning-solid-hover": "#dc6803",
    "background-warning-default": "#fff5ea",
    "background-brand-default-hover": "#aee8e4",
    "background-success-solid-hover": "#067647",
    "background-success-default": "#ebf6f1",
    "background-warning-solid": "#f79009",
    "text-success-default": "#069454",
    "background-secondary-solid": "#293142",
    "background-error-solid-hover": "#d92c20",
    "background-secondary-default": "#f5f5f5",
    "background-primary-solid": "#050609",
    "text-brand-default-hover": "#0c6460",
    "background-primary-hover": "#f5f5f5",
    "icon-primary-hover": "#293142",
    "border-success-default": "#069454",
    "background-error-solid": "#f04437",
    "icon-success-default": "#069454",
    "background-success-solid": "#069454",
    "text-primary-inverse": "#ffffff",
    "background-secondary-hover": "#e9eaeb",
    "background-primary-default-alternative": "#ffffff",
    "text-primary-disabled": "#a4a7ae",
    "background-success-default-hover": "#a9efc5",
    "background-brand-solid": "#159a92",
    "background-primary-default": "#ffffff",
    "background-warning-highlight": "#ffd452",
    "icon-tertiary-default": "#404a5f",
    "icon-disabled-default": "#d5d7da",
    "border-disabled-default": "#d5d7da",
    "background-primary-disabled": "#d5d7da",
    "icon-disabled-hover": "#404a5f",
    "background-info-highlight": "#d1e9ff",
    "text-primary-focus": "#717680",
    "background-error-focus": "#ff0808",
    "text-disabled-default": "#666666",
    "icon-warning-hover": "#facd15",
    "text-primary-alternative": "#050609",
    "background-info-alternative": "#d1e9ff",
    "border-success-hover": "#a9efc5",
    "border-info-hover": "#b2ddff",
    "text-heading-primary": "#101828",
    "border-secondary-default": "#d5d7da",
    "icon-info-subtle": "#175cd3",
    "text-heading-secondary": "#717680",
    "background-asset-purple-default": "#f3e8ff",
    "background-asset-purple-solid": "#a753f7",
    "text-asset-purple-default": "#a753f7",
    "background-info-default-hover-2": "#53b0fd",
    "background-success-focus": "#47cd89",
    "background-asset-purple-hover": "#dc88ff",
    "background-success-default-focus": "#dcfae6",
    "background-primary-focus": "#050609",
    "border-info-solid": "#112c5a",
    "icon-info-focus": "#194084",
    "icon-rate-default": "#ffd452",
    "background-primary-overlay": "#000000b2"
  },
  "dark": {
    "border-info-subtle": "#84caff",
    "border-info-default": "#156fee",
    "border-success-subtle": "#75dfa6",
    "border-warning-default": "#f79009",
    "background-info-solid": "#1849a9",
    "background-info-default-hover": "#252b37",
    "text-info-hover": "#d1e9ff",
    "text-info-default": "#1849a9",
    "border-error-default": "#f04437",
    "border-primary-default": "#666e7f",
    "border-brand-default": "#159a92",
    "icon-error-default": "#f04437",
    "icon-warning-default": "#f79009",
    "icon-brand-hover": "#0c6460",
    "background-info-default": "#112c5a",
    "icon-brand-default": "#159a92",
    "icon-secondary-default": "#666e7f",
    "background-brand-default": "#252b37",
    "text-error-default-hover": "#b42318",
    "text-error-default": "#f04437",
    "text-info-on-solid": "#1849a9",
    "icon-primary-inverse": "#ffffff",
    "background-error-default-hover": "#fecdca",
    "text-warning-default-hover": "#b54707",
    "icon-primary-default": "#f5f5f5",
    "text-warning-default": "#f79009",
    "text-brand-default": "#159a92",
    "text-tertiary-default": "#a4a7ae",
    "background-info-solid-hover": "#252b37",
    "text-secondary-inverse": "#ffffff",
    "border-warning-subtle": "#fec84b",
    "text-secondary-disabled": "#d5d7da",
    "icon-info-default": "#156fee",
    "text-secondary-default": "#f5f5f5",
    "text-primary-hover": "#293142",
    "text-secondary-hover": "#a4a7ae",
    "text-primary-default": "#ffffff",
    "border-brand-subtle": "#85dbd5",
    "border-error-subtle": "#fca19b",
    "text-success-default-hover": "#085d3a",
    "border-primary-focused": "#050609",
    "background-warning-default-hover": "#fedf89",
    "background-error-default": "#501911",
    "background-brand-solid-hover": "#117f78",
    "background-warning-solid-hover": "#dc6803",
    "background-warning-default": "#93370c",
    "background-brand-default-hover": "#aee8e4",
    "background-success-solid-hover": "#252b37",
    "background-success-default": "#053321",
    "background-warning-solid": "#f79009",
    "text-success-default": "#069454",
    "background-secondary-solid": "#050609",
    "background-error-solid-hover": "#d92c20",
    "background-secondary-default": "#404a5f",
    "background-primary-solid": "#f5f5f5",
    "text-brand-default-hover": "#0c6460",
    "background-primary-hover": "#293142",
    "icon-primary-hover": "#293142",
    "border-success-default": "#069454",
    "background-error-solid": "#f04437",
    "icon-success-default": "#069454",
    "background-success-solid": "#069454",
    "text-primary-inverse": "#ffffff",
    "background-secondary-hover": "#4f5663",
    "background-primary-default-alternative": "#252b37",
    "text-primary-disabled": "#a4a7ae",
    "background-success-default-hover": "#252b37",
    "background-brand-solid": "#159a92",
    "background-primary-default": "#181d27",
    "background-warning-highlight": "#ffd452",
    "icon-tertiary-default": "#ffffff",
    "icon-disabled-default": "#d5d7da",
    "border-disabled-default": "#d5d7da",
    "background-primary-disabled": "#404a5f",
    "icon-disabled-hover": "#d5d7da",
    "background-info-highlight": "#d1e9ff",
    "text-primary-focus": "#717680",
    "background-error-focus": "#ff0808",
    "text-disabled-default": "#e9eaeb",
    "icon-warning-hover": "#f79009",
    "text-primary-alternative": "#181d27",
    "background-info-alternative": "#252b37",
    "border-success-hover": "#a9efc5",
    "border-info-hover": "#84caff",
    "text-heading-primary": "#ffffff",
    "border-secondary-default": "#ffffff",
    "icon-info-subtle": "#175cd3",
    "text-heading-secondary": "#ffffff",
    "background-asset-purple-default": "#f3e8ff",
    "background-asset-purple-solid": "#a753f7",
    "text-asset-purple-default": "#ffffff",
    "background-info-default-hover-2": "#112c5a",
    "background-success-focus": "#252b37",
    "background-asset-purple-hover": "#cb77ff",
    "background-success-default-focus": "#252b37",
    "background-primary-focus": "#181d27",
    "border-info-solid": "#156fee",
    "icon-info-focus": "#194084",
    "icon-rate-default": "#ffd452",
    "background-primary-overlay": "#000000b2"
  }
}`,
    spacing: `{
  "spacing": {
    "xs": "4px",
    "sm": "8px",
    "md": "16px",
    "lg": "24px",
    "xl": "32px",
    "2xl": "48px",
    "3xl": "64px"
  },
  "borderRadius": {
    "sm": "4px",
    "md": "8px",
    "lg": "12px",
    "xl": "16px",
    "2xl": "24px",
    "full": "9999px"
  },
  "shadows": {
    "xs": "0 1px 2px rgba(0, 0, 0, 0.04)",
    "sm": "0 1px 3px rgba(0, 0, 0, 0.08)",
    "md": "0 4px 8px rgba(0, 0, 0, 0.06)",
    "lg": "0 8px 16px rgba(0, 0, 0, 0.04)",
    "xl": "0 16px 32px rgba(0, 0, 0, 0.08)",
    "2xl": "0 24px 48px rgba(0, 0, 0, 0.12)"
  }
}`,
    typography: `{
  "fontFamily": {
    "primary": "'Inter', sans-serif",
    "secondary": "'Outfit', sans-serif"
  },
  "fontSize": {
    "xs": "12px",
    "sm": "14px",
    "base": "16px",
    "lg": "18px",
    "xl": "20px",
    "2xl": "24px",
    "3xl": "30px"
  },
  "fontWeight": {
    "normal": 400,
    "medium": 500,
    "semibold": 600,
    "bold": 700
  }
}`,
    buttonComponent: `// Button Component
<button className="btn btn-primary">
  Primary Button
</button>

<button className="btn btn-secondary">
  Secondary Button
</button>

// CSS Classes
.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.2s;
}

.btn-primary {
  background: linear-gradient(to-r, #14b8a6, #0d9488);
  color: white;
}

.btn-secondary {
  background: linear-gradient(to-r, #3b82f6, #2563eb);
  color: white;
}`,
    cardComponent: `// Card Component
<div className="card">
  <div className="card-header">
    <h3>Card Title</h3>
  </div>
  <div className="card-body">
    Card content goes here
  </div>
</div>

// CSS Classes
.card {
  background: rgba(30, 41, 59, 0.5);
  border: 1px solid rgba(148, 163, 184, 0.1);
  border-radius: 12px;
  padding: 24px;
  backdrop-filter: blur(10px);
}`
  };

  return (
    <div className="space-y-8 max-w-7xl mx-auto">
      <div>
        <h2 className="text-3xl font-bold mb-2 text-white">
          Developer Handoff
        </h2>
        <p className="text-gray-400">Everything you need to implement the Momentum Design System</p>
      </div>

      {/* Design Tokens Section */}
      <div className="glass-card bg-opacity-50 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-2">
          <Box className="w-6 h-6 text-teal-400" />
          Design Tokens
        </h3>
        <p className="text-gray-400 mb-6">Core design values exported as JSON for easy integration</p>
        
        <div className="space-y-4">
          {/* Light Mode Colors */}
          <div className="bg-blue-900/30 rounded-lg overflow-hidden">
            <button 
              onClick={() => toggleSection('lightColors')}
              className="w-full flex justify-between items-center p-4 hover:bg-blue-900/40 transition-colors"
            >
              <div className="flex items-center gap-3">
                <ChevronRight className={`w-5 h-5 text-teal-400 transition-transform ${expandedSections.lightColors ? 'rotate-90' : ''}`} />
                <div className="text-left">
                  <h4 className="text-white font-semibold text-lg">Color Palette - Light Mode</h4>
                  <p className="text-gray-400 text-sm">All semantic colors for light theme</p>
                </div>
              </div>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  copyToClipboard(JSON.stringify(JSON.parse(tokens.colors).light, null, 2), 'lightColors');
                }} 
                className="px-4 py-2 bg-teal-500/20 text-teal-400 hover:bg-teal-500/30 rounded-lg text-sm transition-colors"
              >
                {copiedItem === 'lightColors' ? '✓ Copied!' : 'Copy JSON'}
              </button>
            </button>
            {expandedSections.lightColors && (
              <div className="p-4 pt-0">
                <pre className="text-gray-300 text-xs overflow-x-auto bg-gray-900/50 p-4 rounded max-h-96 overflow-y-auto"><code>{JSON.stringify(JSON.parse(tokens.colors).light, null, 2)}</code></pre>
              </div>
            )}
          </div>

          {/* Dark Mode Colors */}
          <div className="bg-blue-900/30 rounded-lg overflow-hidden">
            <button 
              onClick={() => toggleSection('darkColors')}
              className="w-full flex justify-between items-center p-4 hover:bg-blue-900/40 transition-colors"
            >
              <div className="flex items-center gap-3">
                <ChevronRight className={`w-5 h-5 text-teal-400 transition-transform ${expandedSections.darkColors ? 'rotate-90' : ''}`} />
                <div className="text-left">
                  <h4 className="text-white font-semibold text-lg">Color Palette - Dark Mode</h4>
                  <p className="text-gray-400 text-sm">All semantic colors for dark theme</p>
                </div>
              </div>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  copyToClipboard(JSON.stringify(JSON.parse(tokens.colors).dark, null, 2), 'darkColors');
                }} 
                className="px-4 py-2 bg-teal-500/20 text-teal-400 hover:bg-teal-500/30 rounded-lg text-sm transition-colors"
              >
                {copiedItem === 'darkColors' ? '✓ Copied!' : 'Copy JSON'}
              </button>
            </button>
            {expandedSections.darkColors && (
              <div className="p-4 pt-0">
                <pre className="text-gray-300 text-xs overflow-x-auto bg-gray-900/50 p-4 rounded max-h-96 overflow-y-auto"><code>{JSON.stringify(JSON.parse(tokens.colors).dark, null, 2)}</code></pre>
              </div>
            )}
          </div>

          {/* Spacing */}
          <div className="bg-blue-900/30 rounded-lg p-4">
            <div className="flex justify-between items-center mb-3">
              <div>
                <h4 className="text-white font-semibold text-lg">Spacing & Layout</h4>
                <p className="text-gray-400 text-sm">Consistent spacing scale and border radius</p>
              </div>
              <button onClick={() => copyToClipboard(tokens.spacing, 'spacing')} className="px-4 py-2 bg-teal-500/20 text-teal-400 hover:bg-teal-500/30 rounded-lg text-sm transition-colors">
                {copiedItem === 'spacing' ? '✓ Copied!' : 'Copy JSON'}
              </button>
            </div>
            <pre className="text-gray-300 text-xs overflow-x-auto bg-gray-900/50 p-4 rounded"><code>{tokens.spacing}</code></pre>
          </div>

          {/* Typography */}
          <div className="bg-blue-900/30 rounded-lg p-4">
            <div className="flex justify-between items-center mb-3">
              <div>
                <h4 className="text-white font-semibold text-lg">Typography</h4>
                <p className="text-gray-400 text-sm">Font families, sizes, and weights</p>
              </div>
              <button onClick={() => copyToClipboard(tokens.typography, 'typography')} className="px-4 py-2 bg-teal-500/20 text-teal-400 hover:bg-teal-500/30 rounded-lg text-sm transition-colors">
                {copiedItem === 'typography' ? '✓ Copied!' : 'Copy JSON'}
              </button>
            </div>
            <pre className="text-gray-300 text-xs overflow-x-auto bg-gray-900/50 p-4 rounded"><code>{tokens.typography}</code></pre>
          </div>
        </div>
      </div>

      {/* Component Code Examples */}
      <div className="glass-card bg-opacity-50 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-2">
          <Layers className="w-6 h-6 text-teal-400" />
          Component Code Examples
        </h3>
        <p className="text-gray-400 mb-6">Ready-to-use code snippets for common components</p>
        
        <div className="space-y-4">
          {/* Button Component */}
          <div className="bg-blue-900/30 rounded-lg p-4">
            <div className="flex justify-between items-center mb-3">
              <div>
                <h4 className="text-white font-semibold text-lg">Button Component</h4>
                <p className="text-gray-400 text-sm">Primary and secondary button styles</p>
              </div>
              <button onClick={() => copyToClipboard(tokens.buttonComponent, 'button')} className="px-4 py-2 bg-teal-500/20 text-teal-400 hover:bg-teal-500/30 rounded-lg text-sm transition-colors">
                {copiedItem === 'button' ? '✓ Copied!' : 'Copy Code'}
              </button>
            </div>
            <pre className="text-gray-300 text-xs overflow-x-auto bg-gray-900/50 p-4 rounded"><code>{tokens.buttonComponent}</code></pre>
          </div>

          {/* Card Component */}
          <div className="bg-blue-900/30 rounded-lg p-4">
            <div className="flex justify-between items-center mb-3">
              <div>
                <h4 className="text-white font-semibold text-lg">Card Component</h4>
                <p className="text-gray-400 text-sm">Glass-morphism card with blur effect</p>
              </div>
              <button onClick={() => copyToClipboard(tokens.cardComponent, 'card')} className="px-4 py-2 bg-teal-500/20 text-teal-400 hover:bg-teal-500/30 rounded-lg text-sm transition-colors">
                {copiedItem === 'card' ? '✓ Copied!' : 'Copy Code'}
              </button>
            </div>
            <pre className="text-gray-300 text-xs overflow-x-auto bg-gray-900/50 p-4 rounded"><code>{tokens.cardComponent}</code></pre>
          </div>
        </div>
      </div>

      {/* Implementation Guide */}
      <div className="glass-card bg-opacity-50 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-2xl font-bold text-white mb-4">Implementation Guide</h3>
        <p className="text-gray-400 mb-6">Step-by-step instructions for integrating the design system</p>
        
        <div className="space-y-6">
          <div className="flex gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-500/20 text-teal-400 flex items-center justify-center font-bold">1</div>
            <div>
              <h4 className="text-white font-semibold mb-2">Import Design Tokens</h4>
              <p className="text-gray-400 text-sm">Copy the JSON tokens and import them into your project as CSS variables or JavaScript constants</p>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-500/20 text-teal-400 flex items-center justify-center font-bold">2</div>
            <div>
              <h4 className="text-white font-semibold mb-2">Use Component Classes</h4>
              <p className="text-gray-400 text-sm">Apply the predefined CSS classes to maintain consistency across your application</p>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-500/20 text-teal-400 flex items-center justify-center font-bold">3</div>
            <div>
              <h4 className="text-white font-semibold mb-2">Follow Accessibility Guidelines</h4>
              <p className="text-gray-400 text-sm">Ensure all components meet WCAG 2.1 AA standards for contrast ratios and keyboard navigation</p>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-500/20 text-teal-400 flex items-center justify-center font-bold">4</div>
            <div>
              <h4 className="text-white font-semibold mb-2">Test Responsiveness</h4>
              <p className="text-gray-400 text-sm">Components are designed to work across mobile, tablet, and desktop breakpoints</p>
            </div>
          </div>
        </div>
      </div>

      {/* Assets & Resources */}
      <div className="glass-card bg-opacity-50 bg-blue-950 rounded-xl p-6 border border-blue-900/30">
        <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-2">
          <BookOpen className="w-6 h-6 text-teal-400" />
          Assets & Resources
        </h3>
        
        <div className="grid md:grid-cols-2 gap-4">
          <div className="bg-blue-900/30 rounded-lg p-4">
            <h4 className="text-white font-semibold mb-2">Icons</h4>
            <p className="text-gray-400 text-sm mb-3">Using Lucide React icon library</p>
            <code className="text-teal-400 text-xs">npm install lucide-react</code>
          </div>

          <div className="bg-blue-900/30 rounded-lg p-4">
            <h4 className="text-white font-semibold mb-2">Fonts</h4>
            <p className="text-gray-400 text-sm mb-3">Inter & Outfit from Google Fonts</p>
            <code className="text-teal-400 text-xs">@import url('fonts.googleapis.com')</code>
          </div>
        </div>
      </div>
    </div>
  );
}

function TeamPage({ editMode, setEditMode, teamMembers, setTeamMembers }) {
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState('');

  // Load team members from Firebase on mount
    const loadTeamFromFirebase = useCallback(async () => {
        if (!db) return;

        try {
            setLoading(true);

            const querySnapshot = await getDocs(collection(db, 'teamMembers'));

            const members = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));

            members.sort((a, b) => (a.order || a.id) - (b.order || b.id));

            setTeamMembers(members);
        } catch (error) {
            console.error('Error loading team:', error);
        } finally {
            setLoading(false);
        }
    }, [setTeamMembers]);





  const saveTeamToFirebase = async () => {
    try {
      setSaveStatus('saving');
      
      if (!db) {
        setSaveStatus('error');
        return;
      }
      
      for (let i = 0; i < teamMembers.length; i++) {
        const member = teamMembers[i];
        await setDoc(doc(db, 'teamMembers', String(member.id)), {
          name: member.name,
          role: member.role,
          image: member.image || null,
          linkedin: member.linkedin || '',
          badge: member.badge || null,
          order: i + 1
        });
      }
      setSaveStatus('saved');
      setTimeout(() => setSaveStatus(''), 2000);
    } catch (error) {
      console.error('Error saving team:', error);
      setSaveStatus('error');
    }
  };

  const addNewMember = () => {
    const newId = Math.max(...teamMembers.map(m => Number(m.id) || 0)) + 1;
    setTeamMembers(prev => [...prev, {
      id: newId,
      name: 'New Member',
      role: 'UI/UX Designer',
      image: null,
      linkedin: ''
    }]);
  };

const deleteMember = async (memberId) => {
  if (!window.confirm('Are you sure you want to delete this member?')) return;

  try {
    await deleteDoc(doc(db, 'teamMembers', String(memberId)));

    setTeamMembers(prev =>
      prev.filter(member => member.id !== memberId)
    );
  } catch (error) {
    console.error('Error deleting member:', error);
  }
};


  const handleNameChange = (memberId, value) => {
    setTeamMembers(prev => 
      prev.map(member => 
        member.id === memberId 
          ? { ...member, name: value }
          : member
      )
    );
  };

  const handleImageUpload = (memberId, event) => {
    const file = event.target.files[0];
    if (file) {
      // Compress image before saving
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const maxSize = 150;
          let width = img.width;
          let height = img.height;
          
          if (width > height && width > maxSize) {
            height = (height * maxSize) / width;
            width = maxSize;
          } else if (height > maxSize) {
            width = (width * maxSize) / height;
            height = maxSize;
          }
          
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          
          const compressedImage = canvas.toDataURL('image/jpeg', 0.6);
          setTeamMembers(prev => 
            prev.map(member => 
              member.id === memberId 
                ? { ...member, image: compressedImage }
                : member
            )
          );
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const handleLinkedInChange = (memberId, value) => {
    setTeamMembers(prev => 
      prev.map(member => 
        member.id === memberId 
          ? { ...member, linkedin: value }
          : member
      )
    );
  };

  const getInitials = (name) => {
    const parts = name.split(' ');
    return parts.map(part => part[0]).join('').toUpperCase().slice(0, 2);
  };

  const getGradientByIndex = (index) => {
    const gradients = [
      'from-teal-500 via-cyan-500 to-blue-500',
      'from-blue-500 via-indigo-500 to-purple-500',
      'from-purple-500 via-fuchsia-500 to-pink-500',
      'from-pink-500 via-rose-500 to-red-500',
      'from-orange-500 via-amber-500 to-yellow-500',
      'from-green-500 via-emerald-500 to-teal-500',
      'from-cyan-500 via-sky-500 to-blue-500',
      'from-indigo-500 via-violet-500 to-purple-500',
      'from-fuchsia-500 via-pink-500 to-rose-500',
      'from-amber-500 via-orange-500 to-red-500',
    ];
    return gradients[index % gradients.length];
  };

  return (
    <div className="space-y-8 max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold mb-2 bg-gradient-to-r from-teal-400 to-blue-400 bg-clip-text text-transparent">
            Team Behind the Core
          </h2>
          <p className="text-gray-400">
            Get to know the talented designers who created this design system.
          </p>
        </div>
        {editMode && (
          <div className="flex gap-2">
            <button
              onClick={addNewMember}
              className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg hover:opacity-90 transition-opacity btn-scale"
            >
              <Plus className="w-4 h-4 icon-rotate" />
              Add Member
            </button>
            <button
              onClick={saveTeamToFirebase}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all btn-scale ${
                saveStatus === 'saved' 
                  ? 'bg-green-600 text-white' 
                  : saveStatus === 'saving'
                  ? 'bg-yellow-600 text-white'
                  : 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white hover:opacity-90'
              }`}
              disabled={saveStatus === 'saving'}
            >
              {saveStatus === 'saving' ? 'Saving...' : saveStatus === 'saved' ? '✓ Saved!' : 'Save to Cloud'}
            </button>
          </div>
        )}
      </div>

      {loading && (
        <div className="text-center py-8">
          <div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
          <p className="text-gray-400 mt-2">Loading team members...</p>
        </div>
      )}

      {/* Two Equal Rows Layout */}
      <div className="space-y-4">
        <div className="grid grid-cols-5 gap-4">
          {teamMembers.slice(0, 5).map((member, index) => (
            <div key={member.id} className="relative group stagger-item team-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className={`team-card-border relative overflow-hidden rounded-xl p-[2px] bg-gradient-to-br ${getGradientByIndex(index)} transition-all`}>
                <div className="relative bg-gradient-to-b from-blue-950 to-indigo-950 rounded-lg p-4">
                  {member.badge && (
                    <div className="absolute -top-1 -right-1 bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full z-10">
                      ⭐
                    </div>
                  )}
                  <div className="flex flex-col items-center">
                    <div className="relative mb-3">
                      {member.image ? (
                        <img src={member.image} alt={member.name} className="w-24 h-24 rounded-full object-cover ring-2 ring-white/10" />
                      ) : (
                        <div className={`w-24 h-24 rounded-full bg-gradient-to-br ${getGradientByIndex(index)} flex items-center justify-center ring-2 ring-white/10`}>
                          <span className="text-2xl font-bold text-white">{getInitials(member.name)}</span>
                        </div>
                      )}
                    </div>
                    <h3 className="text-sm font-bold text-center mb-0.5">{member.name}</h3>
                    <p className={`text-xs font-medium bg-gradient-to-r ${getGradientByIndex(index)} bg-clip-text text-transparent mb-2`}>{member.role}</p>
                    {member.linkedin && !editMode && (
                      <a 
                        href={member.linkedin} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="p-1.5 rounded-full bg-blue-600/20 hover:bg-blue-600/40 transition-colors inline-block"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                      </a>
                    )}
                  </div>
                  {editMode && (
                    <div className="absolute inset-0 bg-blue-950/95 backdrop-blur-sm rounded-lg flex flex-col items-center justify-center gap-2 p-3">
                      <button
                        onClick={() => deleteMember(member.id)}
                        className="absolute top-1 right-1 p-1 bg-red-500/20 hover:bg-red-500/40 rounded-full transition-colors"
                      >
                        <Trash2 className="w-3 h-3 text-red-400" />
                      </button>
                      <label className="cursor-pointer">
                        <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${getGradientByIndex(index)} flex items-center justify-center hover:scale-110 transition-transform`}>
                          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                        </div>
                        <input type="file" accept="image/*" className="hidden" onChange={(e) => handleImageUpload(member.id, e)} />
                      </label>
                      <input type="text" value={member.name} onChange={(e) => handleNameChange(member.id, e.target.value)} placeholder="Name" className="w-full bg-blue-900/30 border border-blue-800/50 rounded px-2 py-1 text-xs text-white placeholder-gray-500 focus:border-teal-500 focus:outline-none text-center" />
                      <input type="url" value={member.linkedin || ''} onChange={(e) => handleLinkedInChange(member.id, e.target.value)} placeholder="LinkedIn URL" className="w-full bg-blue-900/30 border border-blue-800/50 rounded px-2 py-1 text-xs text-white placeholder-gray-500 focus:border-teal-500 focus:outline-none" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-5 gap-4">
          {teamMembers.slice(5, 10).map((member, index) => (
            <div key={member.id} className="relative group stagger-item team-card" style={{ animationDelay: `${(index + 5) * 0.1}s` }}>
              <div className={`team-card-border relative overflow-hidden rounded-xl p-[2px] bg-gradient-to-br ${getGradientByIndex(index + 5)} transition-all`}>
                <div className="relative bg-gradient-to-b from-blue-950 to-indigo-950 rounded-lg p-4">
                  {member.badge && (
                    <div className="absolute -top-1 -right-1 bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full z-10">
                      ⭐
                    </div>
                  )}
                  <div className="flex flex-col items-center">
                    <div className="relative mb-3">
                      {member.image ? (
                        <img src={member.image} alt={member.name} className="w-24 h-24 rounded-full object-cover ring-2 ring-white/10" />
                      ) : (
                        <div className={`w-24 h-24 rounded-full bg-gradient-to-br ${getGradientByIndex(index + 5)} flex items-center justify-center ring-2 ring-white/10`}>
                          <span className="text-2xl font-bold text-white">{getInitials(member.name)}</span>
                        </div>
                      )}
                    </div>
                    <h3 className="text-sm font-bold text-center mb-0.5">{member.name}</h3>
                    <p className={`text-xs font-medium bg-gradient-to-r ${getGradientByIndex(index + 5)} bg-clip-text text-transparent mb-2`}>{member.role}</p>
                    {member.linkedin && !editMode && (
                      <a 
                        href={member.linkedin} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="p-1.5 rounded-full bg-blue-600/20 hover:bg-blue-600/40 transition-colors inline-block"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                      </a>
                    )}
                  </div>
                  {editMode && (
                    <div className="absolute inset-0 bg-blue-950/95 backdrop-blur-sm rounded-lg flex flex-col items-center justify-center gap-2 p-3">
                      <button
                        onClick={() => deleteMember(member.id)}
                        className="absolute top-1 right-1 p-1 bg-red-500/20 hover:bg-red-500/40 rounded-full transition-colors"
                      >
                        <Trash2 className="w-3 h-3 text-red-400" />
                      </button>
                      <label className="cursor-pointer">
                        <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${getGradientByIndex(index + 5)} flex items-center justify-center hover:scale-110 transition-transform`}>
                          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                        </div>
                        <input type="file" accept="image/*" className="hidden" onChange={(e) => handleImageUpload(member.id, e)} />
                      </label>
                      <input type="text" value={member.name} onChange={(e) => handleNameChange(member.id, e.target.value)} placeholder="Name" className="w-full bg-blue-900/30 border border-blue-800/50 rounded px-2 py-1 text-xs text-white placeholder-gray-500 focus:border-teal-500 focus:outline-none text-center" />
                      <input type="url" value={member.linkedin || ''} onChange={(e) => handleLinkedInChange(member.id, e.target.value)} placeholder="LinkedIn URL" className="w-full bg-blue-900/30 border border-blue-800/50 rounded px-2 py-1 text-xs text-white placeholder-gray-500 focus:border-teal-500 focus:outline-none" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Fun Stats */}
      <div className="grid md:grid-cols-3 gap-6 mt-12">
        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-xl blur opacity-25 group-hover:opacity-40 transition-opacity"></div>
          <div className="relative glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30 text-center">
            <div className="text-5xl font-bold bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent mb-2">
              {teamMembers.length}
            </div>
            <p className="text-gray-400 font-medium">Talented Designers</p>
          </div>
        </div>
        
        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl blur opacity-25 group-hover:opacity-40 transition-opacity"></div>
          <div className="relative glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30 text-center">
            <div className="text-5xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-2">
              100%
            </div>
            <p className="text-gray-400 font-medium">Dedication</p>
          </div>
        </div>
        
        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-red-500 rounded-xl blur opacity-25 group-hover:opacity-40 transition-opacity"></div>
          <div className="relative glass-card bg-opacity-70 bg-blue-950 rounded-xl p-6 border border-blue-900/30 text-center">
            <div className="text-5xl font-bold bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text text-transparent mb-2">
              ∞
            </div>
            <p className="text-gray-400 font-medium">Creativity</p>
          </div>
        </div>
      </div>
    </div>
  );
}
